/**
 * This is an Auto-generated file, any changes made to this file will not be preserved after build.
 * Please see the README.md file for instructions on how this process works.
 * */
import { createLanguageEnum } from '../typescript/NonReact/Languages/LanguageResourcing'
import { NamedEnumLike } from '../typescript/NonReact/Languages/LanguageTypes'

import ACDCodesLanguageDE_DE from './de_DE/ACDCodesLanguage.json'
import ACDCodesLanguageEN_GB from './en_GB/ACDCodesLanguage.json'
import ACDCodesLanguageEN_US from './en_US/ACDCodesLanguage.json'
import ACDCodesLanguageFR_FR from './fr_FR/ACDCodesLanguage.json'
import ACDCodesLanguageIT_IT from './it_IT/ACDCodesLanguage.json'
import ACDCodesLanguageNL_NL from './nl_NL/ACDCodesLanguage.json'
import ACDCodesLanguagePT_PT from './pt_PT/ACDCodesLanguage.json'

import ACDDNDActivityDE_DE from './de_DE/ACDDNDActivity.json'
import ACDDNDActivityEN_GB from './en_GB/ACDDNDActivity.json'
import ACDDNDActivityEN_US from './en_US/ACDDNDActivity.json'
import ACDDNDActivityFR_FR from './fr_FR/ACDDNDActivity.json'
import ACDDNDActivityIT_IT from './it_IT/ACDDNDActivity.json'
import ACDDNDActivityNL_NL from './nl_NL/ACDDNDActivity.json'
import ACDDNDActivityPT_PT from './pt_PT/ACDDNDActivity.json'

import ACDStateThresholdsDE_DE from './de_DE/ACDStateThresholds.json'
import ACDStateThresholdsEN_GB from './en_GB/ACDStateThresholds.json'
import ACDStateThresholdsEN_US from './en_US/ACDStateThresholds.json'
import ACDStateThresholdsFR_FR from './fr_FR/ACDStateThresholds.json'
import ACDStateThresholdsIT_IT from './it_IT/ACDStateThresholds.json'
import ACDStateThresholdsNL_NL from './nl_NL/ACDStateThresholds.json'
import ACDStateThresholdsPT_PT from './pt_PT/ACDStateThresholds.json'

import ACDStatusHotKeysDE_DE from './de_DE/ACDStatusHotKeys.json'
import ACDStatusHotKeysEN_GB from './en_GB/ACDStatusHotKeys.json'
import ACDStatusHotKeysEN_US from './en_US/ACDStatusHotKeys.json'
import ACDStatusHotKeysFR_FR from './fr_FR/ACDStatusHotKeys.json'
import ACDStatusHotKeysIT_IT from './it_IT/ACDStatusHotKeys.json'
import ACDStatusHotKeysNL_NL from './nl_NL/ACDStatusHotKeys.json'
import ACDStatusHotKeysPT_PT from './pt_PT/ACDStatusHotKeys.json'

import AbandonedCallAlarmDE_DE from './de_DE/AbandonedCallAlarm.json'
import AbandonedCallAlarmEN_GB from './en_GB/AbandonedCallAlarm.json'
import AbandonedCallAlarmEN_US from './en_US/AbandonedCallAlarm.json'
import AbandonedCallAlarmFR_FR from './fr_FR/AbandonedCallAlarm.json'
import AbandonedCallAlarmIT_IT from './it_IT/AbandonedCallAlarm.json'
import AbandonedCallAlarmNL_NL from './nl_NL/AbandonedCallAlarm.json'
import AbandonedCallAlarmPT_PT from './pt_PT/AbandonedCallAlarm.json'

import AbandonedTimeStatisticLanguageDE_DE from './de_DE/AbandonedTimeStatisticLanguage.json'
import AbandonedTimeStatisticLanguageEN_GB from './en_GB/AbandonedTimeStatisticLanguage.json'
import AbandonedTimeStatisticLanguageEN_US from './en_US/AbandonedTimeStatisticLanguage.json'
import AbandonedTimeStatisticLanguageFR_FR from './fr_FR/AbandonedTimeStatisticLanguage.json'
import AbandonedTimeStatisticLanguageIT_IT from './it_IT/AbandonedTimeStatisticLanguage.json'
import AbandonedTimeStatisticLanguageNL_NL from './nl_NL/AbandonedTimeStatisticLanguage.json'
import AbandonedTimeStatisticLanguagePT_PT from './pt_PT/AbandonedTimeStatisticLanguage.json'

import AddUserLanguageDE_DE from './de_DE/AddUserLanguage.json'
import AddUserLanguageEN_GB from './en_GB/AddUserLanguage.json'
import AddUserLanguageEN_US from './en_US/AddUserLanguage.json'
import AddUserLanguageFR_FR from './fr_FR/AddUserLanguage.json'
import AddUserLanguageIT_IT from './it_IT/AddUserLanguage.json'
import AddUserLanguageNL_NL from './nl_NL/AddUserLanguage.json'
import AddUserLanguagePT_PT from './pt_PT/AddUserLanguage.json'

import AdminActionsLanguageDE_DE from './de_DE/AdminActionsLanguage.json'
import AdminActionsLanguageEN_GB from './en_GB/AdminActionsLanguage.json'
import AdminActionsLanguageEN_US from './en_US/AdminActionsLanguage.json'
import AdminActionsLanguageFR_FR from './fr_FR/AdminActionsLanguage.json'
import AdminActionsLanguageIT_IT from './it_IT/AdminActionsLanguage.json'
import AdminActionsLanguageNL_NL from './nl_NL/AdminActionsLanguage.json'
import AdminActionsLanguagePT_PT from './pt_PT/AdminActionsLanguage.json'

import AdminOverviewLanguageDE_DE from './de_DE/AdminOverviewLanguage.json'
import AdminOverviewLanguageEN_GB from './en_GB/AdminOverviewLanguage.json'
import AdminOverviewLanguageEN_US from './en_US/AdminOverviewLanguage.json'
import AdminOverviewLanguageFR_FR from './fr_FR/AdminOverviewLanguage.json'
import AdminOverviewLanguageIT_IT from './it_IT/AdminOverviewLanguage.json'
import AdminOverviewLanguageNL_NL from './nl_NL/AdminOverviewLanguage.json'
import AdminOverviewLanguagePT_PT from './pt_PT/AdminOverviewLanguage.json'

import AdministratorLanguageDE_DE from './de_DE/AdministratorLanguage.json'
import AdministratorLanguageEN_GB from './en_GB/AdministratorLanguage.json'
import AdministratorLanguageEN_US from './en_US/AdministratorLanguage.json'
import AdministratorLanguageFR_FR from './fr_FR/AdministratorLanguage.json'
import AdministratorLanguageIT_IT from './it_IT/AdministratorLanguage.json'
import AdministratorLanguageNL_NL from './nl_NL/AdministratorLanguage.json'
import AdministratorLanguagePT_PT from './pt_PT/AdministratorLanguage.json'

import AdvancedDE_DE from './de_DE/Advanced.json'
import AdvancedEN_GB from './en_GB/Advanced.json'
import AdvancedEN_US from './en_US/Advanced.json'
import AdvancedFR_FR from './fr_FR/Advanced.json'
import AdvancedIT_IT from './it_IT/Advanced.json'
import AdvancedNL_NL from './nl_NL/Advanced.json'
import AdvancedPT_PT from './pt_PT/Advanced.json'

import AgentAdvancedDE_DE from './de_DE/AgentAdvanced.json'
import AgentAdvancedEN_GB from './en_GB/AgentAdvanced.json'
import AgentAdvancedEN_US from './en_US/AgentAdvanced.json'
import AgentAdvancedFR_FR from './fr_FR/AgentAdvanced.json'
import AgentAdvancedIT_IT from './it_IT/AgentAdvanced.json'
import AgentAdvancedNL_NL from './nl_NL/AgentAdvanced.json'
import AgentAdvancedPT_PT from './pt_PT/AgentAdvanced.json'

import AgentDetailsDE_DE from './de_DE/AgentDetails.json'
import AgentDetailsEN_GB from './en_GB/AgentDetails.json'
import AgentDetailsEN_US from './en_US/AgentDetails.json'
import AgentDetailsFR_FR from './fr_FR/AgentDetails.json'
import AgentDetailsIT_IT from './it_IT/AgentDetails.json'
import AgentDetailsNL_NL from './nl_NL/AgentDetails.json'
import AgentDetailsPT_PT from './pt_PT/AgentDetails.json'

import AgentListLanguageDE_DE from './de_DE/AgentListLanguage.json'
import AgentListLanguageEN_GB from './en_GB/AgentListLanguage.json'
import AgentListLanguageEN_US from './en_US/AgentListLanguage.json'
import AgentListLanguageFR_FR from './fr_FR/AgentListLanguage.json'
import AgentListLanguageIT_IT from './it_IT/AgentListLanguage.json'
import AgentListLanguageNL_NL from './nl_NL/AgentListLanguage.json'
import AgentListLanguagePT_PT from './pt_PT/AgentListLanguage.json'

import AgentOmnichannelDE_DE from './de_DE/AgentOmnichannel.json'
import AgentOmnichannelEN_GB from './en_GB/AgentOmnichannel.json'
import AgentOmnichannelEN_US from './en_US/AgentOmnichannel.json'
import AgentOmnichannelFR_FR from './fr_FR/AgentOmnichannel.json'
import AgentOmnichannelIT_IT from './it_IT/AgentOmnichannel.json'
import AgentOmnichannelNL_NL from './nl_NL/AgentOmnichannel.json'
import AgentOmnichannelPT_PT from './pt_PT/AgentOmnichannel.json'

import AlarmActionsDE_DE from './de_DE/AlarmActions.json'
import AlarmActionsEN_GB from './en_GB/AlarmActions.json'
import AlarmActionsEN_US from './en_US/AlarmActions.json'
import AlarmActionsFR_FR from './fr_FR/AlarmActions.json'
import AlarmActionsIT_IT from './it_IT/AlarmActions.json'
import AlarmActionsNL_NL from './nl_NL/AlarmActions.json'
import AlarmActionsPT_PT from './pt_PT/AlarmActions.json'

import AnswerPerformanceDE_DE from './de_DE/AnswerPerformance.json'
import AnswerPerformanceEN_GB from './en_GB/AnswerPerformance.json'
import AnswerPerformanceEN_US from './en_US/AnswerPerformance.json'
import AnswerPerformanceFR_FR from './fr_FR/AnswerPerformance.json'
import AnswerPerformanceIT_IT from './it_IT/AnswerPerformance.json'
import AnswerPerformanceNL_NL from './nl_NL/AnswerPerformance.json'
import AnswerPerformancePT_PT from './pt_PT/AnswerPerformance.json'

import ApiKeysDE_DE from './de_DE/ApiKeys.json'
import ApiKeysEN_GB from './en_GB/ApiKeys.json'
import ApiKeysEN_US from './en_US/ApiKeys.json'
import ApiKeysFR_FR from './fr_FR/ApiKeys.json'
import ApiKeysIT_IT from './it_IT/ApiKeys.json'
import ApiKeysNL_NL from './nl_NL/ApiKeys.json'
import ApiKeysPT_PT from './pt_PT/ApiKeys.json'

import AppMenuDE_DE from './de_DE/AppMenu.json'
import AppMenuEN_GB from './en_GB/AppMenu.json'
import AppMenuEN_US from './en_US/AppMenu.json'
import AppMenuFR_FR from './fr_FR/AppMenu.json'
import AppMenuIT_IT from './it_IT/AppMenu.json'
import AppMenuNL_NL from './nl_NL/AppMenu.json'
import AppMenuPT_PT from './pt_PT/AppMenu.json'

import AuditDE_DE from './de_DE/Audit.json'
import AuditEN_GB from './en_GB/Audit.json'
import AuditEN_US from './en_US/Audit.json'
import AuditFR_FR from './fr_FR/Audit.json'
import AuditIT_IT from './it_IT/Audit.json'
import AuditNL_NL from './nl_NL/Audit.json'
import AuditPT_PT from './pt_PT/Audit.json'

import AuthenticationDE_DE from './de_DE/Authentication.json'
import AuthenticationEN_GB from './en_GB/Authentication.json'
import AuthenticationEN_US from './en_US/Authentication.json'
import AuthenticationFR_FR from './fr_FR/Authentication.json'
import AuthenticationIT_IT from './it_IT/Authentication.json'
import AuthenticationNL_NL from './nl_NL/Authentication.json'
import AuthenticationPT_PT from './pt_PT/Authentication.json'

import BrandingLanguageDE_DE from './de_DE/BrandingLanguage.json'
import BrandingLanguageEN_GB from './en_GB/BrandingLanguage.json'
import BrandingLanguageEN_US from './en_US/BrandingLanguage.json'
import BrandingLanguageFR_FR from './fr_FR/BrandingLanguage.json'
import BrandingLanguageIT_IT from './it_IT/BrandingLanguage.json'
import BrandingLanguageNL_NL from './nl_NL/BrandingLanguage.json'
import BrandingLanguagePT_PT from './pt_PT/BrandingLanguage.json'

import BroadworksSSODE_DE from './de_DE/BroadworksSSO.json'
import BroadworksSSOEN_GB from './en_GB/BroadworksSSO.json'
import BroadworksSSOEN_US from './en_US/BroadworksSSO.json'
import BroadworksSSOFR_FR from './fr_FR/BroadworksSSO.json'
import BroadworksSSOIT_IT from './it_IT/BroadworksSSO.json'
import BroadworksSSONL_NL from './nl_NL/BroadworksSSO.json'
import BroadworksSSOPT_PT from './pt_PT/BroadworksSSO.json'

import CMECapabilitiesDE_DE from './de_DE/CMECapabilities.json'
import CMECapabilitiesEN_GB from './en_GB/CMECapabilities.json'
import CMECapabilitiesEN_US from './en_US/CMECapabilities.json'
import CMECapabilitiesFR_FR from './fr_FR/CMECapabilities.json'
import CMECapabilitiesIT_IT from './it_IT/CMECapabilities.json'
import CMECapabilitiesNL_NL from './nl_NL/CMECapabilities.json'
import CMECapabilitiesPT_PT from './pt_PT/CMECapabilities.json'

import CMEDetailsDE_DE from './de_DE/CMEDetails.json'
import CMEDetailsEN_GB from './en_GB/CMEDetails.json'
import CMEDetailsEN_US from './en_US/CMEDetails.json'
import CMEDetailsFR_FR from './fr_FR/CMEDetails.json'
import CMEDetailsIT_IT from './it_IT/CMEDetails.json'
import CMEDetailsNL_NL from './nl_NL/CMEDetails.json'
import CMEDetailsPT_PT from './pt_PT/CMEDetails.json'

import CRMConfigurationLanguageDE_DE from './de_DE/CRMConfigurationLanguage.json'
import CRMConfigurationLanguageEN_GB from './en_GB/CRMConfigurationLanguage.json'
import CRMConfigurationLanguageEN_US from './en_US/CRMConfigurationLanguage.json'
import CRMConfigurationLanguageFR_FR from './fr_FR/CRMConfigurationLanguage.json'
import CRMConfigurationLanguageIT_IT from './it_IT/CRMConfigurationLanguage.json'
import CRMConfigurationLanguageNL_NL from './nl_NL/CRMConfigurationLanguage.json'
import CRMConfigurationLanguagePT_PT from './pt_PT/CRMConfigurationLanguage.json'

import CRMModalDE_DE from './de_DE/CRMModal.json'
import CRMModalEN_GB from './en_GB/CRMModal.json'
import CRMModalEN_US from './en_US/CRMModal.json'
import CRMModalFR_FR from './fr_FR/CRMModal.json'
import CRMModalIT_IT from './it_IT/CRMModal.json'
import CRMModalNL_NL from './nl_NL/CRMModal.json'
import CRMModalPT_PT from './pt_PT/CRMModal.json'

import CSVExportFormatDE_DE from './de_DE/CSVExportFormat.json'
import CSVExportFormatEN_GB from './en_GB/CSVExportFormat.json'
import CSVExportFormatEN_US from './en_US/CSVExportFormat.json'
import CSVExportFormatFR_FR from './fr_FR/CSVExportFormat.json'
import CSVExportFormatIT_IT from './it_IT/CSVExportFormat.json'
import CSVExportFormatNL_NL from './nl_NL/CSVExportFormat.json'
import CSVExportFormatPT_PT from './pt_PT/CSVExportFormat.json'

import CXRecordLanguageDE_DE from './de_DE/CXRecordLanguage.json'
import CXRecordLanguageEN_GB from './en_GB/CXRecordLanguage.json'
import CXRecordLanguageEN_US from './en_US/CXRecordLanguage.json'
import CXRecordLanguageFR_FR from './fr_FR/CXRecordLanguage.json'
import CXRecordLanguageIT_IT from './it_IT/CXRecordLanguage.json'
import CXRecordLanguageNL_NL from './nl_NL/CXRecordLanguage.json'
import CXRecordLanguagePT_PT from './pt_PT/CXRecordLanguage.json'

import CXScoreLanguageDE_DE from './de_DE/CXScoreLanguage.json'
import CXScoreLanguageEN_GB from './en_GB/CXScoreLanguage.json'
import CXScoreLanguageEN_US from './en_US/CXScoreLanguage.json'
import CXScoreLanguageFR_FR from './fr_FR/CXScoreLanguage.json'
import CXScoreLanguageIT_IT from './it_IT/CXScoreLanguage.json'
import CXScoreLanguageNL_NL from './nl_NL/CXScoreLanguage.json'
import CXScoreLanguagePT_PT from './pt_PT/CXScoreLanguage.json'

import CallControlErrorsDE_DE from './de_DE/CallControlErrors.json'
import CallControlErrorsEN_GB from './en_GB/CallControlErrors.json'
import CallControlErrorsEN_US from './en_US/CallControlErrors.json'
import CallControlErrorsFR_FR from './fr_FR/CallControlErrors.json'
import CallControlErrorsIT_IT from './it_IT/CallControlErrors.json'
import CallControlErrorsNL_NL from './nl_NL/CallControlErrors.json'
import CallControlErrorsPT_PT from './pt_PT/CallControlErrors.json'

import CallDetailsDE_DE from './de_DE/CallDetails.json'
import CallDetailsEN_GB from './en_GB/CallDetails.json'
import CallDetailsEN_US from './en_US/CallDetails.json'
import CallDetailsFR_FR from './fr_FR/CallDetails.json'
import CallDetailsIT_IT from './it_IT/CallDetails.json'
import CallDetailsNL_NL from './nl_NL/CallDetails.json'
import CallDetailsPT_PT from './pt_PT/CallDetails.json'

import CallMovementFilteringDE_DE from './de_DE/CallMovementFiltering.json'
import CallMovementFilteringEN_GB from './en_GB/CallMovementFiltering.json'
import CallMovementFilteringEN_US from './en_US/CallMovementFiltering.json'
import CallMovementFilteringFR_FR from './fr_FR/CallMovementFiltering.json'
import CallMovementFilteringIT_IT from './it_IT/CallMovementFiltering.json'
import CallMovementFilteringNL_NL from './nl_NL/CallMovementFiltering.json'
import CallMovementFilteringPT_PT from './pt_PT/CallMovementFiltering.json'

import CallRecIntegrationDE_DE from './de_DE/CallRecIntegration.json'
import CallRecIntegrationEN_GB from './en_GB/CallRecIntegration.json'
import CallRecIntegrationEN_US from './en_US/CallRecIntegration.json'
import CallRecIntegrationFR_FR from './fr_FR/CallRecIntegration.json'
import CallRecIntegrationIT_IT from './it_IT/CallRecIntegration.json'
import CallRecIntegrationNL_NL from './nl_NL/CallRecIntegration.json'
import CallRecIntegrationPT_PT from './pt_PT/CallRecIntegration.json'

import CallRecordingDE_DE from './de_DE/CallRecording.json'
import CallRecordingEN_GB from './en_GB/CallRecording.json'
import CallRecordingEN_US from './en_US/CallRecording.json'
import CallRecordingFR_FR from './fr_FR/CallRecording.json'
import CallRecordingIT_IT from './it_IT/CallRecording.json'
import CallRecordingNL_NL from './nl_NL/CallRecording.json'
import CallRecordingPT_PT from './pt_PT/CallRecording.json'

import CallStateThresholdsDE_DE from './de_DE/CallStateThresholds.json'
import CallStateThresholdsEN_GB from './en_GB/CallStateThresholds.json'
import CallStateThresholdsEN_US from './en_US/CallStateThresholds.json'
import CallStateThresholdsFR_FR from './fr_FR/CallStateThresholds.json'
import CallStateThresholdsIT_IT from './it_IT/CallStateThresholds.json'
import CallStateThresholdsNL_NL from './nl_NL/CallStateThresholds.json'
import CallStateThresholdsPT_PT from './pt_PT/CallStateThresholds.json'

import CallTargettingDE_DE from './de_DE/CallTargetting.json'
import CallTargettingEN_GB from './en_GB/CallTargetting.json'
import CallTargettingEN_US from './en_US/CallTargetting.json'
import CallTargettingFR_FR from './fr_FR/CallTargetting.json'
import CallTargettingIT_IT from './it_IT/CallTargetting.json'
import CallTargettingNL_NL from './nl_NL/CallTargetting.json'
import CallTargettingPT_PT from './pt_PT/CallTargetting.json'

import ChangeLangLanguageDE_DE from './de_DE/ChangeLangLanguage.json'
import ChangeLangLanguageEN_GB from './en_GB/ChangeLangLanguage.json'
import ChangeLangLanguageEN_US from './en_US/ChangeLangLanguage.json'
import ChangeLangLanguageFR_FR from './fr_FR/ChangeLangLanguage.json'
import ChangeLangLanguageIT_IT from './it_IT/ChangeLangLanguage.json'
import ChangeLangLanguageNL_NL from './nl_NL/ChangeLangLanguage.json'
import ChangeLangLanguagePT_PT from './pt_PT/ChangeLangLanguage.json'

import ChangeLayoutDE_DE from './de_DE/ChangeLayout.json'
import ChangeLayoutEN_GB from './en_GB/ChangeLayout.json'
import ChangeLayoutEN_US from './en_US/ChangeLayout.json'
import ChangeLayoutFR_FR from './fr_FR/ChangeLayout.json'
import ChangeLayoutIT_IT from './it_IT/ChangeLayout.json'
import ChangeLayoutNL_NL from './nl_NL/ChangeLayout.json'
import ChangeLayoutPT_PT from './pt_PT/ChangeLayout.json'

import ChangeUserAgentLanguageDE_DE from './de_DE/ChangeUserAgentLanguage.json'
import ChangeUserAgentLanguageEN_GB from './en_GB/ChangeUserAgentLanguage.json'
import ChangeUserAgentLanguageEN_US from './en_US/ChangeUserAgentLanguage.json'
import ChangeUserAgentLanguageFR_FR from './fr_FR/ChangeUserAgentLanguage.json'
import ChangeUserAgentLanguageIT_IT from './it_IT/ChangeUserAgentLanguage.json'
import ChangeUserAgentLanguageNL_NL from './nl_NL/ChangeUserAgentLanguage.json'
import ChangeUserAgentLanguagePT_PT from './pt_PT/ChangeUserAgentLanguage.json'

import ChartProviderOptionsDE_DE from './de_DE/ChartProviderOptions.json'
import ChartProviderOptionsEN_GB from './en_GB/ChartProviderOptions.json'
import ChartProviderOptionsEN_US from './en_US/ChartProviderOptions.json'
import ChartProviderOptionsFR_FR from './fr_FR/ChartProviderOptions.json'
import ChartProviderOptionsIT_IT from './it_IT/ChartProviderOptions.json'
import ChartProviderOptionsNL_NL from './nl_NL/ChartProviderOptions.json'
import ChartProviderOptionsPT_PT from './pt_PT/ChartProviderOptions.json'

import ChartStyleOptionsDE_DE from './de_DE/ChartStyleOptions.json'
import ChartStyleOptionsEN_GB from './en_GB/ChartStyleOptions.json'
import ChartStyleOptionsEN_US from './en_US/ChartStyleOptions.json'
import ChartStyleOptionsFR_FR from './fr_FR/ChartStyleOptions.json'
import ChartStyleOptionsIT_IT from './it_IT/ChartStyleOptions.json'
import ChartStyleOptionsNL_NL from './nl_NL/ChartStyleOptions.json'
import ChartStyleOptionsPT_PT from './pt_PT/ChartStyleOptions.json'

import ClientConfigurationLanguageDE_DE from './de_DE/ClientConfigurationLanguage.json'
import ClientConfigurationLanguageEN_GB from './en_GB/ClientConfigurationLanguage.json'
import ClientConfigurationLanguageEN_US from './en_US/ClientConfigurationLanguage.json'
import ClientConfigurationLanguageFR_FR from './fr_FR/ClientConfigurationLanguage.json'
import ClientConfigurationLanguageIT_IT from './it_IT/ClientConfigurationLanguage.json'
import ClientConfigurationLanguageNL_NL from './nl_NL/ClientConfigurationLanguage.json'
import ClientConfigurationLanguagePT_PT from './pt_PT/ClientConfigurationLanguage.json'

import ClientConfigurationModalLanguageDE_DE from './de_DE/ClientConfigurationModalLanguage.json'
import ClientConfigurationModalLanguageEN_GB from './en_GB/ClientConfigurationModalLanguage.json'
import ClientConfigurationModalLanguageEN_US from './en_US/ClientConfigurationModalLanguage.json'
import ClientConfigurationModalLanguageFR_FR from './fr_FR/ClientConfigurationModalLanguage.json'
import ClientConfigurationModalLanguageIT_IT from './it_IT/ClientConfigurationModalLanguage.json'
import ClientConfigurationModalLanguageNL_NL from './nl_NL/ClientConfigurationModalLanguage.json'
import ClientConfigurationModalLanguagePT_PT from './pt_PT/ClientConfigurationModalLanguage.json'

import CmeListLanguageDE_DE from './de_DE/CmeListLanguage.json'
import CmeListLanguageEN_GB from './en_GB/CmeListLanguage.json'
import CmeListLanguageEN_US from './en_US/CmeListLanguage.json'
import CmeListLanguageFR_FR from './fr_FR/CmeListLanguage.json'
import CmeListLanguageIT_IT from './it_IT/CmeListLanguage.json'
import CmeListLanguageNL_NL from './nl_NL/CmeListLanguage.json'
import CmeListLanguagePT_PT from './pt_PT/CmeListLanguage.json'

import CodeAddModifyDE_DE from './de_DE/CodeAddModify.json'
import CodeAddModifyEN_GB from './en_GB/CodeAddModify.json'
import CodeAddModifyEN_US from './en_US/CodeAddModify.json'
import CodeAddModifyFR_FR from './fr_FR/CodeAddModify.json'
import CodeAddModifyIT_IT from './it_IT/CodeAddModify.json'
import CodeAddModifyNL_NL from './nl_NL/CodeAddModify.json'
import CodeAddModifyPT_PT from './pt_PT/CodeAddModify.json'

import CodeListLanguageDE_DE from './de_DE/CodeListLanguage.json'
import CodeListLanguageEN_GB from './en_GB/CodeListLanguage.json'
import CodeListLanguageEN_US from './en_US/CodeListLanguage.json'
import CodeListLanguageFR_FR from './fr_FR/CodeListLanguage.json'
import CodeListLanguageIT_IT from './it_IT/CodeListLanguage.json'
import CodeListLanguageNL_NL from './nl_NL/CodeListLanguage.json'
import CodeListLanguagePT_PT from './pt_PT/CodeListLanguage.json'

import ComboBoxDE_DE from './de_DE/ComboBox.json'
import ComboBoxEN_GB from './en_GB/ComboBox.json'
import ComboBoxEN_US from './en_US/ComboBox.json'
import ComboBoxFR_FR from './fr_FR/ComboBox.json'
import ComboBoxIT_IT from './it_IT/ComboBox.json'
import ComboBoxNL_NL from './nl_NL/ComboBox.json'
import ComboBoxPT_PT from './pt_PT/ComboBox.json'

import CommonAdminDE_DE from './de_DE/CommonAdmin.json'
import CommonAdminEN_GB from './en_GB/CommonAdmin.json'
import CommonAdminEN_US from './en_US/CommonAdmin.json'
import CommonAdminFR_FR from './fr_FR/CommonAdmin.json'
import CommonAdminIT_IT from './it_IT/CommonAdmin.json'
import CommonAdminNL_NL from './nl_NL/CommonAdmin.json'
import CommonAdminPT_PT from './pt_PT/CommonAdmin.json'

import ConfigChangeLogListLanguageDE_DE from './de_DE/ConfigChangeLogListLanguage.json'
import ConfigChangeLogListLanguageEN_GB from './en_GB/ConfigChangeLogListLanguage.json'
import ConfigChangeLogListLanguageEN_US from './en_US/ConfigChangeLogListLanguage.json'
import ConfigChangeLogListLanguageFR_FR from './fr_FR/ConfigChangeLogListLanguage.json'
import ConfigChangeLogListLanguageIT_IT from './it_IT/ConfigChangeLogListLanguage.json'
import ConfigChangeLogListLanguageNL_NL from './nl_NL/ConfigChangeLogListLanguage.json'
import ConfigChangeLogListLanguagePT_PT from './pt_PT/ConfigChangeLogListLanguage.json'

import ConfigureAgentsDE_DE from './de_DE/ConfigureAgents.json'
import ConfigureAgentsEN_GB from './en_GB/ConfigureAgents.json'
import ConfigureAgentsEN_US from './en_US/ConfigureAgents.json'
import ConfigureAgentsFR_FR from './fr_FR/ConfigureAgents.json'
import ConfigureAgentsIT_IT from './it_IT/ConfigureAgents.json'
import ConfigureAgentsNL_NL from './nl_NL/ConfigureAgents.json'
import ConfigureAgentsPT_PT from './pt_PT/ConfigureAgents.json'

import ConfigureReportDE_DE from './de_DE/ConfigureReport.json'
import ConfigureReportEN_GB from './en_GB/ConfigureReport.json'
import ConfigureReportEN_US from './en_US/ConfigureReport.json'
import ConfigureReportFR_FR from './fr_FR/ConfigureReport.json'
import ConfigureReportIT_IT from './it_IT/ConfigureReport.json'
import ConfigureReportNL_NL from './nl_NL/ConfigureReport.json'
import ConfigureReportPT_PT from './pt_PT/ConfigureReport.json'

import ContentRestrictionDE_DE from './de_DE/ContentRestriction.json'
import ContentRestrictionEN_GB from './en_GB/ContentRestriction.json'
import ContentRestrictionEN_US from './en_US/ContentRestriction.json'
import ContentRestrictionFR_FR from './fr_FR/ContentRestriction.json'
import ContentRestrictionIT_IT from './it_IT/ContentRestriction.json'
import ContentRestrictionNL_NL from './nl_NL/ContentRestriction.json'
import ContentRestrictionPT_PT from './pt_PT/ContentRestriction.json'

import CookieConsentDE_DE from './de_DE/CookieConsent.json'
import CookieConsentEN_GB from './en_GB/CookieConsent.json'
import CookieConsentEN_US from './en_US/CookieConsent.json'
import CookieConsentFR_FR from './fr_FR/CookieConsent.json'
import CookieConsentIT_IT from './it_IT/CookieConsent.json'
import CookieConsentNL_NL from './nl_NL/CookieConsent.json'
import CookieConsentPT_PT from './pt_PT/CookieConsent.json'

import CurrencyDE_DE from './de_DE/Currency.json'
import CurrencyEN_GB from './en_GB/Currency.json'
import CurrencyEN_US from './en_US/Currency.json'
import CurrencyFR_FR from './fr_FR/Currency.json'
import CurrencyIT_IT from './it_IT/Currency.json'
import CurrencyNL_NL from './nl_NL/Currency.json'
import CurrencyPT_PT from './pt_PT/Currency.json'

import CurrencyDisplayFormatDE_DE from './de_DE/CurrencyDisplayFormat.json'
import CurrencyDisplayFormatEN_GB from './en_GB/CurrencyDisplayFormat.json'
import CurrencyDisplayFormatEN_US from './en_US/CurrencyDisplayFormat.json'
import CurrencyDisplayFormatFR_FR from './fr_FR/CurrencyDisplayFormat.json'
import CurrencyDisplayFormatIT_IT from './it_IT/CurrencyDisplayFormat.json'
import CurrencyDisplayFormatNL_NL from './nl_NL/CurrencyDisplayFormat.json'
import CurrencyDisplayFormatPT_PT from './pt_PT/CurrencyDisplayFormat.json'

import CustomSettingsDE_DE from './de_DE/CustomSettings.json'
import CustomSettingsEN_GB from './en_GB/CustomSettings.json'
import CustomSettingsEN_US from './en_US/CustomSettings.json'
import CustomSettingsFR_FR from './fr_FR/CustomSettings.json'
import CustomSettingsIT_IT from './it_IT/CustomSettings.json'
import CustomSettingsNL_NL from './nl_NL/CustomSettings.json'
import CustomSettingsPT_PT from './pt_PT/CustomSettings.json'

import CustomiseRoleDE_DE from './de_DE/CustomiseRole.json'
import CustomiseRoleEN_GB from './en_GB/CustomiseRole.json'
import CustomiseRoleEN_US from './en_US/CustomiseRole.json'
import CustomiseRoleFR_FR from './fr_FR/CustomiseRole.json'
import CustomiseRoleIT_IT from './it_IT/CustomiseRole.json'
import CustomiseRoleNL_NL from './nl_NL/CustomiseRole.json'
import CustomiseRolePT_PT from './pt_PT/CustomiseRole.json'

import CxiLicenceTypesDE_DE from './de_DE/CxiLicenceTypes.json'
import CxiLicenceTypesEN_GB from './en_GB/CxiLicenceTypes.json'
import CxiLicenceTypesEN_US from './en_US/CxiLicenceTypes.json'
import CxiLicenceTypesFR_FR from './fr_FR/CxiLicenceTypes.json'
import CxiLicenceTypesIT_IT from './it_IT/CxiLicenceTypes.json'
import CxiLicenceTypesNL_NL from './nl_NL/CxiLicenceTypes.json'
import CxiLicenceTypesPT_PT from './pt_PT/CxiLicenceTypes.json'

import DarkModeDE_DE from './de_DE/DarkMode.json'
import DarkModeEN_GB from './en_GB/DarkMode.json'
import DarkModeEN_US from './en_US/DarkMode.json'
import DarkModeFR_FR from './fr_FR/DarkMode.json'
import DarkModeIT_IT from './it_IT/DarkMode.json'
import DarkModeNL_NL from './nl_NL/DarkMode.json'
import DarkModePT_PT from './pt_PT/DarkMode.json'

import DashboardDisplaySettingsDE_DE from './de_DE/DashboardDisplaySettings.json'
import DashboardDisplaySettingsEN_GB from './en_GB/DashboardDisplaySettings.json'
import DashboardDisplaySettingsEN_US from './en_US/DashboardDisplaySettings.json'
import DashboardDisplaySettingsFR_FR from './fr_FR/DashboardDisplaySettings.json'
import DashboardDisplaySettingsIT_IT from './it_IT/DashboardDisplaySettings.json'
import DashboardDisplaySettingsNL_NL from './nl_NL/DashboardDisplaySettings.json'
import DashboardDisplaySettingsPT_PT from './pt_PT/DashboardDisplaySettings.json'

import DashboardListDE_DE from './de_DE/DashboardList.json'
import DashboardListEN_GB from './en_GB/DashboardList.json'
import DashboardListEN_US from './en_US/DashboardList.json'
import DashboardListFR_FR from './fr_FR/DashboardList.json'
import DashboardListIT_IT from './it_IT/DashboardList.json'
import DashboardListNL_NL from './nl_NL/DashboardList.json'
import DashboardListPT_PT from './pt_PT/DashboardList.json'

import DashboardOptionsDE_DE from './de_DE/DashboardOptions.json'
import DashboardOptionsEN_GB from './en_GB/DashboardOptions.json'
import DashboardOptionsEN_US from './en_US/DashboardOptions.json'
import DashboardOptionsFR_FR from './fr_FR/DashboardOptions.json'
import DashboardOptionsIT_IT from './it_IT/DashboardOptions.json'
import DashboardOptionsNL_NL from './nl_NL/DashboardOptions.json'
import DashboardOptionsPT_PT from './pt_PT/DashboardOptions.json'

import DatabaseLanguageDE_DE from './de_DE/DatabaseLanguage.json'
import DatabaseLanguageEN_GB from './en_GB/DatabaseLanguage.json'
import DatabaseLanguageEN_US from './en_US/DatabaseLanguage.json'
import DatabaseLanguageFR_FR from './fr_FR/DatabaseLanguage.json'
import DatabaseLanguageIT_IT from './it_IT/DatabaseLanguage.json'
import DatabaseLanguageNL_NL from './nl_NL/DatabaseLanguage.json'
import DatabaseLanguagePT_PT from './pt_PT/DatabaseLanguage.json'

import DateDE_DE from './de_DE/Date.json'
import DateEN_GB from './en_GB/Date.json'
import DateEN_US from './en_US/Date.json'
import DateFR_FR from './fr_FR/Date.json'
import DateIT_IT from './it_IT/Date.json'
import DateNL_NL from './nl_NL/Date.json'
import DatePT_PT from './pt_PT/Date.json'

import DateTimeDE_DE from './de_DE/DateTime.json'
import DateTimeEN_GB from './en_GB/DateTime.json'
import DateTimeEN_US from './en_US/DateTime.json'
import DateTimeFR_FR from './fr_FR/DateTime.json'
import DateTimeIT_IT from './it_IT/DateTime.json'
import DateTimeNL_NL from './nl_NL/DateTime.json'
import DateTimePT_PT from './pt_PT/DateTime.json'

import DaysOfTheWeekDE_DE from './de_DE/DaysOfTheWeek.json'
import DaysOfTheWeekEN_GB from './en_GB/DaysOfTheWeek.json'
import DaysOfTheWeekEN_US from './en_US/DaysOfTheWeek.json'
import DaysOfTheWeekFR_FR from './fr_FR/DaysOfTheWeek.json'
import DaysOfTheWeekIT_IT from './it_IT/DaysOfTheWeek.json'
import DaysOfTheWeekNL_NL from './nl_NL/DaysOfTheWeek.json'
import DaysOfTheWeekPT_PT from './pt_PT/DaysOfTheWeek.json'

import DeviceFilteringDE_DE from './de_DE/DeviceFiltering.json'
import DeviceFilteringEN_GB from './en_GB/DeviceFiltering.json'
import DeviceFilteringEN_US from './en_US/DeviceFiltering.json'
import DeviceFilteringFR_FR from './fr_FR/DeviceFiltering.json'
import DeviceFilteringIT_IT from './it_IT/DeviceFiltering.json'
import DeviceFilteringNL_NL from './nl_NL/DeviceFiltering.json'
import DeviceFilteringPT_PT from './pt_PT/DeviceFiltering.json'

import DeviceListLanguageDE_DE from './de_DE/DeviceListLanguage.json'
import DeviceListLanguageEN_GB from './en_GB/DeviceListLanguage.json'
import DeviceListLanguageEN_US from './en_US/DeviceListLanguage.json'
import DeviceListLanguageFR_FR from './fr_FR/DeviceListLanguage.json'
import DeviceListLanguageIT_IT from './it_IT/DeviceListLanguage.json'
import DeviceListLanguageNL_NL from './nl_NL/DeviceListLanguage.json'
import DeviceListLanguagePT_PT from './pt_PT/DeviceListLanguage.json'

import DeviceModalDE_DE from './de_DE/DeviceModal.json'
import DeviceModalEN_GB from './en_GB/DeviceModal.json'
import DeviceModalEN_US from './en_US/DeviceModal.json'
import DeviceModalFR_FR from './fr_FR/DeviceModal.json'
import DeviceModalIT_IT from './it_IT/DeviceModal.json'
import DeviceModalNL_NL from './nl_NL/DeviceModal.json'
import DeviceModalPT_PT from './pt_PT/DeviceModal.json'

import DeviceTypesLanguageDE_DE from './de_DE/DeviceTypesLanguage.json'
import DeviceTypesLanguageEN_GB from './en_GB/DeviceTypesLanguage.json'
import DeviceTypesLanguageEN_US from './en_US/DeviceTypesLanguage.json'
import DeviceTypesLanguageFR_FR from './fr_FR/DeviceTypesLanguage.json'
import DeviceTypesLanguageIT_IT from './it_IT/DeviceTypesLanguage.json'
import DeviceTypesLanguageNL_NL from './nl_NL/DeviceTypesLanguage.json'
import DeviceTypesLanguagePT_PT from './pt_PT/DeviceTypesLanguage.json'

import DirectoryListLanguageDE_DE from './de_DE/DirectoryListLanguage.json'
import DirectoryListLanguageEN_GB from './en_GB/DirectoryListLanguage.json'
import DirectoryListLanguageEN_US from './en_US/DirectoryListLanguage.json'
import DirectoryListLanguageFR_FR from './fr_FR/DirectoryListLanguage.json'
import DirectoryListLanguageIT_IT from './it_IT/DirectoryListLanguage.json'
import DirectoryListLanguageNL_NL from './nl_NL/DirectoryListLanguage.json'
import DirectoryListLanguagePT_PT from './pt_PT/DirectoryListLanguage.json'

import DirectoryModalDE_DE from './de_DE/DirectoryModal.json'
import DirectoryModalEN_GB from './en_GB/DirectoryModal.json'
import DirectoryModalEN_US from './en_US/DirectoryModal.json'
import DirectoryModalFR_FR from './fr_FR/DirectoryModal.json'
import DirectoryModalIT_IT from './it_IT/DirectoryModal.json'
import DirectoryModalNL_NL from './nl_NL/DirectoryModal.json'
import DirectoryModalPT_PT from './pt_PT/DirectoryModal.json'

import DisplayOptionsDE_DE from './de_DE/DisplayOptions.json'
import DisplayOptionsEN_GB from './en_GB/DisplayOptions.json'
import DisplayOptionsEN_US from './en_US/DisplayOptions.json'
import DisplayOptionsFR_FR from './fr_FR/DisplayOptions.json'
import DisplayOptionsIT_IT from './it_IT/DisplayOptions.json'
import DisplayOptionsNL_NL from './nl_NL/DisplayOptions.json'
import DisplayOptionsPT_PT from './pt_PT/DisplayOptions.json'

import DisplaySettingsDE_DE from './de_DE/DisplaySettings.json'
import DisplaySettingsEN_GB from './en_GB/DisplaySettings.json'
import DisplaySettingsEN_US from './en_US/DisplaySettings.json'
import DisplaySettingsFR_FR from './fr_FR/DisplaySettings.json'
import DisplaySettingsIT_IT from './it_IT/DisplaySettings.json'
import DisplaySettingsNL_NL from './nl_NL/DisplaySettings.json'
import DisplaySettingsPT_PT from './pt_PT/DisplaySettings.json'

import DisplaySwitchingDE_DE from './de_DE/DisplaySwitching.json'
import DisplaySwitchingEN_GB from './en_GB/DisplaySwitching.json'
import DisplaySwitchingEN_US from './en_US/DisplaySwitching.json'
import DisplaySwitchingFR_FR from './fr_FR/DisplaySwitching.json'
import DisplaySwitchingIT_IT from './it_IT/DisplaySwitching.json'
import DisplaySwitchingNL_NL from './nl_NL/DisplaySwitching.json'
import DisplaySwitchingPT_PT from './pt_PT/DisplaySwitching.json'

import DisplayedAsOptionsDE_DE from './de_DE/DisplayedAsOptions.json'
import DisplayedAsOptionsEN_GB from './en_GB/DisplayedAsOptions.json'
import DisplayedAsOptionsEN_US from './en_US/DisplayedAsOptions.json'
import DisplayedAsOptionsFR_FR from './fr_FR/DisplayedAsOptions.json'
import DisplayedAsOptionsIT_IT from './it_IT/DisplayedAsOptions.json'
import DisplayedAsOptionsNL_NL from './nl_NL/DisplayedAsOptions.json'
import DisplayedAsOptionsPT_PT from './pt_PT/DisplayedAsOptions.json'

import DocumentViewerDE_DE from './de_DE/DocumentViewer.json'
import DocumentViewerEN_GB from './en_GB/DocumentViewer.json'
import DocumentViewerEN_US from './en_US/DocumentViewer.json'
import DocumentViewerFR_FR from './fr_FR/DocumentViewer.json'
import DocumentViewerIT_IT from './it_IT/DocumentViewer.json'
import DocumentViewerNL_NL from './nl_NL/DocumentViewer.json'
import DocumentViewerPT_PT from './pt_PT/DocumentViewer.json'

import DomainProfileDE_DE from './de_DE/DomainProfile.json'
import DomainProfileEN_GB from './en_GB/DomainProfile.json'
import DomainProfileEN_US from './en_US/DomainProfile.json'
import DomainProfileFR_FR from './fr_FR/DomainProfile.json'
import DomainProfileIT_IT from './it_IT/DomainProfile.json'
import DomainProfileNL_NL from './nl_NL/DomainProfile.json'
import DomainProfilePT_PT from './pt_PT/DomainProfile.json'

import DurationFilteringDE_DE from './de_DE/DurationFiltering.json'
import DurationFilteringEN_GB from './en_GB/DurationFiltering.json'
import DurationFilteringEN_US from './en_US/DurationFiltering.json'
import DurationFilteringFR_FR from './fr_FR/DurationFiltering.json'
import DurationFilteringIT_IT from './it_IT/DurationFiltering.json'
import DurationFilteringNL_NL from './nl_NL/DurationFiltering.json'
import DurationFilteringPT_PT from './pt_PT/DurationFiltering.json'

import ErrorLanguageDE_DE from './de_DE/ErrorLanguage.json'
import ErrorLanguageEN_GB from './en_GB/ErrorLanguage.json'
import ErrorLanguageEN_US from './en_US/ErrorLanguage.json'
import ErrorLanguageFR_FR from './fr_FR/ErrorLanguage.json'
import ErrorLanguageIT_IT from './it_IT/ErrorLanguage.json'
import ErrorLanguageNL_NL from './nl_NL/ErrorLanguage.json'
import ErrorLanguagePT_PT from './pt_PT/ErrorLanguage.json'

import EstateDE_DE from './de_DE/Estate.json'
import EstateEN_GB from './en_GB/Estate.json'
import EstateEN_US from './en_US/Estate.json'
import EstateFR_FR from './fr_FR/Estate.json'
import EstateIT_IT from './it_IT/Estate.json'
import EstateNL_NL from './nl_NL/Estate.json'
import EstatePT_PT from './pt_PT/Estate.json'

import ExtensionEndpointDE_DE from './de_DE/ExtensionEndpoint.json'
import ExtensionEndpointEN_GB from './en_GB/ExtensionEndpoint.json'
import ExtensionEndpointEN_US from './en_US/ExtensionEndpoint.json'
import ExtensionEndpointFR_FR from './fr_FR/ExtensionEndpoint.json'
import ExtensionEndpointIT_IT from './it_IT/ExtensionEndpoint.json'
import ExtensionEndpointNL_NL from './nl_NL/ExtensionEndpoint.json'
import ExtensionEndpointPT_PT from './pt_PT/ExtensionEndpoint.json'

import FieldsListDE_DE from './de_DE/FieldsList.json'
import FieldsListEN_GB from './en_GB/FieldsList.json'
import FieldsListEN_US from './en_US/FieldsList.json'
import FieldsListFR_FR from './fr_FR/FieldsList.json'
import FieldsListIT_IT from './it_IT/FieldsList.json'
import FieldsListNL_NL from './nl_NL/FieldsList.json'
import FieldsListPT_PT from './pt_PT/FieldsList.json'

import FieldsTabDE_DE from './de_DE/FieldsTab.json'
import FieldsTabEN_GB from './en_GB/FieldsTab.json'
import FieldsTabEN_US from './en_US/FieldsTab.json'
import FieldsTabFR_FR from './fr_FR/FieldsTab.json'
import FieldsTabIT_IT from './it_IT/FieldsTab.json'
import FieldsTabNL_NL from './nl_NL/FieldsTab.json'
import FieldsTabPT_PT from './pt_PT/FieldsTab.json'

import FileUploadLanguageDE_DE from './de_DE/FileUploadLanguage.json'
import FileUploadLanguageEN_GB from './en_GB/FileUploadLanguage.json'
import FileUploadLanguageEN_US from './en_US/FileUploadLanguage.json'
import FileUploadLanguageFR_FR from './fr_FR/FileUploadLanguage.json'
import FileUploadLanguageIT_IT from './it_IT/FileUploadLanguage.json'
import FileUploadLanguageNL_NL from './nl_NL/FileUploadLanguage.json'
import FileUploadLanguagePT_PT from './pt_PT/FileUploadLanguage.json'

import ForgotPasswordLanguageDE_DE from './de_DE/ForgotPasswordLanguage.json'
import ForgotPasswordLanguageEN_GB from './en_GB/ForgotPasswordLanguage.json'
import ForgotPasswordLanguageEN_US from './en_US/ForgotPasswordLanguage.json'
import ForgotPasswordLanguageFR_FR from './fr_FR/ForgotPasswordLanguage.json'
import ForgotPasswordLanguageIT_IT from './it_IT/ForgotPasswordLanguage.json'
import ForgotPasswordLanguageNL_NL from './nl_NL/ForgotPasswordLanguage.json'
import ForgotPasswordLanguagePT_PT from './pt_PT/ForgotPasswordLanguage.json'

import FormatDE_DE from './de_DE/Format.json'
import FormatEN_GB from './en_GB/Format.json'
import FormatEN_US from './en_US/Format.json'
import FormatFR_FR from './fr_FR/Format.json'
import FormatIT_IT from './it_IT/Format.json'
import FormatNL_NL from './nl_NL/Format.json'
import FormatPT_PT from './pt_PT/Format.json'

import GenericAdminFilterLanguageDE_DE from './de_DE/GenericAdminFilterLanguage.json'
import GenericAdminFilterLanguageEN_GB from './en_GB/GenericAdminFilterLanguage.json'
import GenericAdminFilterLanguageEN_US from './en_US/GenericAdminFilterLanguage.json'
import GenericAdminFilterLanguageFR_FR from './fr_FR/GenericAdminFilterLanguage.json'
import GenericAdminFilterLanguageIT_IT from './it_IT/GenericAdminFilterLanguage.json'
import GenericAdminFilterLanguageNL_NL from './nl_NL/GenericAdminFilterLanguage.json'
import GenericAdminFilterLanguagePT_PT from './pt_PT/GenericAdminFilterLanguage.json'

import GenericAdminListLanguageDE_DE from './de_DE/GenericAdminListLanguage.json'
import GenericAdminListLanguageEN_GB from './en_GB/GenericAdminListLanguage.json'
import GenericAdminListLanguageEN_US from './en_US/GenericAdminListLanguage.json'
import GenericAdminListLanguageFR_FR from './fr_FR/GenericAdminListLanguage.json'
import GenericAdminListLanguageIT_IT from './it_IT/GenericAdminListLanguage.json'
import GenericAdminListLanguageNL_NL from './nl_NL/GenericAdminListLanguage.json'
import GenericAdminListLanguagePT_PT from './pt_PT/GenericAdminListLanguage.json'

import GenericFooterDE_DE from './de_DE/GenericFooter.json'
import GenericFooterEN_GB from './en_GB/GenericFooter.json'
import GenericFooterEN_US from './en_US/GenericFooter.json'
import GenericFooterFR_FR from './fr_FR/GenericFooter.json'
import GenericFooterIT_IT from './it_IT/GenericFooter.json'
import GenericFooterNL_NL from './nl_NL/GenericFooter.json'
import GenericFooterPT_PT from './pt_PT/GenericFooter.json'

import GenericModalDE_DE from './de_DE/GenericModal.json'
import GenericModalEN_GB from './en_GB/GenericModal.json'
import GenericModalEN_US from './en_US/GenericModal.json'
import GenericModalFR_FR from './fr_FR/GenericModal.json'
import GenericModalIT_IT from './it_IT/GenericModal.json'
import GenericModalNL_NL from './nl_NL/GenericModal.json'
import GenericModalPT_PT from './pt_PT/GenericModal.json'

import GenericRuleLanguageDE_DE from './de_DE/GenericRuleLanguage.json'
import GenericRuleLanguageEN_GB from './en_GB/GenericRuleLanguage.json'
import GenericRuleLanguageEN_US from './en_US/GenericRuleLanguage.json'
import GenericRuleLanguageFR_FR from './fr_FR/GenericRuleLanguage.json'
import GenericRuleLanguageIT_IT from './it_IT/GenericRuleLanguage.json'
import GenericRuleLanguageNL_NL from './nl_NL/GenericRuleLanguage.json'
import GenericRuleLanguagePT_PT from './pt_PT/GenericRuleLanguage.json'

import GenericScopeTabDE_DE from './de_DE/GenericScopeTab.json'
import GenericScopeTabEN_GB from './en_GB/GenericScopeTab.json'
import GenericScopeTabEN_US from './en_US/GenericScopeTab.json'
import GenericScopeTabFR_FR from './fr_FR/GenericScopeTab.json'
import GenericScopeTabIT_IT from './it_IT/GenericScopeTab.json'
import GenericScopeTabNL_NL from './nl_NL/GenericScopeTab.json'
import GenericScopeTabPT_PT from './pt_PT/GenericScopeTab.json'

import HeaderSidebarDE_DE from './de_DE/HeaderSidebar.json'
import HeaderSidebarEN_GB from './en_GB/HeaderSidebar.json'
import HeaderSidebarEN_US from './en_US/HeaderSidebar.json'
import HeaderSidebarFR_FR from './fr_FR/HeaderSidebar.json'
import HeaderSidebarIT_IT from './it_IT/HeaderSidebar.json'
import HeaderSidebarNL_NL from './nl_NL/HeaderSidebar.json'
import HeaderSidebarPT_PT from './pt_PT/HeaderSidebar.json'

import InboundStatSettingsDE_DE from './de_DE/InboundStatSettings.json'
import InboundStatSettingsEN_GB from './en_GB/InboundStatSettings.json'
import InboundStatSettingsEN_US from './en_US/InboundStatSettings.json'
import InboundStatSettingsFR_FR from './fr_FR/InboundStatSettings.json'
import InboundStatSettingsIT_IT from './it_IT/InboundStatSettings.json'
import InboundStatSettingsNL_NL from './nl_NL/InboundStatSettings.json'
import InboundStatSettingsPT_PT from './pt_PT/InboundStatSettings.json'

import InsightsDashboardLanguageDE_DE from './de_DE/InsightsDashboardLanguage.json'
import InsightsDashboardLanguageEN_GB from './en_GB/InsightsDashboardLanguage.json'
import InsightsDashboardLanguageEN_US from './en_US/InsightsDashboardLanguage.json'
import InsightsDashboardLanguageFR_FR from './fr_FR/InsightsDashboardLanguage.json'
import InsightsDashboardLanguageIT_IT from './it_IT/InsightsDashboardLanguage.json'
import InsightsDashboardLanguageNL_NL from './nl_NL/InsightsDashboardLanguage.json'
import InsightsDashboardLanguagePT_PT from './pt_PT/InsightsDashboardLanguage.json'

import InsightsHubDE_DE from './de_DE/InsightsHub.json'
import InsightsHubEN_GB from './en_GB/InsightsHub.json'
import InsightsHubEN_US from './en_US/InsightsHub.json'
import InsightsHubFR_FR from './fr_FR/InsightsHub.json'
import InsightsHubIT_IT from './it_IT/InsightsHub.json'
import InsightsHubNL_NL from './nl_NL/InsightsHub.json'
import InsightsHubPT_PT from './pt_PT/InsightsHub.json'

import LanguageBulkInsertUsersDE_DE from './de_DE/LanguageBulkInsertUsers.json'
import LanguageBulkInsertUsersEN_GB from './en_GB/LanguageBulkInsertUsers.json'
import LanguageBulkInsertUsersEN_US from './en_US/LanguageBulkInsertUsers.json'
import LanguageBulkInsertUsersFR_FR from './fr_FR/LanguageBulkInsertUsers.json'
import LanguageBulkInsertUsersIT_IT from './it_IT/LanguageBulkInsertUsers.json'
import LanguageBulkInsertUsersNL_NL from './nl_NL/LanguageBulkInsertUsers.json'
import LanguageBulkInsertUsersPT_PT from './pt_PT/LanguageBulkInsertUsers.json'

import LanguageBulkUploadDirectoryEntriesDE_DE from './de_DE/LanguageBulkUploadDirectoryEntries.json'
import LanguageBulkUploadDirectoryEntriesEN_GB from './en_GB/LanguageBulkUploadDirectoryEntries.json'
import LanguageBulkUploadDirectoryEntriesEN_US from './en_US/LanguageBulkUploadDirectoryEntries.json'
import LanguageBulkUploadDirectoryEntriesFR_FR from './fr_FR/LanguageBulkUploadDirectoryEntries.json'
import LanguageBulkUploadDirectoryEntriesIT_IT from './it_IT/LanguageBulkUploadDirectoryEntries.json'
import LanguageBulkUploadDirectoryEntriesNL_NL from './nl_NL/LanguageBulkUploadDirectoryEntries.json'
import LanguageBulkUploadDirectoryEntriesPT_PT from './pt_PT/LanguageBulkUploadDirectoryEntries.json'

import LanguageCMEDE_DE from './de_DE/LanguageCME.json'
import LanguageCMEEN_GB from './en_GB/LanguageCME.json'
import LanguageCMEEN_US from './en_US/LanguageCME.json'
import LanguageCMEFR_FR from './fr_FR/LanguageCME.json'
import LanguageCMEIT_IT from './it_IT/LanguageCME.json'
import LanguageCMENL_NL from './nl_NL/LanguageCME.json'
import LanguageCMEPT_PT from './pt_PT/LanguageCME.json'

import LanguageDataTableDE_DE from './de_DE/LanguageDataTable.json'
import LanguageDataTableEN_GB from './en_GB/LanguageDataTable.json'
import LanguageDataTableEN_US from './en_US/LanguageDataTable.json'
import LanguageDataTableFR_FR from './fr_FR/LanguageDataTable.json'
import LanguageDataTableIT_IT from './it_IT/LanguageDataTable.json'
import LanguageDataTableNL_NL from './nl_NL/LanguageDataTable.json'
import LanguageDataTablePT_PT from './pt_PT/LanguageDataTable.json'

import LanguageErrorCodesDE_DE from './de_DE/LanguageErrorCodes.json'
import LanguageErrorCodesEN_GB from './en_GB/LanguageErrorCodes.json'
import LanguageErrorCodesEN_US from './en_US/LanguageErrorCodes.json'
import LanguageErrorCodesFR_FR from './fr_FR/LanguageErrorCodes.json'
import LanguageErrorCodesIT_IT from './it_IT/LanguageErrorCodes.json'
import LanguageErrorCodesNL_NL from './nl_NL/LanguageErrorCodes.json'
import LanguageErrorCodesPT_PT from './pt_PT/LanguageErrorCodes.json'

import LanguageErrorsDE_DE from './de_DE/LanguageErrors.json'
import LanguageErrorsEN_GB from './en_GB/LanguageErrors.json'
import LanguageErrorsEN_US from './en_US/LanguageErrors.json'
import LanguageErrorsFR_FR from './fr_FR/LanguageErrors.json'
import LanguageErrorsIT_IT from './it_IT/LanguageErrors.json'
import LanguageErrorsNL_NL from './nl_NL/LanguageErrors.json'
import LanguageErrorsPT_PT from './pt_PT/LanguageErrors.json'

import LanguageFallbackNavDE_DE from './de_DE/LanguageFallbackNav.json'
import LanguageFallbackNavEN_GB from './en_GB/LanguageFallbackNav.json'
import LanguageFallbackNavEN_US from './en_US/LanguageFallbackNav.json'
import LanguageFallbackNavFR_FR from './fr_FR/LanguageFallbackNav.json'
import LanguageFallbackNavIT_IT from './it_IT/LanguageFallbackNav.json'
import LanguageFallbackNavNL_NL from './nl_NL/LanguageFallbackNav.json'
import LanguageFallbackNavPT_PT from './pt_PT/LanguageFallbackNav.json'

import LanguageGeneralDE_DE from './de_DE/LanguageGeneral.json'
import LanguageGeneralEN_GB from './en_GB/LanguageGeneral.json'
import LanguageGeneralEN_US from './en_US/LanguageGeneral.json'
import LanguageGeneralFR_FR from './fr_FR/LanguageGeneral.json'
import LanguageGeneralIT_IT from './it_IT/LanguageGeneral.json'
import LanguageGeneralNL_NL from './nl_NL/LanguageGeneral.json'
import LanguageGeneralPT_PT from './pt_PT/LanguageGeneral.json'

import LanguageLogFileDownloadDE_DE from './de_DE/LanguageLogFileDownload.json'
import LanguageLogFileDownloadEN_GB from './en_GB/LanguageLogFileDownload.json'
import LanguageLogFileDownloadEN_US from './en_US/LanguageLogFileDownload.json'
import LanguageLogFileDownloadFR_FR from './fr_FR/LanguageLogFileDownload.json'
import LanguageLogFileDownloadIT_IT from './it_IT/LanguageLogFileDownload.json'
import LanguageLogFileDownloadNL_NL from './nl_NL/LanguageLogFileDownload.json'
import LanguageLogFileDownloadPT_PT from './pt_PT/LanguageLogFileDownload.json'

import LanguageMainMenuDE_DE from './de_DE/LanguageMainMenu.json'
import LanguageMainMenuEN_GB from './en_GB/LanguageMainMenu.json'
import LanguageMainMenuEN_US from './en_US/LanguageMainMenu.json'
import LanguageMainMenuFR_FR from './fr_FR/LanguageMainMenu.json'
import LanguageMainMenuIT_IT from './it_IT/LanguageMainMenu.json'
import LanguageMainMenuNL_NL from './nl_NL/LanguageMainMenu.json'
import LanguageMainMenuPT_PT from './pt_PT/LanguageMainMenu.json'

import LanguageMainNavigationDE_DE from './de_DE/LanguageMainNavigation.json'
import LanguageMainNavigationEN_GB from './en_GB/LanguageMainNavigation.json'
import LanguageMainNavigationEN_US from './en_US/LanguageMainNavigation.json'
import LanguageMainNavigationFR_FR from './fr_FR/LanguageMainNavigation.json'
import LanguageMainNavigationIT_IT from './it_IT/LanguageMainNavigation.json'
import LanguageMainNavigationNL_NL from './nl_NL/LanguageMainNavigation.json'
import LanguageMainNavigationPT_PT from './pt_PT/LanguageMainNavigation.json'

import LanguageMyReportListDE_DE from './de_DE/LanguageMyReportList.json'
import LanguageMyReportListEN_GB from './en_GB/LanguageMyReportList.json'
import LanguageMyReportListEN_US from './en_US/LanguageMyReportList.json'
import LanguageMyReportListFR_FR from './fr_FR/LanguageMyReportList.json'
import LanguageMyReportListIT_IT from './it_IT/LanguageMyReportList.json'
import LanguageMyReportListNL_NL from './nl_NL/LanguageMyReportList.json'
import LanguageMyReportListPT_PT from './pt_PT/LanguageMyReportList.json'

import LanguageNewUserTutorialDE_DE from './de_DE/LanguageNewUserTutorial.json'
import LanguageNewUserTutorialEN_GB from './en_GB/LanguageNewUserTutorial.json'
import LanguageNewUserTutorialEN_US from './en_US/LanguageNewUserTutorial.json'
import LanguageNewUserTutorialFR_FR from './fr_FR/LanguageNewUserTutorial.json'
import LanguageNewUserTutorialIT_IT from './it_IT/LanguageNewUserTutorial.json'
import LanguageNewUserTutorialNL_NL from './nl_NL/LanguageNewUserTutorial.json'
import LanguageNewUserTutorialPT_PT from './pt_PT/LanguageNewUserTutorial.json'

import LanguagePromptDE_DE from './de_DE/LanguagePrompt.json'
import LanguagePromptEN_GB from './en_GB/LanguagePrompt.json'
import LanguagePromptEN_US from './en_US/LanguagePrompt.json'
import LanguagePromptFR_FR from './fr_FR/LanguagePrompt.json'
import LanguagePromptIT_IT from './it_IT/LanguagePrompt.json'
import LanguagePromptNL_NL from './nl_NL/LanguagePrompt.json'
import LanguagePromptPT_PT from './pt_PT/LanguagePrompt.json'

import LanguageSnackbarDE_DE from './de_DE/LanguageSnackbar.json'
import LanguageSnackbarEN_GB from './en_GB/LanguageSnackbar.json'
import LanguageSnackbarEN_US from './en_US/LanguageSnackbar.json'
import LanguageSnackbarFR_FR from './fr_FR/LanguageSnackbar.json'
import LanguageSnackbarIT_IT from './it_IT/LanguageSnackbar.json'
import LanguageSnackbarNL_NL from './nl_NL/LanguageSnackbar.json'
import LanguageSnackbarPT_PT from './pt_PT/LanguageSnackbar.json'

import LicenceManagementPageLanguageDE_DE from './de_DE/LicenceManagementPageLanguage.json'
import LicenceManagementPageLanguageEN_GB from './en_GB/LicenceManagementPageLanguage.json'
import LicenceManagementPageLanguageEN_US from './en_US/LicenceManagementPageLanguage.json'
import LicenceManagementPageLanguageFR_FR from './fr_FR/LicenceManagementPageLanguage.json'
import LicenceManagementPageLanguageIT_IT from './it_IT/LicenceManagementPageLanguage.json'
import LicenceManagementPageLanguageNL_NL from './nl_NL/LicenceManagementPageLanguage.json'
import LicenceManagementPageLanguagePT_PT from './pt_PT/LicenceManagementPageLanguage.json'

import LicenseManagementDE_DE from './de_DE/LicenseManagement.json'
import LicenseManagementEN_GB from './en_GB/LicenseManagement.json'
import LicenseManagementEN_US from './en_US/LicenseManagement.json'
import LicenseManagementFR_FR from './fr_FR/LicenseManagement.json'
import LicenseManagementIT_IT from './it_IT/LicenseManagement.json'
import LicenseManagementNL_NL from './nl_NL/LicenseManagement.json'
import LicenseManagementPT_PT from './pt_PT/LicenseManagement.json'

import LicenseManagementLanguageDE_DE from './de_DE/LicenseManagementLanguage.json'
import LicenseManagementLanguageEN_GB from './en_GB/LicenseManagementLanguage.json'
import LicenseManagementLanguageEN_US from './en_US/LicenseManagementLanguage.json'
import LicenseManagementLanguageFR_FR from './fr_FR/LicenseManagementLanguage.json'
import LicenseManagementLanguageIT_IT from './it_IT/LicenseManagementLanguage.json'
import LicenseManagementLanguageNL_NL from './nl_NL/LicenseManagementLanguage.json'
import LicenseManagementLanguagePT_PT from './pt_PT/LicenseManagementLanguage.json'

import LinkInputLanguageDE_DE from './de_DE/LinkInputLanguage.json'
import LinkInputLanguageEN_GB from './en_GB/LinkInputLanguage.json'
import LinkInputLanguageEN_US from './en_US/LinkInputLanguage.json'
import LinkInputLanguageFR_FR from './fr_FR/LinkInputLanguage.json'
import LinkInputLanguageIT_IT from './it_IT/LinkInputLanguage.json'
import LinkInputLanguageNL_NL from './nl_NL/LinkInputLanguage.json'
import LinkInputLanguagePT_PT from './pt_PT/LinkInputLanguage.json'

import LocationalFilteringDE_DE from './de_DE/LocationalFiltering.json'
import LocationalFilteringEN_GB from './en_GB/LocationalFiltering.json'
import LocationalFilteringEN_US from './en_US/LocationalFiltering.json'
import LocationalFilteringFR_FR from './fr_FR/LocationalFiltering.json'
import LocationalFilteringIT_IT from './it_IT/LocationalFiltering.json'
import LocationalFilteringNL_NL from './nl_NL/LocationalFiltering.json'
import LocationalFilteringPT_PT from './pt_PT/LocationalFiltering.json'

import LogManagementListLanguageDE_DE from './de_DE/LogManagementListLanguage.json'
import LogManagementListLanguageEN_GB from './en_GB/LogManagementListLanguage.json'
import LogManagementListLanguageEN_US from './en_US/LogManagementListLanguage.json'
import LogManagementListLanguageFR_FR from './fr_FR/LogManagementListLanguage.json'
import LogManagementListLanguageIT_IT from './it_IT/LogManagementListLanguage.json'
import LogManagementListLanguageNL_NL from './nl_NL/LogManagementListLanguage.json'
import LogManagementListLanguagePT_PT from './pt_PT/LogManagementListLanguage.json'

import LoggingSettingsLanguageDE_DE from './de_DE/LoggingSettingsLanguage.json'
import LoggingSettingsLanguageEN_GB from './en_GB/LoggingSettingsLanguage.json'
import LoggingSettingsLanguageEN_US from './en_US/LoggingSettingsLanguage.json'
import LoggingSettingsLanguageFR_FR from './fr_FR/LoggingSettingsLanguage.json'
import LoggingSettingsLanguageIT_IT from './it_IT/LoggingSettingsLanguage.json'
import LoggingSettingsLanguageNL_NL from './nl_NL/LoggingSettingsLanguage.json'
import LoggingSettingsLanguagePT_PT from './pt_PT/LoggingSettingsLanguage.json'

import MFALanguageDE_DE from './de_DE/MFALanguage.json'
import MFALanguageEN_GB from './en_GB/MFALanguage.json'
import MFALanguageEN_US from './en_US/MFALanguage.json'
import MFALanguageFR_FR from './fr_FR/MFALanguage.json'
import MFALanguageIT_IT from './it_IT/MFALanguage.json'
import MFALanguageNL_NL from './nl_NL/MFALanguage.json'
import MFALanguagePT_PT from './pt_PT/MFALanguage.json'

import ManageCustomRolesDE_DE from './de_DE/ManageCustomRoles.json'
import ManageCustomRolesEN_GB from './en_GB/ManageCustomRoles.json'
import ManageCustomRolesEN_US from './en_US/ManageCustomRoles.json'
import ManageCustomRolesFR_FR from './fr_FR/ManageCustomRoles.json'
import ManageCustomRolesIT_IT from './it_IT/ManageCustomRoles.json'
import ManageCustomRolesNL_NL from './nl_NL/ManageCustomRoles.json'
import ManageCustomRolesPT_PT from './pt_PT/ManageCustomRoles.json'

import ManageQueuesDE_DE from './de_DE/ManageQueues.json'
import ManageQueuesEN_GB from './en_GB/ManageQueues.json'
import ManageQueuesEN_US from './en_US/ManageQueues.json'
import ManageQueuesFR_FR from './fr_FR/ManageQueues.json'
import ManageQueuesIT_IT from './it_IT/ManageQueues.json'
import ManageQueuesNL_NL from './nl_NL/ManageQueues.json'
import ManageQueuesPT_PT from './pt_PT/ManageQueues.json'

import MediaPlayerDE_DE from './de_DE/MediaPlayer.json'
import MediaPlayerEN_GB from './en_GB/MediaPlayer.json'
import MediaPlayerEN_US from './en_US/MediaPlayer.json'
import MediaPlayerFR_FR from './fr_FR/MediaPlayer.json'
import MediaPlayerIT_IT from './it_IT/MediaPlayer.json'
import MediaPlayerNL_NL from './nl_NL/MediaPlayer.json'
import MediaPlayerPT_PT from './pt_PT/MediaPlayer.json'

import MessagesLanguageDE_DE from './de_DE/MessagesLanguage.json'
import MessagesLanguageEN_GB from './en_GB/MessagesLanguage.json'
import MessagesLanguageEN_US from './en_US/MessagesLanguage.json'
import MessagesLanguageFR_FR from './fr_FR/MessagesLanguage.json'
import MessagesLanguageIT_IT from './it_IT/MessagesLanguage.json'
import MessagesLanguageNL_NL from './nl_NL/MessagesLanguage.json'
import MessagesLanguagePT_PT from './pt_PT/MessagesLanguage.json'

import MicrosoftSSODE_DE from './de_DE/MicrosoftSSO.json'
import MicrosoftSSOEN_GB from './en_GB/MicrosoftSSO.json'
import MicrosoftSSOEN_US from './en_US/MicrosoftSSO.json'
import MicrosoftSSOFR_FR from './fr_FR/MicrosoftSSO.json'
import MicrosoftSSOIT_IT from './it_IT/MicrosoftSSO.json'
import MicrosoftSSONL_NL from './nl_NL/MicrosoftSSO.json'
import MicrosoftSSOPT_PT from './pt_PT/MicrosoftSSO.json'

import MiscellaneousFilteringDE_DE from './de_DE/MiscellaneousFiltering.json'
import MiscellaneousFilteringEN_GB from './en_GB/MiscellaneousFiltering.json'
import MiscellaneousFilteringEN_US from './en_US/MiscellaneousFiltering.json'
import MiscellaneousFilteringFR_FR from './fr_FR/MiscellaneousFiltering.json'
import MiscellaneousFilteringIT_IT from './it_IT/MiscellaneousFiltering.json'
import MiscellaneousFilteringNL_NL from './nl_NL/MiscellaneousFiltering.json'
import MiscellaneousFilteringPT_PT from './pt_PT/MiscellaneousFiltering.json'

import MonetaryCallAssignmentsDE_DE from './de_DE/MonetaryCallAssignments.json'
import MonetaryCallAssignmentsEN_GB from './en_GB/MonetaryCallAssignments.json'
import MonetaryCallAssignmentsEN_US from './en_US/MonetaryCallAssignments.json'
import MonetaryCallAssignmentsFR_FR from './fr_FR/MonetaryCallAssignments.json'
import MonetaryCallAssignmentsIT_IT from './it_IT/MonetaryCallAssignments.json'
import MonetaryCallAssignmentsNL_NL from './nl_NL/MonetaryCallAssignments.json'
import MonetaryCallAssignmentsPT_PT from './pt_PT/MonetaryCallAssignments.json'

import NotificationsLanguageDE_DE from './de_DE/NotificationsLanguage.json'
import NotificationsLanguageEN_GB from './en_GB/NotificationsLanguage.json'
import NotificationsLanguageEN_US from './en_US/NotificationsLanguage.json'
import NotificationsLanguageFR_FR from './fr_FR/NotificationsLanguage.json'
import NotificationsLanguageIT_IT from './it_IT/NotificationsLanguage.json'
import NotificationsLanguageNL_NL from './nl_NL/NotificationsLanguage.json'
import NotificationsLanguagePT_PT from './pt_PT/NotificationsLanguage.json'

import NotificationsLanguageModalDE_DE from './de_DE/NotificationsLanguageModal.json'
import NotificationsLanguageModalEN_GB from './en_GB/NotificationsLanguageModal.json'
import NotificationsLanguageModalEN_US from './en_US/NotificationsLanguageModal.json'
import NotificationsLanguageModalFR_FR from './fr_FR/NotificationsLanguageModal.json'
import NotificationsLanguageModalIT_IT from './it_IT/NotificationsLanguageModal.json'
import NotificationsLanguageModalNL_NL from './nl_NL/NotificationsLanguageModal.json'
import NotificationsLanguageModalPT_PT from './pt_PT/NotificationsLanguageModal.json'

import OAuthButtonDE_DE from './de_DE/OAuthButton.json'
import OAuthButtonEN_GB from './en_GB/OAuthButton.json'
import OAuthButtonEN_US from './en_US/OAuthButton.json'
import OAuthButtonFR_FR from './fr_FR/OAuthButton.json'
import OAuthButtonIT_IT from './it_IT/OAuthButton.json'
import OAuthButtonNL_NL from './nl_NL/OAuthButton.json'
import OAuthButtonPT_PT from './pt_PT/OAuthButton.json'

import PaginatedListDE_DE from './de_DE/PaginatedList.json'
import PaginatedListEN_GB from './en_GB/PaginatedList.json'
import PaginatedListEN_US from './en_US/PaginatedList.json'
import PaginatedListFR_FR from './fr_FR/PaginatedList.json'
import PaginatedListIT_IT from './it_IT/PaginatedList.json'
import PaginatedListNL_NL from './nl_NL/PaginatedList.json'
import PaginatedListPT_PT from './pt_PT/PaginatedList.json'

import PartitionListLanguageDE_DE from './de_DE/PartitionListLanguage.json'
import PartitionListLanguageEN_GB from './en_GB/PartitionListLanguage.json'
import PartitionListLanguageEN_US from './en_US/PartitionListLanguage.json'
import PartitionListLanguageFR_FR from './fr_FR/PartitionListLanguage.json'
import PartitionListLanguageIT_IT from './it_IT/PartitionListLanguage.json'
import PartitionListLanguageNL_NL from './nl_NL/PartitionListLanguage.json'
import PartitionListLanguagePT_PT from './pt_PT/PartitionListLanguage.json'

import PartitionModalDE_DE from './de_DE/PartitionModal.json'
import PartitionModalEN_GB from './en_GB/PartitionModal.json'
import PartitionModalEN_US from './en_US/PartitionModal.json'
import PartitionModalFR_FR from './fr_FR/PartitionModal.json'
import PartitionModalIT_IT from './it_IT/PartitionModal.json'
import PartitionModalNL_NL from './nl_NL/PartitionModal.json'
import PartitionModalPT_PT from './pt_PT/PartitionModal.json'

import PasswordChangeLanguageDE_DE from './de_DE/PasswordChangeLanguage.json'
import PasswordChangeLanguageEN_GB from './en_GB/PasswordChangeLanguage.json'
import PasswordChangeLanguageEN_US from './en_US/PasswordChangeLanguage.json'
import PasswordChangeLanguageFR_FR from './fr_FR/PasswordChangeLanguage.json'
import PasswordChangeLanguageIT_IT from './it_IT/PasswordChangeLanguage.json'
import PasswordChangeLanguageNL_NL from './nl_NL/PasswordChangeLanguage.json'
import PasswordChangeLanguagePT_PT from './pt_PT/PasswordChangeLanguage.json'

import PasswordTextInputDE_DE from './de_DE/PasswordTextInput.json'
import PasswordTextInputEN_GB from './en_GB/PasswordTextInput.json'
import PasswordTextInputEN_US from './en_US/PasswordTextInput.json'
import PasswordTextInputFR_FR from './fr_FR/PasswordTextInput.json'
import PasswordTextInputIT_IT from './it_IT/PasswordTextInput.json'
import PasswordTextInputNL_NL from './nl_NL/PasswordTextInput.json'
import PasswordTextInputPT_PT from './pt_PT/PasswordTextInput.json'

import PermissionsLanguageDE_DE from './de_DE/PermissionsLanguage.json'
import PermissionsLanguageEN_GB from './en_GB/PermissionsLanguage.json'
import PermissionsLanguageEN_US from './en_US/PermissionsLanguage.json'
import PermissionsLanguageFR_FR from './fr_FR/PermissionsLanguage.json'
import PermissionsLanguageIT_IT from './it_IT/PermissionsLanguage.json'
import PermissionsLanguageNL_NL from './nl_NL/PermissionsLanguage.json'
import PermissionsLanguagePT_PT from './pt_PT/PermissionsLanguage.json'

import PresenceDE_DE from './de_DE/Presence.json'
import PresenceEN_GB from './en_GB/Presence.json'
import PresenceEN_US from './en_US/Presence.json'
import PresenceFR_FR from './fr_FR/Presence.json'
import PresenceIT_IT from './it_IT/Presence.json'
import PresenceNL_NL from './nl_NL/Presence.json'
import PresencePT_PT from './pt_PT/Presence.json'

import PreviewDE_DE from './de_DE/Preview.json'
import PreviewEN_GB from './en_GB/Preview.json'
import PreviewEN_US from './en_US/Preview.json'
import PreviewFR_FR from './fr_FR/Preview.json'
import PreviewIT_IT from './it_IT/Preview.json'
import PreviewNL_NL from './nl_NL/Preview.json'
import PreviewPT_PT from './pt_PT/Preview.json'

import PrintOutputDE_DE from './de_DE/PrintOutput.json'
import PrintOutputEN_GB from './en_GB/PrintOutput.json'
import PrintOutputEN_US from './en_US/PrintOutput.json'
import PrintOutputFR_FR from './fr_FR/PrintOutput.json'
import PrintOutputIT_IT from './it_IT/PrintOutput.json'
import PrintOutputNL_NL from './nl_NL/PrintOutput.json'
import PrintOutputPT_PT from './pt_PT/PrintOutput.json'

import ProvisioningDE_DE from './de_DE/Provisioning.json'
import ProvisioningEN_GB from './en_GB/Provisioning.json'
import ProvisioningEN_US from './en_US/Provisioning.json'
import ProvisioningFR_FR from './fr_FR/Provisioning.json'
import ProvisioningIT_IT from './it_IT/Provisioning.json'
import ProvisioningNL_NL from './nl_NL/Provisioning.json'
import ProvisioningPT_PT from './pt_PT/Provisioning.json'

import RangeComboLanguageDE_DE from './de_DE/RangeComboLanguage.json'
import RangeComboLanguageEN_GB from './en_GB/RangeComboLanguage.json'
import RangeComboLanguageEN_US from './en_US/RangeComboLanguage.json'
import RangeComboLanguageFR_FR from './fr_FR/RangeComboLanguage.json'
import RangeComboLanguageIT_IT from './it_IT/RangeComboLanguage.json'
import RangeComboLanguageNL_NL from './nl_NL/RangeComboLanguage.json'
import RangeComboLanguagePT_PT from './pt_PT/RangeComboLanguage.json'

import RecordingListLanguageDE_DE from './de_DE/RecordingListLanguage.json'
import RecordingListLanguageEN_GB from './en_GB/RecordingListLanguage.json'
import RecordingListLanguageEN_US from './en_US/RecordingListLanguage.json'
import RecordingListLanguageFR_FR from './fr_FR/RecordingListLanguage.json'
import RecordingListLanguageIT_IT from './it_IT/RecordingListLanguage.json'
import RecordingListLanguageNL_NL from './nl_NL/RecordingListLanguage.json'
import RecordingListLanguagePT_PT from './pt_PT/RecordingListLanguage.json'

import ReportContentRowsSettingsLanguageDE_DE from './de_DE/ReportContentRowsSettingsLanguage.json'
import ReportContentRowsSettingsLanguageEN_GB from './en_GB/ReportContentRowsSettingsLanguage.json'
import ReportContentRowsSettingsLanguageEN_US from './en_US/ReportContentRowsSettingsLanguage.json'
import ReportContentRowsSettingsLanguageFR_FR from './fr_FR/ReportContentRowsSettingsLanguage.json'
import ReportContentRowsSettingsLanguageIT_IT from './it_IT/ReportContentRowsSettingsLanguage.json'
import ReportContentRowsSettingsLanguageNL_NL from './nl_NL/ReportContentRowsSettingsLanguage.json'
import ReportContentRowsSettingsLanguagePT_PT from './pt_PT/ReportContentRowsSettingsLanguage.json'

import ReportIntervalLanguageDE_DE from './de_DE/ReportIntervalLanguage.json'
import ReportIntervalLanguageEN_GB from './en_GB/ReportIntervalLanguage.json'
import ReportIntervalLanguageEN_US from './en_US/ReportIntervalLanguage.json'
import ReportIntervalLanguageFR_FR from './fr_FR/ReportIntervalLanguage.json'
import ReportIntervalLanguageIT_IT from './it_IT/ReportIntervalLanguage.json'
import ReportIntervalLanguageNL_NL from './nl_NL/ReportIntervalLanguage.json'
import ReportIntervalLanguagePT_PT from './pt_PT/ReportIntervalLanguage.json'

import ReportOptionsDE_DE from './de_DE/ReportOptions.json'
import ReportOptionsEN_GB from './en_GB/ReportOptions.json'
import ReportOptionsEN_US from './en_US/ReportOptions.json'
import ReportOptionsFR_FR from './fr_FR/ReportOptions.json'
import ReportOptionsIT_IT from './it_IT/ReportOptions.json'
import ReportOptionsNL_NL from './nl_NL/ReportOptions.json'
import ReportOptionsPT_PT from './pt_PT/ReportOptions.json'

import ReportPortalInfoDE_DE from './de_DE/ReportPortalInfo.json'
import ReportPortalInfoEN_GB from './en_GB/ReportPortalInfo.json'
import ReportPortalInfoEN_US from './en_US/ReportPortalInfo.json'
import ReportPortalInfoFR_FR from './fr_FR/ReportPortalInfo.json'
import ReportPortalInfoIT_IT from './it_IT/ReportPortalInfo.json'
import ReportPortalInfoNL_NL from './nl_NL/ReportPortalInfo.json'
import ReportPortalInfoPT_PT from './pt_PT/ReportPortalInfo.json'

import ReportSchedulingDE_DE from './de_DE/ReportScheduling.json'
import ReportSchedulingEN_GB from './en_GB/ReportScheduling.json'
import ReportSchedulingEN_US from './en_US/ReportScheduling.json'
import ReportSchedulingFR_FR from './fr_FR/ReportScheduling.json'
import ReportSchedulingIT_IT from './it_IT/ReportScheduling.json'
import ReportSchedulingNL_NL from './nl_NL/ReportScheduling.json'
import ReportSchedulingPT_PT from './pt_PT/ReportScheduling.json'

import ReportSchedulingEmailsDE_DE from './de_DE/ReportSchedulingEmails.json'
import ReportSchedulingEmailsEN_GB from './en_GB/ReportSchedulingEmails.json'
import ReportSchedulingEmailsEN_US from './en_US/ReportSchedulingEmails.json'
import ReportSchedulingEmailsFR_FR from './fr_FR/ReportSchedulingEmails.json'
import ReportSchedulingEmailsIT_IT from './it_IT/ReportSchedulingEmails.json'
import ReportSchedulingEmailsNL_NL from './nl_NL/ReportSchedulingEmails.json'
import ReportSchedulingEmailsPT_PT from './pt_PT/ReportSchedulingEmails.json'

import ReportTypesDE_DE from './de_DE/ReportTypes.json'
import ReportTypesEN_GB from './en_GB/ReportTypes.json'
import ReportTypesEN_US from './en_US/ReportTypes.json'
import ReportTypesFR_FR from './fr_FR/ReportTypes.json'
import ReportTypesIT_IT from './it_IT/ReportTypes.json'
import ReportTypesNL_NL from './nl_NL/ReportTypes.json'
import ReportTypesPT_PT from './pt_PT/ReportTypes.json'

import ReportingDefaultReportSetsDE_DE from './de_DE/ReportingDefaultReportSets.json'
import ReportingDefaultReportSetsEN_GB from './en_GB/ReportingDefaultReportSets.json'
import ReportingDefaultReportSetsEN_US from './en_US/ReportingDefaultReportSets.json'
import ReportingDefaultReportSetsFR_FR from './fr_FR/ReportingDefaultReportSets.json'
import ReportingDefaultReportSetsIT_IT from './it_IT/ReportingDefaultReportSets.json'
import ReportingDefaultReportSetsNL_NL from './nl_NL/ReportingDefaultReportSets.json'
import ReportingDefaultReportSetsPT_PT from './pt_PT/ReportingDefaultReportSets.json'

import ReportingLanguageDE_DE from './de_DE/ReportingLanguage.json'
import ReportingLanguageEN_GB from './en_GB/ReportingLanguage.json'
import ReportingLanguageEN_US from './en_US/ReportingLanguage.json'
import ReportingLanguageFR_FR from './fr_FR/ReportingLanguage.json'
import ReportingLanguageIT_IT from './it_IT/ReportingLanguage.json'
import ReportingLanguageNL_NL from './nl_NL/ReportingLanguage.json'
import ReportingLanguagePT_PT from './pt_PT/ReportingLanguage.json'

import ReportingMenuLanguageDE_DE from './de_DE/ReportingMenuLanguage.json'
import ReportingMenuLanguageEN_GB from './en_GB/ReportingMenuLanguage.json'
import ReportingMenuLanguageEN_US from './en_US/ReportingMenuLanguage.json'
import ReportingMenuLanguageFR_FR from './fr_FR/ReportingMenuLanguage.json'
import ReportingMenuLanguageIT_IT from './it_IT/ReportingMenuLanguage.json'
import ReportingMenuLanguageNL_NL from './nl_NL/ReportingMenuLanguage.json'
import ReportingMenuLanguagePT_PT from './pt_PT/ReportingMenuLanguage.json'

import ReportsFilterDeviceFilterDE_DE from './de_DE/ReportsFilterDeviceFilter.json'
import ReportsFilterDeviceFilterEN_GB from './en_GB/ReportsFilterDeviceFilter.json'
import ReportsFilterDeviceFilterEN_US from './en_US/ReportsFilterDeviceFilter.json'
import ReportsFilterDeviceFilterFR_FR from './fr_FR/ReportsFilterDeviceFilter.json'
import ReportsFilterDeviceFilterIT_IT from './it_IT/ReportsFilterDeviceFilter.json'
import ReportsFilterDeviceFilterNL_NL from './nl_NL/ReportsFilterDeviceFilter.json'
import ReportsFilterDeviceFilterPT_PT from './pt_PT/ReportsFilterDeviceFilter.json'

import RichTextEditorDE_DE from './de_DE/RichTextEditor.json'
import RichTextEditorEN_GB from './en_GB/RichTextEditor.json'
import RichTextEditorEN_US from './en_US/RichTextEditor.json'
import RichTextEditorFR_FR from './fr_FR/RichTextEditor.json'
import RichTextEditorIT_IT from './it_IT/RichTextEditor.json'
import RichTextEditorNL_NL from './nl_NL/RichTextEditor.json'
import RichTextEditorPT_PT from './pt_PT/RichTextEditor.json'

import RoleLanguageDE_DE from './de_DE/RoleLanguage.json'
import RoleLanguageEN_GB from './en_GB/RoleLanguage.json'
import RoleLanguageEN_US from './en_US/RoleLanguage.json'
import RoleLanguageFR_FR from './fr_FR/RoleLanguage.json'
import RoleLanguageIT_IT from './it_IT/RoleLanguage.json'
import RoleLanguageNL_NL from './nl_NL/RoleLanguage.json'
import RoleLanguagePT_PT from './pt_PT/RoleLanguage.json'

import RouterDE_DE from './de_DE/Router.json'
import RouterEN_GB from './en_GB/Router.json'
import RouterEN_US from './en_US/Router.json'
import RouterFR_FR from './fr_FR/Router.json'
import RouterIT_IT from './it_IT/Router.json'
import RouterNL_NL from './nl_NL/Router.json'
import RouterPT_PT from './pt_PT/Router.json'

import RowOptionsDE_DE from './de_DE/RowOptions.json'
import RowOptionsEN_GB from './en_GB/RowOptions.json'
import RowOptionsEN_US from './en_US/RowOptions.json'
import RowOptionsFR_FR from './fr_FR/RowOptions.json'
import RowOptionsIT_IT from './it_IT/RowOptions.json'
import RowOptionsNL_NL from './nl_NL/RowOptions.json'
import RowOptionsPT_PT from './pt_PT/RowOptions.json'

import RulesLanguageDE_DE from './de_DE/RulesLanguage.json'
import RulesLanguageEN_GB from './en_GB/RulesLanguage.json'
import RulesLanguageEN_US from './en_US/RulesLanguage.json'
import RulesLanguageFR_FR from './fr_FR/RulesLanguage.json'
import RulesLanguageIT_IT from './it_IT/RulesLanguage.json'
import RulesLanguageNL_NL from './nl_NL/RulesLanguage.json'
import RulesLanguagePT_PT from './pt_PT/RulesLanguage.json'

import SSOLanguageDE_DE from './de_DE/SSOLanguage.json'
import SSOLanguageEN_GB from './en_GB/SSOLanguage.json'
import SSOLanguageEN_US from './en_US/SSOLanguage.json'
import SSOLanguageFR_FR from './fr_FR/SSOLanguage.json'
import SSOLanguageIT_IT from './it_IT/SSOLanguage.json'
import SSOLanguageNL_NL from './nl_NL/SSOLanguage.json'
import SSOLanguagePT_PT from './pt_PT/SSOLanguage.json'

import ScheduleStatusDE_DE from './de_DE/ScheduleStatus.json'
import ScheduleStatusEN_GB from './en_GB/ScheduleStatus.json'
import ScheduleStatusEN_US from './en_US/ScheduleStatus.json'
import ScheduleStatusFR_FR from './fr_FR/ScheduleStatus.json'
import ScheduleStatusIT_IT from './it_IT/ScheduleStatus.json'
import ScheduleStatusNL_NL from './nl_NL/ScheduleStatus.json'
import ScheduleStatusPT_PT from './pt_PT/ScheduleStatus.json'

import ScopeAssignmentDE_DE from './de_DE/ScopeAssignment.json'
import ScopeAssignmentEN_GB from './en_GB/ScopeAssignment.json'
import ScopeAssignmentEN_US from './en_US/ScopeAssignment.json'
import ScopeAssignmentFR_FR from './fr_FR/ScopeAssignment.json'
import ScopeAssignmentIT_IT from './it_IT/ScopeAssignment.json'
import ScopeAssignmentNL_NL from './nl_NL/ScopeAssignment.json'
import ScopeAssignmentPT_PT from './pt_PT/ScopeAssignment.json'

import ScopeFilteringDE_DE from './de_DE/ScopeFiltering.json'
import ScopeFilteringEN_GB from './en_GB/ScopeFiltering.json'
import ScopeFilteringEN_US from './en_US/ScopeFiltering.json'
import ScopeFilteringFR_FR from './fr_FR/ScopeFiltering.json'
import ScopeFilteringIT_IT from './it_IT/ScopeFiltering.json'
import ScopeFilteringNL_NL from './nl_NL/ScopeFiltering.json'
import ScopeFilteringPT_PT from './pt_PT/ScopeFiltering.json'

import SelfProvisioningDE_DE from './de_DE/SelfProvisioning.json'
import SelfProvisioningEN_GB from './en_GB/SelfProvisioning.json'
import SelfProvisioningEN_US from './en_US/SelfProvisioning.json'
import SelfProvisioningFR_FR from './fr_FR/SelfProvisioning.json'
import SelfProvisioningIT_IT from './it_IT/SelfProvisioning.json'
import SelfProvisioningNL_NL from './nl_NL/SelfProvisioning.json'
import SelfProvisioningPT_PT from './pt_PT/SelfProvisioning.json'

import ServerStatusLanguageDE_DE from './de_DE/ServerStatusLanguage.json'
import ServerStatusLanguageEN_GB from './en_GB/ServerStatusLanguage.json'
import ServerStatusLanguageEN_US from './en_US/ServerStatusLanguage.json'
import ServerStatusLanguageFR_FR from './fr_FR/ServerStatusLanguage.json'
import ServerStatusLanguageIT_IT from './it_IT/ServerStatusLanguage.json'
import ServerStatusLanguageNL_NL from './nl_NL/ServerStatusLanguage.json'
import ServerStatusLanguagePT_PT from './pt_PT/ServerStatusLanguage.json'

import ServiceLvlSettingsDE_DE from './de_DE/ServiceLvlSettings.json'
import ServiceLvlSettingsEN_GB from './en_GB/ServiceLvlSettings.json'
import ServiceLvlSettingsEN_US from './en_US/ServiceLvlSettings.json'
import ServiceLvlSettingsFR_FR from './fr_FR/ServiceLvlSettings.json'
import ServiceLvlSettingsIT_IT from './it_IT/ServiceLvlSettings.json'
import ServiceLvlSettingsNL_NL from './nl_NL/ServiceLvlSettings.json'
import ServiceLvlSettingsPT_PT from './pt_PT/ServiceLvlSettings.json'

import ServiceMessagesLanguageDE_DE from './de_DE/ServiceMessagesLanguage.json'
import ServiceMessagesLanguageEN_GB from './en_GB/ServiceMessagesLanguage.json'
import ServiceMessagesLanguageEN_US from './en_US/ServiceMessagesLanguage.json'
import ServiceMessagesLanguageFR_FR from './fr_FR/ServiceMessagesLanguage.json'
import ServiceMessagesLanguageIT_IT from './it_IT/ServiceMessagesLanguage.json'
import ServiceMessagesLanguageNL_NL from './nl_NL/ServiceMessagesLanguage.json'
import ServiceMessagesLanguagePT_PT from './pt_PT/ServiceMessagesLanguage.json'

import SettingsLanguageDE_DE from './de_DE/SettingsLanguage.json'
import SettingsLanguageEN_GB from './en_GB/SettingsLanguage.json'
import SettingsLanguageEN_US from './en_US/SettingsLanguage.json'
import SettingsLanguageFR_FR from './fr_FR/SettingsLanguage.json'
import SettingsLanguageIT_IT from './it_IT/SettingsLanguage.json'
import SettingsLanguageNL_NL from './nl_NL/SettingsLanguage.json'
import SettingsLanguagePT_PT from './pt_PT/SettingsLanguage.json'

import SidebarMenuDE_DE from './de_DE/SidebarMenu.json'
import SidebarMenuEN_GB from './en_GB/SidebarMenu.json'
import SidebarMenuEN_US from './en_US/SidebarMenu.json'
import SidebarMenuFR_FR from './fr_FR/SidebarMenu.json'
import SidebarMenuIT_IT from './it_IT/SidebarMenu.json'
import SidebarMenuNL_NL from './nl_NL/SidebarMenu.json'
import SidebarMenuPT_PT from './pt_PT/SidebarMenu.json'

import SignInWithDE_DE from './de_DE/SignInWith.json'
import SignInWithEN_GB from './en_GB/SignInWith.json'
import SignInWithEN_US from './en_US/SignInWith.json'
import SignInWithFR_FR from './fr_FR/SignInWith.json'
import SignInWithIT_IT from './it_IT/SignInWith.json'
import SignInWithNL_NL from './nl_NL/SignInWith.json'
import SignInWithPT_PT from './pt_PT/SignInWith.json'

import SortListDE_DE from './de_DE/SortList.json'
import SortListEN_GB from './en_GB/SortList.json'
import SortListEN_US from './en_US/SortList.json'
import SortListFR_FR from './fr_FR/SortList.json'
import SortListIT_IT from './it_IT/SortList.json'
import SortListNL_NL from './nl_NL/SortList.json'
import SortListPT_PT from './pt_PT/SortList.json'

import StaticAgentControlsDE_DE from './de_DE/StaticAgentControls.json'
import StaticAgentControlsEN_GB from './en_GB/StaticAgentControls.json'
import StaticAgentControlsEN_US from './en_US/StaticAgentControls.json'
import StaticAgentControlsFR_FR from './fr_FR/StaticAgentControls.json'
import StaticAgentControlsIT_IT from './it_IT/StaticAgentControls.json'
import StaticAgentControlsNL_NL from './nl_NL/StaticAgentControls.json'
import StaticAgentControlsPT_PT from './pt_PT/StaticAgentControls.json'

import StatisticAlarmDE_DE from './de_DE/StatisticAlarm.json'
import StatisticAlarmEN_GB from './en_GB/StatisticAlarm.json'
import StatisticAlarmEN_US from './en_US/StatisticAlarm.json'
import StatisticAlarmFR_FR from './fr_FR/StatisticAlarm.json'
import StatisticAlarmIT_IT from './it_IT/StatisticAlarm.json'
import StatisticAlarmNL_NL from './nl_NL/StatisticAlarm.json'
import StatisticAlarmPT_PT from './pt_PT/StatisticAlarm.json'

import StatisticCalculationsDE_DE from './de_DE/StatisticCalculations.json'
import StatisticCalculationsEN_GB from './en_GB/StatisticCalculations.json'
import StatisticCalculationsEN_US from './en_US/StatisticCalculations.json'
import StatisticCalculationsFR_FR from './fr_FR/StatisticCalculations.json'
import StatisticCalculationsIT_IT from './it_IT/StatisticCalculations.json'
import StatisticCalculationsNL_NL from './nl_NL/StatisticCalculations.json'
import StatisticCalculationsPT_PT from './pt_PT/StatisticCalculations.json'

import StatusChangeDE_DE from './de_DE/StatusChange.json'
import StatusChangeEN_GB from './en_GB/StatusChange.json'
import StatusChangeEN_US from './en_US/StatusChange.json'
import StatusChangeFR_FR from './fr_FR/StatusChange.json'
import StatusChangeIT_IT from './it_IT/StatusChange.json'
import StatusChangeNL_NL from './nl_NL/StatusChange.json'
import StatusChangePT_PT from './pt_PT/StatusChange.json'

import TalkTimeDE_DE from './de_DE/TalkTime.json'
import TalkTimeEN_GB from './en_GB/TalkTime.json'
import TalkTimeEN_US from './en_US/TalkTime.json'
import TalkTimeFR_FR from './fr_FR/TalkTime.json'
import TalkTimeIT_IT from './it_IT/TalkTime.json'
import TalkTimeNL_NL from './nl_NL/TalkTime.json'
import TalkTimePT_PT from './pt_PT/TalkTime.json'

import TeamsAuthDE_DE from './de_DE/TeamsAuth.json'
import TeamsAuthEN_GB from './en_GB/TeamsAuth.json'
import TeamsAuthEN_US from './en_US/TeamsAuth.json'
import TeamsAuthFR_FR from './fr_FR/TeamsAuth.json'
import TeamsAuthIT_IT from './it_IT/TeamsAuth.json'
import TeamsAuthNL_NL from './nl_NL/TeamsAuth.json'
import TeamsAuthPT_PT from './pt_PT/TeamsAuth.json'

import TelModuleStatusListLanguageDE_DE from './de_DE/TelModuleStatusListLanguage.json'
import TelModuleStatusListLanguageEN_GB from './en_GB/TelModuleStatusListLanguage.json'
import TelModuleStatusListLanguageEN_US from './en_US/TelModuleStatusListLanguage.json'
import TelModuleStatusListLanguageFR_FR from './fr_FR/TelModuleStatusListLanguage.json'
import TelModuleStatusListLanguageIT_IT from './it_IT/TelModuleStatusListLanguage.json'
import TelModuleStatusListLanguageNL_NL from './nl_NL/TelModuleStatusListLanguage.json'
import TelModuleStatusListLanguagePT_PT from './pt_PT/TelModuleStatusListLanguage.json'

import TelSysConfigurationDE_DE from './de_DE/TelSysConfiguration.json'
import TelSysConfigurationEN_GB from './en_GB/TelSysConfiguration.json'
import TelSysConfigurationEN_US from './en_US/TelSysConfiguration.json'
import TelSysConfigurationFR_FR from './fr_FR/TelSysConfiguration.json'
import TelSysConfigurationIT_IT from './it_IT/TelSysConfiguration.json'
import TelSysConfigurationNL_NL from './nl_NL/TelSysConfiguration.json'
import TelSysConfigurationPT_PT from './pt_PT/TelSysConfiguration.json'

import TelsysListLanguageDE_DE from './de_DE/TelsysListLanguage.json'
import TelsysListLanguageEN_GB from './en_GB/TelsysListLanguage.json'
import TelsysListLanguageEN_US from './en_US/TelsysListLanguage.json'
import TelsysListLanguageFR_FR from './fr_FR/TelsysListLanguage.json'
import TelsysListLanguageIT_IT from './it_IT/TelsysListLanguage.json'
import TelsysListLanguageNL_NL from './nl_NL/TelsysListLanguage.json'
import TelsysListLanguagePT_PT from './pt_PT/TelsysListLanguage.json'

import TermsAndConditionsDE_DE from './de_DE/TermsAndConditions.json'
import TermsAndConditionsEN_GB from './en_GB/TermsAndConditions.json'
import TermsAndConditionsEN_US from './en_US/TermsAndConditions.json'
import TermsAndConditionsFR_FR from './fr_FR/TermsAndConditions.json'
import TermsAndConditionsIT_IT from './it_IT/TermsAndConditions.json'
import TermsAndConditionsNL_NL from './nl_NL/TermsAndConditions.json'
import TermsAndConditionsPT_PT from './pt_PT/TermsAndConditions.json'

import TextInputDropDownDE_DE from './de_DE/TextInputDropDown.json'
import TextInputDropDownEN_GB from './en_GB/TextInputDropDown.json'
import TextInputDropDownEN_US from './en_US/TextInputDropDown.json'
import TextInputDropDownFR_FR from './fr_FR/TextInputDropDown.json'
import TextInputDropDownIT_IT from './it_IT/TextInputDropDown.json'
import TextInputDropDownNL_NL from './nl_NL/TextInputDropDown.json'
import TextInputDropDownPT_PT from './pt_PT/TextInputDropDown.json'

import TimeFormatsDE_DE from './de_DE/TimeFormats.json'
import TimeFormatsEN_GB from './en_GB/TimeFormats.json'
import TimeFormatsEN_US from './en_US/TimeFormats.json'
import TimeFormatsFR_FR from './fr_FR/TimeFormats.json'
import TimeFormatsIT_IT from './it_IT/TimeFormats.json'
import TimeFormatsNL_NL from './nl_NL/TimeFormats.json'
import TimeFormatsPT_PT from './pt_PT/TimeFormats.json'

import TimeOptionsDE_DE from './de_DE/TimeOptions.json'
import TimeOptionsEN_GB from './en_GB/TimeOptions.json'
import TimeOptionsEN_US from './en_US/TimeOptions.json'
import TimeOptionsFR_FR from './fr_FR/TimeOptions.json'
import TimeOptionsIT_IT from './it_IT/TimeOptions.json'
import TimeOptionsNL_NL from './nl_NL/TimeOptions.json'
import TimeOptionsPT_PT from './pt_PT/TimeOptions.json'

import TimezoneDE_DE from './de_DE/Timezone.json'
import TimezoneEN_GB from './en_GB/Timezone.json'
import TimezoneEN_US from './en_US/Timezone.json'
import TimezoneFR_FR from './fr_FR/Timezone.json'
import TimezoneIT_IT from './it_IT/Timezone.json'
import TimezoneNL_NL from './nl_NL/Timezone.json'
import TimezonePT_PT from './pt_PT/Timezone.json'

import TimezoneModalDE_DE from './de_DE/TimezoneModal.json'
import TimezoneModalEN_GB from './en_GB/TimezoneModal.json'
import TimezoneModalEN_US from './en_US/TimezoneModal.json'
import TimezoneModalFR_FR from './fr_FR/TimezoneModal.json'
import TimezoneModalIT_IT from './it_IT/TimezoneModal.json'
import TimezoneModalNL_NL from './nl_NL/TimezoneModal.json'
import TimezoneModalPT_PT from './pt_PT/TimezoneModal.json'

import UnreturnedCallsDE_DE from './de_DE/UnreturnedCalls.json'
import UnreturnedCallsEN_GB from './en_GB/UnreturnedCalls.json'
import UnreturnedCallsEN_US from './en_US/UnreturnedCalls.json'
import UnreturnedCallsFR_FR from './fr_FR/UnreturnedCalls.json'
import UnreturnedCallsIT_IT from './it_IT/UnreturnedCalls.json'
import UnreturnedCallsNL_NL from './nl_NL/UnreturnedCalls.json'
import UnreturnedCallsPT_PT from './pt_PT/UnreturnedCalls.json'

import UnreturnedCallsFilterDE_DE from './de_DE/UnreturnedCallsFilter.json'
import UnreturnedCallsFilterEN_GB from './en_GB/UnreturnedCallsFilter.json'
import UnreturnedCallsFilterEN_US from './en_US/UnreturnedCallsFilter.json'
import UnreturnedCallsFilterFR_FR from './fr_FR/UnreturnedCallsFilter.json'
import UnreturnedCallsFilterIT_IT from './it_IT/UnreturnedCallsFilter.json'
import UnreturnedCallsFilterNL_NL from './nl_NL/UnreturnedCallsFilter.json'
import UnreturnedCallsFilterPT_PT from './pt_PT/UnreturnedCallsFilter.json'

import UserDetailsLanguageDE_DE from './de_DE/UserDetailsLanguage.json'
import UserDetailsLanguageEN_GB from './en_GB/UserDetailsLanguage.json'
import UserDetailsLanguageEN_US from './en_US/UserDetailsLanguage.json'
import UserDetailsLanguageFR_FR from './fr_FR/UserDetailsLanguage.json'
import UserDetailsLanguageIT_IT from './it_IT/UserDetailsLanguage.json'
import UserDetailsLanguageNL_NL from './nl_NL/UserDetailsLanguage.json'
import UserDetailsLanguagePT_PT from './pt_PT/UserDetailsLanguage.json'

import UserInviteDE_DE from './de_DE/UserInvite.json'
import UserInviteEN_GB from './en_GB/UserInvite.json'
import UserInviteEN_US from './en_US/UserInvite.json'
import UserInviteFR_FR from './fr_FR/UserInvite.json'
import UserInviteIT_IT from './it_IT/UserInvite.json'
import UserInviteNL_NL from './nl_NL/UserInvite.json'
import UserInvitePT_PT from './pt_PT/UserInvite.json'

import UserMenuDE_DE from './de_DE/UserMenu.json'
import UserMenuEN_GB from './en_GB/UserMenu.json'
import UserMenuEN_US from './en_US/UserMenu.json'
import UserMenuFR_FR from './fr_FR/UserMenu.json'
import UserMenuIT_IT from './it_IT/UserMenu.json'
import UserMenuNL_NL from './nl_NL/UserMenu.json'
import UserMenuPT_PT from './pt_PT/UserMenu.json'

import UserNotificationTypesHelpDE_DE from './de_DE/UserNotificationTypesHelp.json'
import UserNotificationTypesHelpEN_GB from './en_GB/UserNotificationTypesHelp.json'
import UserNotificationTypesHelpEN_US from './en_US/UserNotificationTypesHelp.json'
import UserNotificationTypesHelpFR_FR from './fr_FR/UserNotificationTypesHelp.json'
import UserNotificationTypesHelpIT_IT from './it_IT/UserNotificationTypesHelp.json'
import UserNotificationTypesHelpNL_NL from './nl_NL/UserNotificationTypesHelp.json'
import UserNotificationTypesHelpPT_PT from './pt_PT/UserNotificationTypesHelp.json'

import UserTourDE_DE from './de_DE/UserTour.json'
import UserTourEN_GB from './en_GB/UserTour.json'
import UserTourEN_US from './en_US/UserTour.json'
import UserTourFR_FR from './fr_FR/UserTour.json'
import UserTourIT_IT from './it_IT/UserTour.json'
import UserTourNL_NL from './nl_NL/UserTour.json'
import UserTourPT_PT from './pt_PT/UserTour.json'

import UsersByExtensionDE_DE from './de_DE/UsersByExtension.json'
import UsersByExtensionEN_GB from './en_GB/UsersByExtension.json'
import UsersByExtensionEN_US from './en_US/UsersByExtension.json'
import UsersByExtensionFR_FR from './fr_FR/UsersByExtension.json'
import UsersByExtensionIT_IT from './it_IT/UsersByExtension.json'
import UsersByExtensionNL_NL from './nl_NL/UsersByExtension.json'
import UsersByExtensionPT_PT from './pt_PT/UsersByExtension.json'

import UsersListLanguageDE_DE from './de_DE/UsersListLanguage.json'
import UsersListLanguageEN_GB from './en_GB/UsersListLanguage.json'
import UsersListLanguageEN_US from './en_US/UsersListLanguage.json'
import UsersListLanguageFR_FR from './fr_FR/UsersListLanguage.json'
import UsersListLanguageIT_IT from './it_IT/UsersListLanguage.json'
import UsersListLanguageNL_NL from './nl_NL/UsersListLanguage.json'
import UsersListLanguagePT_PT from './pt_PT/UsersListLanguage.json'

import WebexAuthLanguageDE_DE from './de_DE/WebexAuthLanguage.json'
import WebexAuthLanguageEN_GB from './en_GB/WebexAuthLanguage.json'
import WebexAuthLanguageEN_US from './en_US/WebexAuthLanguage.json'
import WebexAuthLanguageFR_FR from './fr_FR/WebexAuthLanguage.json'
import WebexAuthLanguageIT_IT from './it_IT/WebexAuthLanguage.json'
import WebexAuthLanguageNL_NL from './nl_NL/WebexAuthLanguage.json'
import WebexAuthLanguagePT_PT from './pt_PT/WebexAuthLanguage.json'

export type AvailableLanguages = {
    i18nBundles: Record<string, NamedEnumLike<unknown>>
}

export type AvailableLanguageBundle = {
    keys: NamedEnumLike<unknown>
} & AvailableLanguages['i18nBundles']

export const languageItems = {
    ACDCodesLanguage: {
        ...createLanguageEnum(ACDCodesLanguageEN_GB),
        i18nBundles: {
            de_DE: ACDCodesLanguageDE_DE,
            en_GB: ACDCodesLanguageEN_GB,
            en_US: ACDCodesLanguageEN_US,
            fr_FR: ACDCodesLanguageFR_FR,
            it_IT: ACDCodesLanguageIT_IT,
            nl_NL: ACDCodesLanguageNL_NL,
            pt_PT: ACDCodesLanguagePT_PT
        }
    },
    ACDDNDActivity: {
        ...createLanguageEnum(ACDDNDActivityEN_GB),
        i18nBundles: {
            de_DE: ACDDNDActivityDE_DE,
            en_GB: ACDDNDActivityEN_GB,
            en_US: ACDDNDActivityEN_US,
            fr_FR: ACDDNDActivityFR_FR,
            it_IT: ACDDNDActivityIT_IT,
            nl_NL: ACDDNDActivityNL_NL,
            pt_PT: ACDDNDActivityPT_PT
        }
    },
    ACDStateThresholds: {
        ...createLanguageEnum(ACDStateThresholdsEN_GB),
        i18nBundles: {
            de_DE: ACDStateThresholdsDE_DE,
            en_GB: ACDStateThresholdsEN_GB,
            en_US: ACDStateThresholdsEN_US,
            fr_FR: ACDStateThresholdsFR_FR,
            it_IT: ACDStateThresholdsIT_IT,
            nl_NL: ACDStateThresholdsNL_NL,
            pt_PT: ACDStateThresholdsPT_PT
        }
    },
    ACDStatusHotKeys: {
        ...createLanguageEnum(ACDStatusHotKeysEN_GB),
        i18nBundles: {
            de_DE: ACDStatusHotKeysDE_DE,
            en_GB: ACDStatusHotKeysEN_GB,
            en_US: ACDStatusHotKeysEN_US,
            fr_FR: ACDStatusHotKeysFR_FR,
            it_IT: ACDStatusHotKeysIT_IT,
            nl_NL: ACDStatusHotKeysNL_NL,
            pt_PT: ACDStatusHotKeysPT_PT
        }
    },
    AbandonedCallAlarm: {
        ...createLanguageEnum(AbandonedCallAlarmEN_GB),
        i18nBundles: {
            de_DE: AbandonedCallAlarmDE_DE,
            en_GB: AbandonedCallAlarmEN_GB,
            en_US: AbandonedCallAlarmEN_US,
            fr_FR: AbandonedCallAlarmFR_FR,
            it_IT: AbandonedCallAlarmIT_IT,
            nl_NL: AbandonedCallAlarmNL_NL,
            pt_PT: AbandonedCallAlarmPT_PT
        }
    },
    AbandonedTimeStatisticLanguage: {
        ...createLanguageEnum(AbandonedTimeStatisticLanguageEN_GB),
        i18nBundles: {
            de_DE: AbandonedTimeStatisticLanguageDE_DE,
            en_GB: AbandonedTimeStatisticLanguageEN_GB,
            en_US: AbandonedTimeStatisticLanguageEN_US,
            fr_FR: AbandonedTimeStatisticLanguageFR_FR,
            it_IT: AbandonedTimeStatisticLanguageIT_IT,
            nl_NL: AbandonedTimeStatisticLanguageNL_NL,
            pt_PT: AbandonedTimeStatisticLanguagePT_PT
        }
    },
    AddUserLanguage: {
        ...createLanguageEnum(AddUserLanguageEN_GB),
        i18nBundles: {
            de_DE: AddUserLanguageDE_DE,
            en_GB: AddUserLanguageEN_GB,
            en_US: AddUserLanguageEN_US,
            fr_FR: AddUserLanguageFR_FR,
            it_IT: AddUserLanguageIT_IT,
            nl_NL: AddUserLanguageNL_NL,
            pt_PT: AddUserLanguagePT_PT
        }
    },
    AdminActionsLanguage: {
        ...createLanguageEnum(AdminActionsLanguageEN_GB),
        i18nBundles: {
            de_DE: AdminActionsLanguageDE_DE,
            en_GB: AdminActionsLanguageEN_GB,
            en_US: AdminActionsLanguageEN_US,
            fr_FR: AdminActionsLanguageFR_FR,
            it_IT: AdminActionsLanguageIT_IT,
            nl_NL: AdminActionsLanguageNL_NL,
            pt_PT: AdminActionsLanguagePT_PT
        }
    },
    AdminOverviewLanguage: {
        ...createLanguageEnum(AdminOverviewLanguageEN_GB),
        i18nBundles: {
            de_DE: AdminOverviewLanguageDE_DE,
            en_GB: AdminOverviewLanguageEN_GB,
            en_US: AdminOverviewLanguageEN_US,
            fr_FR: AdminOverviewLanguageFR_FR,
            it_IT: AdminOverviewLanguageIT_IT,
            nl_NL: AdminOverviewLanguageNL_NL,
            pt_PT: AdminOverviewLanguagePT_PT
        }
    },
    AdministratorLanguage: {
        ...createLanguageEnum(AdministratorLanguageEN_GB),
        i18nBundles: {
            de_DE: AdministratorLanguageDE_DE,
            en_GB: AdministratorLanguageEN_GB,
            en_US: AdministratorLanguageEN_US,
            fr_FR: AdministratorLanguageFR_FR,
            it_IT: AdministratorLanguageIT_IT,
            nl_NL: AdministratorLanguageNL_NL,
            pt_PT: AdministratorLanguagePT_PT
        }
    },
    Advanced: {
        ...createLanguageEnum(AdvancedEN_GB),
        i18nBundles: {
            de_DE: AdvancedDE_DE,
            en_GB: AdvancedEN_GB,
            en_US: AdvancedEN_US,
            fr_FR: AdvancedFR_FR,
            it_IT: AdvancedIT_IT,
            nl_NL: AdvancedNL_NL,
            pt_PT: AdvancedPT_PT
        }
    },
    AgentAdvanced: {
        ...createLanguageEnum(AgentAdvancedEN_GB),
        i18nBundles: {
            de_DE: AgentAdvancedDE_DE,
            en_GB: AgentAdvancedEN_GB,
            en_US: AgentAdvancedEN_US,
            fr_FR: AgentAdvancedFR_FR,
            it_IT: AgentAdvancedIT_IT,
            nl_NL: AgentAdvancedNL_NL,
            pt_PT: AgentAdvancedPT_PT
        }
    },
    AgentDetails: {
        ...createLanguageEnum(AgentDetailsEN_GB),
        i18nBundles: {
            de_DE: AgentDetailsDE_DE,
            en_GB: AgentDetailsEN_GB,
            en_US: AgentDetailsEN_US,
            fr_FR: AgentDetailsFR_FR,
            it_IT: AgentDetailsIT_IT,
            nl_NL: AgentDetailsNL_NL,
            pt_PT: AgentDetailsPT_PT
        }
    },
    AgentListLanguage: {
        ...createLanguageEnum(AgentListLanguageEN_GB),
        i18nBundles: {
            de_DE: AgentListLanguageDE_DE,
            en_GB: AgentListLanguageEN_GB,
            en_US: AgentListLanguageEN_US,
            fr_FR: AgentListLanguageFR_FR,
            it_IT: AgentListLanguageIT_IT,
            nl_NL: AgentListLanguageNL_NL,
            pt_PT: AgentListLanguagePT_PT
        }
    },
    AgentOmnichannel: {
        ...createLanguageEnum(AgentOmnichannelEN_GB),
        i18nBundles: {
            de_DE: AgentOmnichannelDE_DE,
            en_GB: AgentOmnichannelEN_GB,
            en_US: AgentOmnichannelEN_US,
            fr_FR: AgentOmnichannelFR_FR,
            it_IT: AgentOmnichannelIT_IT,
            nl_NL: AgentOmnichannelNL_NL,
            pt_PT: AgentOmnichannelPT_PT
        }
    },
    AlarmActions: {
        ...createLanguageEnum(AlarmActionsEN_GB),
        i18nBundles: {
            de_DE: AlarmActionsDE_DE,
            en_GB: AlarmActionsEN_GB,
            en_US: AlarmActionsEN_US,
            fr_FR: AlarmActionsFR_FR,
            it_IT: AlarmActionsIT_IT,
            nl_NL: AlarmActionsNL_NL,
            pt_PT: AlarmActionsPT_PT
        }
    },
    AnswerPerformance: {
        ...createLanguageEnum(AnswerPerformanceEN_GB),
        i18nBundles: {
            de_DE: AnswerPerformanceDE_DE,
            en_GB: AnswerPerformanceEN_GB,
            en_US: AnswerPerformanceEN_US,
            fr_FR: AnswerPerformanceFR_FR,
            it_IT: AnswerPerformanceIT_IT,
            nl_NL: AnswerPerformanceNL_NL,
            pt_PT: AnswerPerformancePT_PT
        }
    },
    ApiKeys: {
        ...createLanguageEnum(ApiKeysEN_GB),
        i18nBundles: {
            de_DE: ApiKeysDE_DE,
            en_GB: ApiKeysEN_GB,
            en_US: ApiKeysEN_US,
            fr_FR: ApiKeysFR_FR,
            it_IT: ApiKeysIT_IT,
            nl_NL: ApiKeysNL_NL,
            pt_PT: ApiKeysPT_PT
        }
    },
    AppMenu: {
        ...createLanguageEnum(AppMenuEN_GB),
        i18nBundles: {
            de_DE: AppMenuDE_DE,
            en_GB: AppMenuEN_GB,
            en_US: AppMenuEN_US,
            fr_FR: AppMenuFR_FR,
            it_IT: AppMenuIT_IT,
            nl_NL: AppMenuNL_NL,
            pt_PT: AppMenuPT_PT
        }
    },
    Audit: {
        ...createLanguageEnum(AuditEN_GB),
        i18nBundles: {
            de_DE: AuditDE_DE,
            en_GB: AuditEN_GB,
            en_US: AuditEN_US,
            fr_FR: AuditFR_FR,
            it_IT: AuditIT_IT,
            nl_NL: AuditNL_NL,
            pt_PT: AuditPT_PT
        }
    },
    Authentication: {
        ...createLanguageEnum(AuthenticationEN_GB),
        i18nBundles: {
            de_DE: AuthenticationDE_DE,
            en_GB: AuthenticationEN_GB,
            en_US: AuthenticationEN_US,
            fr_FR: AuthenticationFR_FR,
            it_IT: AuthenticationIT_IT,
            nl_NL: AuthenticationNL_NL,
            pt_PT: AuthenticationPT_PT
        }
    },
    BrandingLanguage: {
        ...createLanguageEnum(BrandingLanguageEN_GB),
        i18nBundles: {
            de_DE: BrandingLanguageDE_DE,
            en_GB: BrandingLanguageEN_GB,
            en_US: BrandingLanguageEN_US,
            fr_FR: BrandingLanguageFR_FR,
            it_IT: BrandingLanguageIT_IT,
            nl_NL: BrandingLanguageNL_NL,
            pt_PT: BrandingLanguagePT_PT
        }
    },
    BroadworksSSO: {
        ...createLanguageEnum(BroadworksSSOEN_GB),
        i18nBundles: {
            de_DE: BroadworksSSODE_DE,
            en_GB: BroadworksSSOEN_GB,
            en_US: BroadworksSSOEN_US,
            fr_FR: BroadworksSSOFR_FR,
            it_IT: BroadworksSSOIT_IT,
            nl_NL: BroadworksSSONL_NL,
            pt_PT: BroadworksSSOPT_PT
        }
    },
    CMECapabilities: {
        ...createLanguageEnum(CMECapabilitiesEN_GB),
        i18nBundles: {
            de_DE: CMECapabilitiesDE_DE,
            en_GB: CMECapabilitiesEN_GB,
            en_US: CMECapabilitiesEN_US,
            fr_FR: CMECapabilitiesFR_FR,
            it_IT: CMECapabilitiesIT_IT,
            nl_NL: CMECapabilitiesNL_NL,
            pt_PT: CMECapabilitiesPT_PT
        }
    },
    CMEDetails: {
        ...createLanguageEnum(CMEDetailsEN_GB),
        i18nBundles: {
            de_DE: CMEDetailsDE_DE,
            en_GB: CMEDetailsEN_GB,
            en_US: CMEDetailsEN_US,
            fr_FR: CMEDetailsFR_FR,
            it_IT: CMEDetailsIT_IT,
            nl_NL: CMEDetailsNL_NL,
            pt_PT: CMEDetailsPT_PT
        }
    },
    CRMConfigurationLanguage: {
        ...createLanguageEnum(CRMConfigurationLanguageEN_GB),
        i18nBundles: {
            de_DE: CRMConfigurationLanguageDE_DE,
            en_GB: CRMConfigurationLanguageEN_GB,
            en_US: CRMConfigurationLanguageEN_US,
            fr_FR: CRMConfigurationLanguageFR_FR,
            it_IT: CRMConfigurationLanguageIT_IT,
            nl_NL: CRMConfigurationLanguageNL_NL,
            pt_PT: CRMConfigurationLanguagePT_PT
        }
    },
    CRMModal: {
        ...createLanguageEnum(CRMModalEN_GB),
        i18nBundles: {
            de_DE: CRMModalDE_DE,
            en_GB: CRMModalEN_GB,
            en_US: CRMModalEN_US,
            fr_FR: CRMModalFR_FR,
            it_IT: CRMModalIT_IT,
            nl_NL: CRMModalNL_NL,
            pt_PT: CRMModalPT_PT
        }
    },
    CSVExportFormat: {
        ...createLanguageEnum(CSVExportFormatEN_GB),
        i18nBundles: {
            de_DE: CSVExportFormatDE_DE,
            en_GB: CSVExportFormatEN_GB,
            en_US: CSVExportFormatEN_US,
            fr_FR: CSVExportFormatFR_FR,
            it_IT: CSVExportFormatIT_IT,
            nl_NL: CSVExportFormatNL_NL,
            pt_PT: CSVExportFormatPT_PT
        }
    },
    CXRecordLanguage: {
        ...createLanguageEnum(CXRecordLanguageEN_GB),
        i18nBundles: {
            de_DE: CXRecordLanguageDE_DE,
            en_GB: CXRecordLanguageEN_GB,
            en_US: CXRecordLanguageEN_US,
            fr_FR: CXRecordLanguageFR_FR,
            it_IT: CXRecordLanguageIT_IT,
            nl_NL: CXRecordLanguageNL_NL,
            pt_PT: CXRecordLanguagePT_PT
        }
    },
    CXScoreLanguage: {
        ...createLanguageEnum(CXScoreLanguageEN_GB),
        i18nBundles: {
            de_DE: CXScoreLanguageDE_DE,
            en_GB: CXScoreLanguageEN_GB,
            en_US: CXScoreLanguageEN_US,
            fr_FR: CXScoreLanguageFR_FR,
            it_IT: CXScoreLanguageIT_IT,
            nl_NL: CXScoreLanguageNL_NL,
            pt_PT: CXScoreLanguagePT_PT
        }
    },
    CallControlErrors: {
        ...createLanguageEnum(CallControlErrorsEN_GB),
        i18nBundles: {
            de_DE: CallControlErrorsDE_DE,
            en_GB: CallControlErrorsEN_GB,
            en_US: CallControlErrorsEN_US,
            fr_FR: CallControlErrorsFR_FR,
            it_IT: CallControlErrorsIT_IT,
            nl_NL: CallControlErrorsNL_NL,
            pt_PT: CallControlErrorsPT_PT
        }
    },
    CallDetails: {
        ...createLanguageEnum(CallDetailsEN_GB),
        i18nBundles: {
            de_DE: CallDetailsDE_DE,
            en_GB: CallDetailsEN_GB,
            en_US: CallDetailsEN_US,
            fr_FR: CallDetailsFR_FR,
            it_IT: CallDetailsIT_IT,
            nl_NL: CallDetailsNL_NL,
            pt_PT: CallDetailsPT_PT
        }
    },
    CallMovementFiltering: {
        ...createLanguageEnum(CallMovementFilteringEN_GB),
        i18nBundles: {
            de_DE: CallMovementFilteringDE_DE,
            en_GB: CallMovementFilteringEN_GB,
            en_US: CallMovementFilteringEN_US,
            fr_FR: CallMovementFilteringFR_FR,
            it_IT: CallMovementFilteringIT_IT,
            nl_NL: CallMovementFilteringNL_NL,
            pt_PT: CallMovementFilteringPT_PT
        }
    },
    CallRecIntegration: {
        ...createLanguageEnum(CallRecIntegrationEN_GB),
        i18nBundles: {
            de_DE: CallRecIntegrationDE_DE,
            en_GB: CallRecIntegrationEN_GB,
            en_US: CallRecIntegrationEN_US,
            fr_FR: CallRecIntegrationFR_FR,
            it_IT: CallRecIntegrationIT_IT,
            nl_NL: CallRecIntegrationNL_NL,
            pt_PT: CallRecIntegrationPT_PT
        }
    },
    CallRecording: {
        ...createLanguageEnum(CallRecordingEN_GB),
        i18nBundles: {
            de_DE: CallRecordingDE_DE,
            en_GB: CallRecordingEN_GB,
            en_US: CallRecordingEN_US,
            fr_FR: CallRecordingFR_FR,
            it_IT: CallRecordingIT_IT,
            nl_NL: CallRecordingNL_NL,
            pt_PT: CallRecordingPT_PT
        }
    },
    CallStateThresholds: {
        ...createLanguageEnum(CallStateThresholdsEN_GB),
        i18nBundles: {
            de_DE: CallStateThresholdsDE_DE,
            en_GB: CallStateThresholdsEN_GB,
            en_US: CallStateThresholdsEN_US,
            fr_FR: CallStateThresholdsFR_FR,
            it_IT: CallStateThresholdsIT_IT,
            nl_NL: CallStateThresholdsNL_NL,
            pt_PT: CallStateThresholdsPT_PT
        }
    },
    CallTargetting: {
        ...createLanguageEnum(CallTargettingEN_GB),
        i18nBundles: {
            de_DE: CallTargettingDE_DE,
            en_GB: CallTargettingEN_GB,
            en_US: CallTargettingEN_US,
            fr_FR: CallTargettingFR_FR,
            it_IT: CallTargettingIT_IT,
            nl_NL: CallTargettingNL_NL,
            pt_PT: CallTargettingPT_PT
        }
    },
    ChangeLangLanguage: {
        ...createLanguageEnum(ChangeLangLanguageEN_GB),
        i18nBundles: {
            de_DE: ChangeLangLanguageDE_DE,
            en_GB: ChangeLangLanguageEN_GB,
            en_US: ChangeLangLanguageEN_US,
            fr_FR: ChangeLangLanguageFR_FR,
            it_IT: ChangeLangLanguageIT_IT,
            nl_NL: ChangeLangLanguageNL_NL,
            pt_PT: ChangeLangLanguagePT_PT
        }
    },
    ChangeLayout: {
        ...createLanguageEnum(ChangeLayoutEN_GB),
        i18nBundles: {
            de_DE: ChangeLayoutDE_DE,
            en_GB: ChangeLayoutEN_GB,
            en_US: ChangeLayoutEN_US,
            fr_FR: ChangeLayoutFR_FR,
            it_IT: ChangeLayoutIT_IT,
            nl_NL: ChangeLayoutNL_NL,
            pt_PT: ChangeLayoutPT_PT
        }
    },
    ChangeUserAgentLanguage: {
        ...createLanguageEnum(ChangeUserAgentLanguageEN_GB),
        i18nBundles: {
            de_DE: ChangeUserAgentLanguageDE_DE,
            en_GB: ChangeUserAgentLanguageEN_GB,
            en_US: ChangeUserAgentLanguageEN_US,
            fr_FR: ChangeUserAgentLanguageFR_FR,
            it_IT: ChangeUserAgentLanguageIT_IT,
            nl_NL: ChangeUserAgentLanguageNL_NL,
            pt_PT: ChangeUserAgentLanguagePT_PT
        }
    },
    ChartProviderOptions: {
        ...createLanguageEnum(ChartProviderOptionsEN_GB),
        i18nBundles: {
            de_DE: ChartProviderOptionsDE_DE,
            en_GB: ChartProviderOptionsEN_GB,
            en_US: ChartProviderOptionsEN_US,
            fr_FR: ChartProviderOptionsFR_FR,
            it_IT: ChartProviderOptionsIT_IT,
            nl_NL: ChartProviderOptionsNL_NL,
            pt_PT: ChartProviderOptionsPT_PT
        }
    },
    ChartStyleOptions: {
        ...createLanguageEnum(ChartStyleOptionsEN_GB),
        i18nBundles: {
            de_DE: ChartStyleOptionsDE_DE,
            en_GB: ChartStyleOptionsEN_GB,
            en_US: ChartStyleOptionsEN_US,
            fr_FR: ChartStyleOptionsFR_FR,
            it_IT: ChartStyleOptionsIT_IT,
            nl_NL: ChartStyleOptionsNL_NL,
            pt_PT: ChartStyleOptionsPT_PT
        }
    },
    ClientConfigurationLanguage: {
        ...createLanguageEnum(ClientConfigurationLanguageEN_GB),
        i18nBundles: {
            de_DE: ClientConfigurationLanguageDE_DE,
            en_GB: ClientConfigurationLanguageEN_GB,
            en_US: ClientConfigurationLanguageEN_US,
            fr_FR: ClientConfigurationLanguageFR_FR,
            it_IT: ClientConfigurationLanguageIT_IT,
            nl_NL: ClientConfigurationLanguageNL_NL,
            pt_PT: ClientConfigurationLanguagePT_PT
        }
    },
    ClientConfigurationModalLanguage: {
        ...createLanguageEnum(ClientConfigurationModalLanguageEN_GB),
        i18nBundles: {
            de_DE: ClientConfigurationModalLanguageDE_DE,
            en_GB: ClientConfigurationModalLanguageEN_GB,
            en_US: ClientConfigurationModalLanguageEN_US,
            fr_FR: ClientConfigurationModalLanguageFR_FR,
            it_IT: ClientConfigurationModalLanguageIT_IT,
            nl_NL: ClientConfigurationModalLanguageNL_NL,
            pt_PT: ClientConfigurationModalLanguagePT_PT
        }
    },
    CmeListLanguage: {
        ...createLanguageEnum(CmeListLanguageEN_GB),
        i18nBundles: {
            de_DE: CmeListLanguageDE_DE,
            en_GB: CmeListLanguageEN_GB,
            en_US: CmeListLanguageEN_US,
            fr_FR: CmeListLanguageFR_FR,
            it_IT: CmeListLanguageIT_IT,
            nl_NL: CmeListLanguageNL_NL,
            pt_PT: CmeListLanguagePT_PT
        }
    },
    CodeAddModify: {
        ...createLanguageEnum(CodeAddModifyEN_GB),
        i18nBundles: {
            de_DE: CodeAddModifyDE_DE,
            en_GB: CodeAddModifyEN_GB,
            en_US: CodeAddModifyEN_US,
            fr_FR: CodeAddModifyFR_FR,
            it_IT: CodeAddModifyIT_IT,
            nl_NL: CodeAddModifyNL_NL,
            pt_PT: CodeAddModifyPT_PT
        }
    },
    CodeListLanguage: {
        ...createLanguageEnum(CodeListLanguageEN_GB),
        i18nBundles: {
            de_DE: CodeListLanguageDE_DE,
            en_GB: CodeListLanguageEN_GB,
            en_US: CodeListLanguageEN_US,
            fr_FR: CodeListLanguageFR_FR,
            it_IT: CodeListLanguageIT_IT,
            nl_NL: CodeListLanguageNL_NL,
            pt_PT: CodeListLanguagePT_PT
        }
    },
    ComboBox: {
        ...createLanguageEnum(ComboBoxEN_GB),
        i18nBundles: {
            de_DE: ComboBoxDE_DE,
            en_GB: ComboBoxEN_GB,
            en_US: ComboBoxEN_US,
            fr_FR: ComboBoxFR_FR,
            it_IT: ComboBoxIT_IT,
            nl_NL: ComboBoxNL_NL,
            pt_PT: ComboBoxPT_PT
        }
    },
    CommonAdmin: {
        ...createLanguageEnum(CommonAdminEN_GB),
        i18nBundles: {
            de_DE: CommonAdminDE_DE,
            en_GB: CommonAdminEN_GB,
            en_US: CommonAdminEN_US,
            fr_FR: CommonAdminFR_FR,
            it_IT: CommonAdminIT_IT,
            nl_NL: CommonAdminNL_NL,
            pt_PT: CommonAdminPT_PT
        }
    },
    ConfigChangeLogListLanguage: {
        ...createLanguageEnum(ConfigChangeLogListLanguageEN_GB),
        i18nBundles: {
            de_DE: ConfigChangeLogListLanguageDE_DE,
            en_GB: ConfigChangeLogListLanguageEN_GB,
            en_US: ConfigChangeLogListLanguageEN_US,
            fr_FR: ConfigChangeLogListLanguageFR_FR,
            it_IT: ConfigChangeLogListLanguageIT_IT,
            nl_NL: ConfigChangeLogListLanguageNL_NL,
            pt_PT: ConfigChangeLogListLanguagePT_PT
        }
    },
    ConfigureAgents: {
        ...createLanguageEnum(ConfigureAgentsEN_GB),
        i18nBundles: {
            de_DE: ConfigureAgentsDE_DE,
            en_GB: ConfigureAgentsEN_GB,
            en_US: ConfigureAgentsEN_US,
            fr_FR: ConfigureAgentsFR_FR,
            it_IT: ConfigureAgentsIT_IT,
            nl_NL: ConfigureAgentsNL_NL,
            pt_PT: ConfigureAgentsPT_PT
        }
    },
    ConfigureReport: {
        ...createLanguageEnum(ConfigureReportEN_GB),
        i18nBundles: {
            de_DE: ConfigureReportDE_DE,
            en_GB: ConfigureReportEN_GB,
            en_US: ConfigureReportEN_US,
            fr_FR: ConfigureReportFR_FR,
            it_IT: ConfigureReportIT_IT,
            nl_NL: ConfigureReportNL_NL,
            pt_PT: ConfigureReportPT_PT
        }
    },
    ContentRestriction: {
        ...createLanguageEnum(ContentRestrictionEN_GB),
        i18nBundles: {
            de_DE: ContentRestrictionDE_DE,
            en_GB: ContentRestrictionEN_GB,
            en_US: ContentRestrictionEN_US,
            fr_FR: ContentRestrictionFR_FR,
            it_IT: ContentRestrictionIT_IT,
            nl_NL: ContentRestrictionNL_NL,
            pt_PT: ContentRestrictionPT_PT
        }
    },
    CookieConsent: {
        ...createLanguageEnum(CookieConsentEN_GB),
        i18nBundles: {
            de_DE: CookieConsentDE_DE,
            en_GB: CookieConsentEN_GB,
            en_US: CookieConsentEN_US,
            fr_FR: CookieConsentFR_FR,
            it_IT: CookieConsentIT_IT,
            nl_NL: CookieConsentNL_NL,
            pt_PT: CookieConsentPT_PT
        }
    },
    Currency: {
        ...createLanguageEnum(CurrencyEN_GB),
        i18nBundles: {
            de_DE: CurrencyDE_DE,
            en_GB: CurrencyEN_GB,
            en_US: CurrencyEN_US,
            fr_FR: CurrencyFR_FR,
            it_IT: CurrencyIT_IT,
            nl_NL: CurrencyNL_NL,
            pt_PT: CurrencyPT_PT
        }
    },
    CurrencyDisplayFormat: {
        ...createLanguageEnum(CurrencyDisplayFormatEN_GB),
        i18nBundles: {
            de_DE: CurrencyDisplayFormatDE_DE,
            en_GB: CurrencyDisplayFormatEN_GB,
            en_US: CurrencyDisplayFormatEN_US,
            fr_FR: CurrencyDisplayFormatFR_FR,
            it_IT: CurrencyDisplayFormatIT_IT,
            nl_NL: CurrencyDisplayFormatNL_NL,
            pt_PT: CurrencyDisplayFormatPT_PT
        }
    },
    CustomSettings: {
        ...createLanguageEnum(CustomSettingsEN_GB),
        i18nBundles: {
            de_DE: CustomSettingsDE_DE,
            en_GB: CustomSettingsEN_GB,
            en_US: CustomSettingsEN_US,
            fr_FR: CustomSettingsFR_FR,
            it_IT: CustomSettingsIT_IT,
            nl_NL: CustomSettingsNL_NL,
            pt_PT: CustomSettingsPT_PT
        }
    },
    CustomiseRole: {
        ...createLanguageEnum(CustomiseRoleEN_GB),
        i18nBundles: {
            de_DE: CustomiseRoleDE_DE,
            en_GB: CustomiseRoleEN_GB,
            en_US: CustomiseRoleEN_US,
            fr_FR: CustomiseRoleFR_FR,
            it_IT: CustomiseRoleIT_IT,
            nl_NL: CustomiseRoleNL_NL,
            pt_PT: CustomiseRolePT_PT
        }
    },
    CxiLicenceTypes: {
        ...createLanguageEnum(CxiLicenceTypesEN_GB),
        i18nBundles: {
            de_DE: CxiLicenceTypesDE_DE,
            en_GB: CxiLicenceTypesEN_GB,
            en_US: CxiLicenceTypesEN_US,
            fr_FR: CxiLicenceTypesFR_FR,
            it_IT: CxiLicenceTypesIT_IT,
            nl_NL: CxiLicenceTypesNL_NL,
            pt_PT: CxiLicenceTypesPT_PT
        }
    },
    DarkMode: {
        ...createLanguageEnum(DarkModeEN_GB),
        i18nBundles: {
            de_DE: DarkModeDE_DE,
            en_GB: DarkModeEN_GB,
            en_US: DarkModeEN_US,
            fr_FR: DarkModeFR_FR,
            it_IT: DarkModeIT_IT,
            nl_NL: DarkModeNL_NL,
            pt_PT: DarkModePT_PT
        }
    },
    DashboardDisplaySettings: {
        ...createLanguageEnum(DashboardDisplaySettingsEN_GB),
        i18nBundles: {
            de_DE: DashboardDisplaySettingsDE_DE,
            en_GB: DashboardDisplaySettingsEN_GB,
            en_US: DashboardDisplaySettingsEN_US,
            fr_FR: DashboardDisplaySettingsFR_FR,
            it_IT: DashboardDisplaySettingsIT_IT,
            nl_NL: DashboardDisplaySettingsNL_NL,
            pt_PT: DashboardDisplaySettingsPT_PT
        }
    },
    DashboardList: {
        ...createLanguageEnum(DashboardListEN_GB),
        i18nBundles: {
            de_DE: DashboardListDE_DE,
            en_GB: DashboardListEN_GB,
            en_US: DashboardListEN_US,
            fr_FR: DashboardListFR_FR,
            it_IT: DashboardListIT_IT,
            nl_NL: DashboardListNL_NL,
            pt_PT: DashboardListPT_PT
        }
    },
    DashboardOptions: {
        ...createLanguageEnum(DashboardOptionsEN_GB),
        i18nBundles: {
            de_DE: DashboardOptionsDE_DE,
            en_GB: DashboardOptionsEN_GB,
            en_US: DashboardOptionsEN_US,
            fr_FR: DashboardOptionsFR_FR,
            it_IT: DashboardOptionsIT_IT,
            nl_NL: DashboardOptionsNL_NL,
            pt_PT: DashboardOptionsPT_PT
        }
    },
    DatabaseLanguage: {
        ...createLanguageEnum(DatabaseLanguageEN_GB),
        i18nBundles: {
            de_DE: DatabaseLanguageDE_DE,
            en_GB: DatabaseLanguageEN_GB,
            en_US: DatabaseLanguageEN_US,
            fr_FR: DatabaseLanguageFR_FR,
            it_IT: DatabaseLanguageIT_IT,
            nl_NL: DatabaseLanguageNL_NL,
            pt_PT: DatabaseLanguagePT_PT
        }
    },
    Date: {
        ...createLanguageEnum(DateEN_GB),
        i18nBundles: {
            de_DE: DateDE_DE,
            en_GB: DateEN_GB,
            en_US: DateEN_US,
            fr_FR: DateFR_FR,
            it_IT: DateIT_IT,
            nl_NL: DateNL_NL,
            pt_PT: DatePT_PT
        }
    },
    DateTime: {
        ...createLanguageEnum(DateTimeEN_GB),
        i18nBundles: {
            de_DE: DateTimeDE_DE,
            en_GB: DateTimeEN_GB,
            en_US: DateTimeEN_US,
            fr_FR: DateTimeFR_FR,
            it_IT: DateTimeIT_IT,
            nl_NL: DateTimeNL_NL,
            pt_PT: DateTimePT_PT
        }
    },
    DaysOfTheWeek: {
        ...createLanguageEnum(DaysOfTheWeekEN_GB),
        i18nBundles: {
            de_DE: DaysOfTheWeekDE_DE,
            en_GB: DaysOfTheWeekEN_GB,
            en_US: DaysOfTheWeekEN_US,
            fr_FR: DaysOfTheWeekFR_FR,
            it_IT: DaysOfTheWeekIT_IT,
            nl_NL: DaysOfTheWeekNL_NL,
            pt_PT: DaysOfTheWeekPT_PT
        }
    },
    DeviceFiltering: {
        ...createLanguageEnum(DeviceFilteringEN_GB),
        i18nBundles: {
            de_DE: DeviceFilteringDE_DE,
            en_GB: DeviceFilteringEN_GB,
            en_US: DeviceFilteringEN_US,
            fr_FR: DeviceFilteringFR_FR,
            it_IT: DeviceFilteringIT_IT,
            nl_NL: DeviceFilteringNL_NL,
            pt_PT: DeviceFilteringPT_PT
        }
    },
    DeviceListLanguage: {
        ...createLanguageEnum(DeviceListLanguageEN_GB),
        i18nBundles: {
            de_DE: DeviceListLanguageDE_DE,
            en_GB: DeviceListLanguageEN_GB,
            en_US: DeviceListLanguageEN_US,
            fr_FR: DeviceListLanguageFR_FR,
            it_IT: DeviceListLanguageIT_IT,
            nl_NL: DeviceListLanguageNL_NL,
            pt_PT: DeviceListLanguagePT_PT
        }
    },
    DeviceModal: {
        ...createLanguageEnum(DeviceModalEN_GB),
        i18nBundles: {
            de_DE: DeviceModalDE_DE,
            en_GB: DeviceModalEN_GB,
            en_US: DeviceModalEN_US,
            fr_FR: DeviceModalFR_FR,
            it_IT: DeviceModalIT_IT,
            nl_NL: DeviceModalNL_NL,
            pt_PT: DeviceModalPT_PT
        }
    },
    DeviceTypesLanguage: {
        ...createLanguageEnum(DeviceTypesLanguageEN_GB),
        i18nBundles: {
            de_DE: DeviceTypesLanguageDE_DE,
            en_GB: DeviceTypesLanguageEN_GB,
            en_US: DeviceTypesLanguageEN_US,
            fr_FR: DeviceTypesLanguageFR_FR,
            it_IT: DeviceTypesLanguageIT_IT,
            nl_NL: DeviceTypesLanguageNL_NL,
            pt_PT: DeviceTypesLanguagePT_PT
        }
    },
    DirectoryListLanguage: {
        ...createLanguageEnum(DirectoryListLanguageEN_GB),
        i18nBundles: {
            de_DE: DirectoryListLanguageDE_DE,
            en_GB: DirectoryListLanguageEN_GB,
            en_US: DirectoryListLanguageEN_US,
            fr_FR: DirectoryListLanguageFR_FR,
            it_IT: DirectoryListLanguageIT_IT,
            nl_NL: DirectoryListLanguageNL_NL,
            pt_PT: DirectoryListLanguagePT_PT
        }
    },
    DirectoryModal: {
        ...createLanguageEnum(DirectoryModalEN_GB),
        i18nBundles: {
            de_DE: DirectoryModalDE_DE,
            en_GB: DirectoryModalEN_GB,
            en_US: DirectoryModalEN_US,
            fr_FR: DirectoryModalFR_FR,
            it_IT: DirectoryModalIT_IT,
            nl_NL: DirectoryModalNL_NL,
            pt_PT: DirectoryModalPT_PT
        }
    },
    DisplayOptions: {
        ...createLanguageEnum(DisplayOptionsEN_GB),
        i18nBundles: {
            de_DE: DisplayOptionsDE_DE,
            en_GB: DisplayOptionsEN_GB,
            en_US: DisplayOptionsEN_US,
            fr_FR: DisplayOptionsFR_FR,
            it_IT: DisplayOptionsIT_IT,
            nl_NL: DisplayOptionsNL_NL,
            pt_PT: DisplayOptionsPT_PT
        }
    },
    DisplaySettings: {
        ...createLanguageEnum(DisplaySettingsEN_GB),
        i18nBundles: {
            de_DE: DisplaySettingsDE_DE,
            en_GB: DisplaySettingsEN_GB,
            en_US: DisplaySettingsEN_US,
            fr_FR: DisplaySettingsFR_FR,
            it_IT: DisplaySettingsIT_IT,
            nl_NL: DisplaySettingsNL_NL,
            pt_PT: DisplaySettingsPT_PT
        }
    },
    DisplaySwitching: {
        ...createLanguageEnum(DisplaySwitchingEN_GB),
        i18nBundles: {
            de_DE: DisplaySwitchingDE_DE,
            en_GB: DisplaySwitchingEN_GB,
            en_US: DisplaySwitchingEN_US,
            fr_FR: DisplaySwitchingFR_FR,
            it_IT: DisplaySwitchingIT_IT,
            nl_NL: DisplaySwitchingNL_NL,
            pt_PT: DisplaySwitchingPT_PT
        }
    },
    DisplayedAsOptions: {
        ...createLanguageEnum(DisplayedAsOptionsEN_GB),
        i18nBundles: {
            de_DE: DisplayedAsOptionsDE_DE,
            en_GB: DisplayedAsOptionsEN_GB,
            en_US: DisplayedAsOptionsEN_US,
            fr_FR: DisplayedAsOptionsFR_FR,
            it_IT: DisplayedAsOptionsIT_IT,
            nl_NL: DisplayedAsOptionsNL_NL,
            pt_PT: DisplayedAsOptionsPT_PT
        }
    },
    DocumentViewer: {
        ...createLanguageEnum(DocumentViewerEN_GB),
        i18nBundles: {
            de_DE: DocumentViewerDE_DE,
            en_GB: DocumentViewerEN_GB,
            en_US: DocumentViewerEN_US,
            fr_FR: DocumentViewerFR_FR,
            it_IT: DocumentViewerIT_IT,
            nl_NL: DocumentViewerNL_NL,
            pt_PT: DocumentViewerPT_PT
        }
    },
    DomainProfile: {
        ...createLanguageEnum(DomainProfileEN_GB),
        i18nBundles: {
            de_DE: DomainProfileDE_DE,
            en_GB: DomainProfileEN_GB,
            en_US: DomainProfileEN_US,
            fr_FR: DomainProfileFR_FR,
            it_IT: DomainProfileIT_IT,
            nl_NL: DomainProfileNL_NL,
            pt_PT: DomainProfilePT_PT
        }
    },
    DurationFiltering: {
        ...createLanguageEnum(DurationFilteringEN_GB),
        i18nBundles: {
            de_DE: DurationFilteringDE_DE,
            en_GB: DurationFilteringEN_GB,
            en_US: DurationFilteringEN_US,
            fr_FR: DurationFilteringFR_FR,
            it_IT: DurationFilteringIT_IT,
            nl_NL: DurationFilteringNL_NL,
            pt_PT: DurationFilteringPT_PT
        }
    },
    ErrorLanguage: {
        ...createLanguageEnum(ErrorLanguageEN_GB),
        i18nBundles: {
            de_DE: ErrorLanguageDE_DE,
            en_GB: ErrorLanguageEN_GB,
            en_US: ErrorLanguageEN_US,
            fr_FR: ErrorLanguageFR_FR,
            it_IT: ErrorLanguageIT_IT,
            nl_NL: ErrorLanguageNL_NL,
            pt_PT: ErrorLanguagePT_PT
        }
    },
    Estate: {
        ...createLanguageEnum(EstateEN_GB),
        i18nBundles: {
            de_DE: EstateDE_DE,
            en_GB: EstateEN_GB,
            en_US: EstateEN_US,
            fr_FR: EstateFR_FR,
            it_IT: EstateIT_IT,
            nl_NL: EstateNL_NL,
            pt_PT: EstatePT_PT
        }
    },
    ExtensionEndpoint: {
        ...createLanguageEnum(ExtensionEndpointEN_GB),
        i18nBundles: {
            de_DE: ExtensionEndpointDE_DE,
            en_GB: ExtensionEndpointEN_GB,
            en_US: ExtensionEndpointEN_US,
            fr_FR: ExtensionEndpointFR_FR,
            it_IT: ExtensionEndpointIT_IT,
            nl_NL: ExtensionEndpointNL_NL,
            pt_PT: ExtensionEndpointPT_PT
        }
    },
    FieldsList: {
        ...createLanguageEnum(FieldsListEN_GB),
        i18nBundles: {
            de_DE: FieldsListDE_DE,
            en_GB: FieldsListEN_GB,
            en_US: FieldsListEN_US,
            fr_FR: FieldsListFR_FR,
            it_IT: FieldsListIT_IT,
            nl_NL: FieldsListNL_NL,
            pt_PT: FieldsListPT_PT
        }
    },
    FieldsTab: {
        ...createLanguageEnum(FieldsTabEN_GB),
        i18nBundles: {
            de_DE: FieldsTabDE_DE,
            en_GB: FieldsTabEN_GB,
            en_US: FieldsTabEN_US,
            fr_FR: FieldsTabFR_FR,
            it_IT: FieldsTabIT_IT,
            nl_NL: FieldsTabNL_NL,
            pt_PT: FieldsTabPT_PT
        }
    },
    FileUploadLanguage: {
        ...createLanguageEnum(FileUploadLanguageEN_GB),
        i18nBundles: {
            de_DE: FileUploadLanguageDE_DE,
            en_GB: FileUploadLanguageEN_GB,
            en_US: FileUploadLanguageEN_US,
            fr_FR: FileUploadLanguageFR_FR,
            it_IT: FileUploadLanguageIT_IT,
            nl_NL: FileUploadLanguageNL_NL,
            pt_PT: FileUploadLanguagePT_PT
        }
    },
    ForgotPasswordLanguage: {
        ...createLanguageEnum(ForgotPasswordLanguageEN_GB),
        i18nBundles: {
            de_DE: ForgotPasswordLanguageDE_DE,
            en_GB: ForgotPasswordLanguageEN_GB,
            en_US: ForgotPasswordLanguageEN_US,
            fr_FR: ForgotPasswordLanguageFR_FR,
            it_IT: ForgotPasswordLanguageIT_IT,
            nl_NL: ForgotPasswordLanguageNL_NL,
            pt_PT: ForgotPasswordLanguagePT_PT
        }
    },
    Format: {
        ...createLanguageEnum(FormatEN_GB),
        i18nBundles: {
            de_DE: FormatDE_DE,
            en_GB: FormatEN_GB,
            en_US: FormatEN_US,
            fr_FR: FormatFR_FR,
            it_IT: FormatIT_IT,
            nl_NL: FormatNL_NL,
            pt_PT: FormatPT_PT
        }
    },
    GenericAdminFilterLanguage: {
        ...createLanguageEnum(GenericAdminFilterLanguageEN_GB),
        i18nBundles: {
            de_DE: GenericAdminFilterLanguageDE_DE,
            en_GB: GenericAdminFilterLanguageEN_GB,
            en_US: GenericAdminFilterLanguageEN_US,
            fr_FR: GenericAdminFilterLanguageFR_FR,
            it_IT: GenericAdminFilterLanguageIT_IT,
            nl_NL: GenericAdminFilterLanguageNL_NL,
            pt_PT: GenericAdminFilterLanguagePT_PT
        }
    },
    GenericAdminListLanguage: {
        ...createLanguageEnum(GenericAdminListLanguageEN_GB),
        i18nBundles: {
            de_DE: GenericAdminListLanguageDE_DE,
            en_GB: GenericAdminListLanguageEN_GB,
            en_US: GenericAdminListLanguageEN_US,
            fr_FR: GenericAdminListLanguageFR_FR,
            it_IT: GenericAdminListLanguageIT_IT,
            nl_NL: GenericAdminListLanguageNL_NL,
            pt_PT: GenericAdminListLanguagePT_PT
        }
    },
    GenericFooter: {
        ...createLanguageEnum(GenericFooterEN_GB),
        i18nBundles: {
            de_DE: GenericFooterDE_DE,
            en_GB: GenericFooterEN_GB,
            en_US: GenericFooterEN_US,
            fr_FR: GenericFooterFR_FR,
            it_IT: GenericFooterIT_IT,
            nl_NL: GenericFooterNL_NL,
            pt_PT: GenericFooterPT_PT
        }
    },
    GenericModal: {
        ...createLanguageEnum(GenericModalEN_GB),
        i18nBundles: {
            de_DE: GenericModalDE_DE,
            en_GB: GenericModalEN_GB,
            en_US: GenericModalEN_US,
            fr_FR: GenericModalFR_FR,
            it_IT: GenericModalIT_IT,
            nl_NL: GenericModalNL_NL,
            pt_PT: GenericModalPT_PT
        }
    },
    GenericRuleLanguage: {
        ...createLanguageEnum(GenericRuleLanguageEN_GB),
        i18nBundles: {
            de_DE: GenericRuleLanguageDE_DE,
            en_GB: GenericRuleLanguageEN_GB,
            en_US: GenericRuleLanguageEN_US,
            fr_FR: GenericRuleLanguageFR_FR,
            it_IT: GenericRuleLanguageIT_IT,
            nl_NL: GenericRuleLanguageNL_NL,
            pt_PT: GenericRuleLanguagePT_PT
        }
    },
    GenericScopeTab: {
        ...createLanguageEnum(GenericScopeTabEN_GB),
        i18nBundles: {
            de_DE: GenericScopeTabDE_DE,
            en_GB: GenericScopeTabEN_GB,
            en_US: GenericScopeTabEN_US,
            fr_FR: GenericScopeTabFR_FR,
            it_IT: GenericScopeTabIT_IT,
            nl_NL: GenericScopeTabNL_NL,
            pt_PT: GenericScopeTabPT_PT
        }
    },
    HeaderSidebar: {
        ...createLanguageEnum(HeaderSidebarEN_GB),
        i18nBundles: {
            de_DE: HeaderSidebarDE_DE,
            en_GB: HeaderSidebarEN_GB,
            en_US: HeaderSidebarEN_US,
            fr_FR: HeaderSidebarFR_FR,
            it_IT: HeaderSidebarIT_IT,
            nl_NL: HeaderSidebarNL_NL,
            pt_PT: HeaderSidebarPT_PT
        }
    },
    InboundStatSettings: {
        ...createLanguageEnum(InboundStatSettingsEN_GB),
        i18nBundles: {
            de_DE: InboundStatSettingsDE_DE,
            en_GB: InboundStatSettingsEN_GB,
            en_US: InboundStatSettingsEN_US,
            fr_FR: InboundStatSettingsFR_FR,
            it_IT: InboundStatSettingsIT_IT,
            nl_NL: InboundStatSettingsNL_NL,
            pt_PT: InboundStatSettingsPT_PT
        }
    },
    InsightsDashboardLanguage: {
        ...createLanguageEnum(InsightsDashboardLanguageEN_GB),
        i18nBundles: {
            de_DE: InsightsDashboardLanguageDE_DE,
            en_GB: InsightsDashboardLanguageEN_GB,
            en_US: InsightsDashboardLanguageEN_US,
            fr_FR: InsightsDashboardLanguageFR_FR,
            it_IT: InsightsDashboardLanguageIT_IT,
            nl_NL: InsightsDashboardLanguageNL_NL,
            pt_PT: InsightsDashboardLanguagePT_PT
        }
    },
    InsightsHub: {
        ...createLanguageEnum(InsightsHubEN_GB),
        i18nBundles: {
            de_DE: InsightsHubDE_DE,
            en_GB: InsightsHubEN_GB,
            en_US: InsightsHubEN_US,
            fr_FR: InsightsHubFR_FR,
            it_IT: InsightsHubIT_IT,
            nl_NL: InsightsHubNL_NL,
            pt_PT: InsightsHubPT_PT
        }
    },
    LanguageBulkInsertUsers: {
        ...createLanguageEnum(LanguageBulkInsertUsersEN_GB),
        i18nBundles: {
            de_DE: LanguageBulkInsertUsersDE_DE,
            en_GB: LanguageBulkInsertUsersEN_GB,
            en_US: LanguageBulkInsertUsersEN_US,
            fr_FR: LanguageBulkInsertUsersFR_FR,
            it_IT: LanguageBulkInsertUsersIT_IT,
            nl_NL: LanguageBulkInsertUsersNL_NL,
            pt_PT: LanguageBulkInsertUsersPT_PT
        }
    },
    LanguageBulkUploadDirectoryEntries: {
        ...createLanguageEnum(LanguageBulkUploadDirectoryEntriesEN_GB),
        i18nBundles: {
            de_DE: LanguageBulkUploadDirectoryEntriesDE_DE,
            en_GB: LanguageBulkUploadDirectoryEntriesEN_GB,
            en_US: LanguageBulkUploadDirectoryEntriesEN_US,
            fr_FR: LanguageBulkUploadDirectoryEntriesFR_FR,
            it_IT: LanguageBulkUploadDirectoryEntriesIT_IT,
            nl_NL: LanguageBulkUploadDirectoryEntriesNL_NL,
            pt_PT: LanguageBulkUploadDirectoryEntriesPT_PT
        }
    },
    LanguageCME: {
        ...createLanguageEnum(LanguageCMEEN_GB),
        i18nBundles: {
            de_DE: LanguageCMEDE_DE,
            en_GB: LanguageCMEEN_GB,
            en_US: LanguageCMEEN_US,
            fr_FR: LanguageCMEFR_FR,
            it_IT: LanguageCMEIT_IT,
            nl_NL: LanguageCMENL_NL,
            pt_PT: LanguageCMEPT_PT
        }
    },
    LanguageDataTable: {
        ...createLanguageEnum(LanguageDataTableEN_GB),
        i18nBundles: {
            de_DE: LanguageDataTableDE_DE,
            en_GB: LanguageDataTableEN_GB,
            en_US: LanguageDataTableEN_US,
            fr_FR: LanguageDataTableFR_FR,
            it_IT: LanguageDataTableIT_IT,
            nl_NL: LanguageDataTableNL_NL,
            pt_PT: LanguageDataTablePT_PT
        }
    },
    LanguageErrorCodes: {
        ...createLanguageEnum(LanguageErrorCodesEN_GB),
        i18nBundles: {
            de_DE: LanguageErrorCodesDE_DE,
            en_GB: LanguageErrorCodesEN_GB,
            en_US: LanguageErrorCodesEN_US,
            fr_FR: LanguageErrorCodesFR_FR,
            it_IT: LanguageErrorCodesIT_IT,
            nl_NL: LanguageErrorCodesNL_NL,
            pt_PT: LanguageErrorCodesPT_PT
        }
    },
    LanguageErrors: {
        ...createLanguageEnum(LanguageErrorsEN_GB),
        i18nBundles: {
            de_DE: LanguageErrorsDE_DE,
            en_GB: LanguageErrorsEN_GB,
            en_US: LanguageErrorsEN_US,
            fr_FR: LanguageErrorsFR_FR,
            it_IT: LanguageErrorsIT_IT,
            nl_NL: LanguageErrorsNL_NL,
            pt_PT: LanguageErrorsPT_PT
        }
    },
    LanguageFallbackNav: {
        ...createLanguageEnum(LanguageFallbackNavEN_GB),
        i18nBundles: {
            de_DE: LanguageFallbackNavDE_DE,
            en_GB: LanguageFallbackNavEN_GB,
            en_US: LanguageFallbackNavEN_US,
            fr_FR: LanguageFallbackNavFR_FR,
            it_IT: LanguageFallbackNavIT_IT,
            nl_NL: LanguageFallbackNavNL_NL,
            pt_PT: LanguageFallbackNavPT_PT
        }
    },
    LanguageGeneral: {
        ...createLanguageEnum(LanguageGeneralEN_GB),
        i18nBundles: {
            de_DE: LanguageGeneralDE_DE,
            en_GB: LanguageGeneralEN_GB,
            en_US: LanguageGeneralEN_US,
            fr_FR: LanguageGeneralFR_FR,
            it_IT: LanguageGeneralIT_IT,
            nl_NL: LanguageGeneralNL_NL,
            pt_PT: LanguageGeneralPT_PT
        }
    },
    LanguageLogFileDownload: {
        ...createLanguageEnum(LanguageLogFileDownloadEN_GB),
        i18nBundles: {
            de_DE: LanguageLogFileDownloadDE_DE,
            en_GB: LanguageLogFileDownloadEN_GB,
            en_US: LanguageLogFileDownloadEN_US,
            fr_FR: LanguageLogFileDownloadFR_FR,
            it_IT: LanguageLogFileDownloadIT_IT,
            nl_NL: LanguageLogFileDownloadNL_NL,
            pt_PT: LanguageLogFileDownloadPT_PT
        }
    },
    LanguageMainMenu: {
        ...createLanguageEnum(LanguageMainMenuEN_GB),
        i18nBundles: {
            de_DE: LanguageMainMenuDE_DE,
            en_GB: LanguageMainMenuEN_GB,
            en_US: LanguageMainMenuEN_US,
            fr_FR: LanguageMainMenuFR_FR,
            it_IT: LanguageMainMenuIT_IT,
            nl_NL: LanguageMainMenuNL_NL,
            pt_PT: LanguageMainMenuPT_PT
        }
    },
    LanguageMainNavigation: {
        ...createLanguageEnum(LanguageMainNavigationEN_GB),
        i18nBundles: {
            de_DE: LanguageMainNavigationDE_DE,
            en_GB: LanguageMainNavigationEN_GB,
            en_US: LanguageMainNavigationEN_US,
            fr_FR: LanguageMainNavigationFR_FR,
            it_IT: LanguageMainNavigationIT_IT,
            nl_NL: LanguageMainNavigationNL_NL,
            pt_PT: LanguageMainNavigationPT_PT
        }
    },
    LanguageMyReportList: {
        ...createLanguageEnum(LanguageMyReportListEN_GB),
        i18nBundles: {
            de_DE: LanguageMyReportListDE_DE,
            en_GB: LanguageMyReportListEN_GB,
            en_US: LanguageMyReportListEN_US,
            fr_FR: LanguageMyReportListFR_FR,
            it_IT: LanguageMyReportListIT_IT,
            nl_NL: LanguageMyReportListNL_NL,
            pt_PT: LanguageMyReportListPT_PT
        }
    },
    LanguageNewUserTutorial: {
        ...createLanguageEnum(LanguageNewUserTutorialEN_GB),
        i18nBundles: {
            de_DE: LanguageNewUserTutorialDE_DE,
            en_GB: LanguageNewUserTutorialEN_GB,
            en_US: LanguageNewUserTutorialEN_US,
            fr_FR: LanguageNewUserTutorialFR_FR,
            it_IT: LanguageNewUserTutorialIT_IT,
            nl_NL: LanguageNewUserTutorialNL_NL,
            pt_PT: LanguageNewUserTutorialPT_PT
        }
    },
    LanguagePrompt: {
        ...createLanguageEnum(LanguagePromptEN_GB),
        i18nBundles: {
            de_DE: LanguagePromptDE_DE,
            en_GB: LanguagePromptEN_GB,
            en_US: LanguagePromptEN_US,
            fr_FR: LanguagePromptFR_FR,
            it_IT: LanguagePromptIT_IT,
            nl_NL: LanguagePromptNL_NL,
            pt_PT: LanguagePromptPT_PT
        }
    },
    LanguageSnackbar: {
        ...createLanguageEnum(LanguageSnackbarEN_GB),
        i18nBundles: {
            de_DE: LanguageSnackbarDE_DE,
            en_GB: LanguageSnackbarEN_GB,
            en_US: LanguageSnackbarEN_US,
            fr_FR: LanguageSnackbarFR_FR,
            it_IT: LanguageSnackbarIT_IT,
            nl_NL: LanguageSnackbarNL_NL,
            pt_PT: LanguageSnackbarPT_PT
        }
    },
    LicenceManagementPageLanguage: {
        ...createLanguageEnum(LicenceManagementPageLanguageEN_GB),
        i18nBundles: {
            de_DE: LicenceManagementPageLanguageDE_DE,
            en_GB: LicenceManagementPageLanguageEN_GB,
            en_US: LicenceManagementPageLanguageEN_US,
            fr_FR: LicenceManagementPageLanguageFR_FR,
            it_IT: LicenceManagementPageLanguageIT_IT,
            nl_NL: LicenceManagementPageLanguageNL_NL,
            pt_PT: LicenceManagementPageLanguagePT_PT
        }
    },
    LicenseManagement: {
        ...createLanguageEnum(LicenseManagementEN_GB),
        i18nBundles: {
            de_DE: LicenseManagementDE_DE,
            en_GB: LicenseManagementEN_GB,
            en_US: LicenseManagementEN_US,
            fr_FR: LicenseManagementFR_FR,
            it_IT: LicenseManagementIT_IT,
            nl_NL: LicenseManagementNL_NL,
            pt_PT: LicenseManagementPT_PT
        }
    },
    LicenseManagementLanguage: {
        ...createLanguageEnum(LicenseManagementLanguageEN_GB),
        i18nBundles: {
            de_DE: LicenseManagementLanguageDE_DE,
            en_GB: LicenseManagementLanguageEN_GB,
            en_US: LicenseManagementLanguageEN_US,
            fr_FR: LicenseManagementLanguageFR_FR,
            it_IT: LicenseManagementLanguageIT_IT,
            nl_NL: LicenseManagementLanguageNL_NL,
            pt_PT: LicenseManagementLanguagePT_PT
        }
    },
    LinkInputLanguage: {
        ...createLanguageEnum(LinkInputLanguageEN_GB),
        i18nBundles: {
            de_DE: LinkInputLanguageDE_DE,
            en_GB: LinkInputLanguageEN_GB,
            en_US: LinkInputLanguageEN_US,
            fr_FR: LinkInputLanguageFR_FR,
            it_IT: LinkInputLanguageIT_IT,
            nl_NL: LinkInputLanguageNL_NL,
            pt_PT: LinkInputLanguagePT_PT
        }
    },
    LocationalFiltering: {
        ...createLanguageEnum(LocationalFilteringEN_GB),
        i18nBundles: {
            de_DE: LocationalFilteringDE_DE,
            en_GB: LocationalFilteringEN_GB,
            en_US: LocationalFilteringEN_US,
            fr_FR: LocationalFilteringFR_FR,
            it_IT: LocationalFilteringIT_IT,
            nl_NL: LocationalFilteringNL_NL,
            pt_PT: LocationalFilteringPT_PT
        }
    },
    LogManagementListLanguage: {
        ...createLanguageEnum(LogManagementListLanguageEN_GB),
        i18nBundles: {
            de_DE: LogManagementListLanguageDE_DE,
            en_GB: LogManagementListLanguageEN_GB,
            en_US: LogManagementListLanguageEN_US,
            fr_FR: LogManagementListLanguageFR_FR,
            it_IT: LogManagementListLanguageIT_IT,
            nl_NL: LogManagementListLanguageNL_NL,
            pt_PT: LogManagementListLanguagePT_PT
        }
    },
    LoggingSettingsLanguage: {
        ...createLanguageEnum(LoggingSettingsLanguageEN_GB),
        i18nBundles: {
            de_DE: LoggingSettingsLanguageDE_DE,
            en_GB: LoggingSettingsLanguageEN_GB,
            en_US: LoggingSettingsLanguageEN_US,
            fr_FR: LoggingSettingsLanguageFR_FR,
            it_IT: LoggingSettingsLanguageIT_IT,
            nl_NL: LoggingSettingsLanguageNL_NL,
            pt_PT: LoggingSettingsLanguagePT_PT
        }
    },
    MFALanguage: {
        ...createLanguageEnum(MFALanguageEN_GB),
        i18nBundles: {
            de_DE: MFALanguageDE_DE,
            en_GB: MFALanguageEN_GB,
            en_US: MFALanguageEN_US,
            fr_FR: MFALanguageFR_FR,
            it_IT: MFALanguageIT_IT,
            nl_NL: MFALanguageNL_NL,
            pt_PT: MFALanguagePT_PT
        }
    },
    ManageCustomRoles: {
        ...createLanguageEnum(ManageCustomRolesEN_GB),
        i18nBundles: {
            de_DE: ManageCustomRolesDE_DE,
            en_GB: ManageCustomRolesEN_GB,
            en_US: ManageCustomRolesEN_US,
            fr_FR: ManageCustomRolesFR_FR,
            it_IT: ManageCustomRolesIT_IT,
            nl_NL: ManageCustomRolesNL_NL,
            pt_PT: ManageCustomRolesPT_PT
        }
    },
    ManageQueues: {
        ...createLanguageEnum(ManageQueuesEN_GB),
        i18nBundles: {
            de_DE: ManageQueuesDE_DE,
            en_GB: ManageQueuesEN_GB,
            en_US: ManageQueuesEN_US,
            fr_FR: ManageQueuesFR_FR,
            it_IT: ManageQueuesIT_IT,
            nl_NL: ManageQueuesNL_NL,
            pt_PT: ManageQueuesPT_PT
        }
    },
    MediaPlayer: {
        ...createLanguageEnum(MediaPlayerEN_GB),
        i18nBundles: {
            de_DE: MediaPlayerDE_DE,
            en_GB: MediaPlayerEN_GB,
            en_US: MediaPlayerEN_US,
            fr_FR: MediaPlayerFR_FR,
            it_IT: MediaPlayerIT_IT,
            nl_NL: MediaPlayerNL_NL,
            pt_PT: MediaPlayerPT_PT
        }
    },
    MessagesLanguage: {
        ...createLanguageEnum(MessagesLanguageEN_GB),
        i18nBundles: {
            de_DE: MessagesLanguageDE_DE,
            en_GB: MessagesLanguageEN_GB,
            en_US: MessagesLanguageEN_US,
            fr_FR: MessagesLanguageFR_FR,
            it_IT: MessagesLanguageIT_IT,
            nl_NL: MessagesLanguageNL_NL,
            pt_PT: MessagesLanguagePT_PT
        }
    },
    MicrosoftSSO: {
        ...createLanguageEnum(MicrosoftSSOEN_GB),
        i18nBundles: {
            de_DE: MicrosoftSSODE_DE,
            en_GB: MicrosoftSSOEN_GB,
            en_US: MicrosoftSSOEN_US,
            fr_FR: MicrosoftSSOFR_FR,
            it_IT: MicrosoftSSOIT_IT,
            nl_NL: MicrosoftSSONL_NL,
            pt_PT: MicrosoftSSOPT_PT
        }
    },
    MiscellaneousFiltering: {
        ...createLanguageEnum(MiscellaneousFilteringEN_GB),
        i18nBundles: {
            de_DE: MiscellaneousFilteringDE_DE,
            en_GB: MiscellaneousFilteringEN_GB,
            en_US: MiscellaneousFilteringEN_US,
            fr_FR: MiscellaneousFilteringFR_FR,
            it_IT: MiscellaneousFilteringIT_IT,
            nl_NL: MiscellaneousFilteringNL_NL,
            pt_PT: MiscellaneousFilteringPT_PT
        }
    },
    MonetaryCallAssignments: {
        ...createLanguageEnum(MonetaryCallAssignmentsEN_GB),
        i18nBundles: {
            de_DE: MonetaryCallAssignmentsDE_DE,
            en_GB: MonetaryCallAssignmentsEN_GB,
            en_US: MonetaryCallAssignmentsEN_US,
            fr_FR: MonetaryCallAssignmentsFR_FR,
            it_IT: MonetaryCallAssignmentsIT_IT,
            nl_NL: MonetaryCallAssignmentsNL_NL,
            pt_PT: MonetaryCallAssignmentsPT_PT
        }
    },
    NotificationsLanguage: {
        ...createLanguageEnum(NotificationsLanguageEN_GB),
        i18nBundles: {
            de_DE: NotificationsLanguageDE_DE,
            en_GB: NotificationsLanguageEN_GB,
            en_US: NotificationsLanguageEN_US,
            fr_FR: NotificationsLanguageFR_FR,
            it_IT: NotificationsLanguageIT_IT,
            nl_NL: NotificationsLanguageNL_NL,
            pt_PT: NotificationsLanguagePT_PT
        }
    },
    NotificationsLanguageModal: {
        ...createLanguageEnum(NotificationsLanguageModalEN_GB),
        i18nBundles: {
            de_DE: NotificationsLanguageModalDE_DE,
            en_GB: NotificationsLanguageModalEN_GB,
            en_US: NotificationsLanguageModalEN_US,
            fr_FR: NotificationsLanguageModalFR_FR,
            it_IT: NotificationsLanguageModalIT_IT,
            nl_NL: NotificationsLanguageModalNL_NL,
            pt_PT: NotificationsLanguageModalPT_PT
        }
    },
    OAuthButton: {
        ...createLanguageEnum(OAuthButtonEN_GB),
        i18nBundles: {
            de_DE: OAuthButtonDE_DE,
            en_GB: OAuthButtonEN_GB,
            en_US: OAuthButtonEN_US,
            fr_FR: OAuthButtonFR_FR,
            it_IT: OAuthButtonIT_IT,
            nl_NL: OAuthButtonNL_NL,
            pt_PT: OAuthButtonPT_PT
        }
    },
    PaginatedList: {
        ...createLanguageEnum(PaginatedListEN_GB),
        i18nBundles: {
            de_DE: PaginatedListDE_DE,
            en_GB: PaginatedListEN_GB,
            en_US: PaginatedListEN_US,
            fr_FR: PaginatedListFR_FR,
            it_IT: PaginatedListIT_IT,
            nl_NL: PaginatedListNL_NL,
            pt_PT: PaginatedListPT_PT
        }
    },
    PartitionListLanguage: {
        ...createLanguageEnum(PartitionListLanguageEN_GB),
        i18nBundles: {
            de_DE: PartitionListLanguageDE_DE,
            en_GB: PartitionListLanguageEN_GB,
            en_US: PartitionListLanguageEN_US,
            fr_FR: PartitionListLanguageFR_FR,
            it_IT: PartitionListLanguageIT_IT,
            nl_NL: PartitionListLanguageNL_NL,
            pt_PT: PartitionListLanguagePT_PT
        }
    },
    PartitionModal: {
        ...createLanguageEnum(PartitionModalEN_GB),
        i18nBundles: {
            de_DE: PartitionModalDE_DE,
            en_GB: PartitionModalEN_GB,
            en_US: PartitionModalEN_US,
            fr_FR: PartitionModalFR_FR,
            it_IT: PartitionModalIT_IT,
            nl_NL: PartitionModalNL_NL,
            pt_PT: PartitionModalPT_PT
        }
    },
    PasswordChangeLanguage: {
        ...createLanguageEnum(PasswordChangeLanguageEN_GB),
        i18nBundles: {
            de_DE: PasswordChangeLanguageDE_DE,
            en_GB: PasswordChangeLanguageEN_GB,
            en_US: PasswordChangeLanguageEN_US,
            fr_FR: PasswordChangeLanguageFR_FR,
            it_IT: PasswordChangeLanguageIT_IT,
            nl_NL: PasswordChangeLanguageNL_NL,
            pt_PT: PasswordChangeLanguagePT_PT
        }
    },
    PasswordTextInput: {
        ...createLanguageEnum(PasswordTextInputEN_GB),
        i18nBundles: {
            de_DE: PasswordTextInputDE_DE,
            en_GB: PasswordTextInputEN_GB,
            en_US: PasswordTextInputEN_US,
            fr_FR: PasswordTextInputFR_FR,
            it_IT: PasswordTextInputIT_IT,
            nl_NL: PasswordTextInputNL_NL,
            pt_PT: PasswordTextInputPT_PT
        }
    },
    PermissionsLanguage: {
        ...createLanguageEnum(PermissionsLanguageEN_GB),
        i18nBundles: {
            de_DE: PermissionsLanguageDE_DE,
            en_GB: PermissionsLanguageEN_GB,
            en_US: PermissionsLanguageEN_US,
            fr_FR: PermissionsLanguageFR_FR,
            it_IT: PermissionsLanguageIT_IT,
            nl_NL: PermissionsLanguageNL_NL,
            pt_PT: PermissionsLanguagePT_PT
        }
    },
    Presence: {
        ...createLanguageEnum(PresenceEN_GB),
        i18nBundles: {
            de_DE: PresenceDE_DE,
            en_GB: PresenceEN_GB,
            en_US: PresenceEN_US,
            fr_FR: PresenceFR_FR,
            it_IT: PresenceIT_IT,
            nl_NL: PresenceNL_NL,
            pt_PT: PresencePT_PT
        }
    },
    Preview: {
        ...createLanguageEnum(PreviewEN_GB),
        i18nBundles: {
            de_DE: PreviewDE_DE,
            en_GB: PreviewEN_GB,
            en_US: PreviewEN_US,
            fr_FR: PreviewFR_FR,
            it_IT: PreviewIT_IT,
            nl_NL: PreviewNL_NL,
            pt_PT: PreviewPT_PT
        }
    },
    PrintOutput: {
        ...createLanguageEnum(PrintOutputEN_GB),
        i18nBundles: {
            de_DE: PrintOutputDE_DE,
            en_GB: PrintOutputEN_GB,
            en_US: PrintOutputEN_US,
            fr_FR: PrintOutputFR_FR,
            it_IT: PrintOutputIT_IT,
            nl_NL: PrintOutputNL_NL,
            pt_PT: PrintOutputPT_PT
        }
    },
    Provisioning: {
        ...createLanguageEnum(ProvisioningEN_GB),
        i18nBundles: {
            de_DE: ProvisioningDE_DE,
            en_GB: ProvisioningEN_GB,
            en_US: ProvisioningEN_US,
            fr_FR: ProvisioningFR_FR,
            it_IT: ProvisioningIT_IT,
            nl_NL: ProvisioningNL_NL,
            pt_PT: ProvisioningPT_PT
        }
    },
    RangeComboLanguage: {
        ...createLanguageEnum(RangeComboLanguageEN_GB),
        i18nBundles: {
            de_DE: RangeComboLanguageDE_DE,
            en_GB: RangeComboLanguageEN_GB,
            en_US: RangeComboLanguageEN_US,
            fr_FR: RangeComboLanguageFR_FR,
            it_IT: RangeComboLanguageIT_IT,
            nl_NL: RangeComboLanguageNL_NL,
            pt_PT: RangeComboLanguagePT_PT
        }
    },
    RecordingListLanguage: {
        ...createLanguageEnum(RecordingListLanguageEN_GB),
        i18nBundles: {
            de_DE: RecordingListLanguageDE_DE,
            en_GB: RecordingListLanguageEN_GB,
            en_US: RecordingListLanguageEN_US,
            fr_FR: RecordingListLanguageFR_FR,
            it_IT: RecordingListLanguageIT_IT,
            nl_NL: RecordingListLanguageNL_NL,
            pt_PT: RecordingListLanguagePT_PT
        }
    },
    ReportContentRowsSettingsLanguage: {
        ...createLanguageEnum(ReportContentRowsSettingsLanguageEN_GB),
        i18nBundles: {
            de_DE: ReportContentRowsSettingsLanguageDE_DE,
            en_GB: ReportContentRowsSettingsLanguageEN_GB,
            en_US: ReportContentRowsSettingsLanguageEN_US,
            fr_FR: ReportContentRowsSettingsLanguageFR_FR,
            it_IT: ReportContentRowsSettingsLanguageIT_IT,
            nl_NL: ReportContentRowsSettingsLanguageNL_NL,
            pt_PT: ReportContentRowsSettingsLanguagePT_PT
        }
    },
    ReportIntervalLanguage: {
        ...createLanguageEnum(ReportIntervalLanguageEN_GB),
        i18nBundles: {
            de_DE: ReportIntervalLanguageDE_DE,
            en_GB: ReportIntervalLanguageEN_GB,
            en_US: ReportIntervalLanguageEN_US,
            fr_FR: ReportIntervalLanguageFR_FR,
            it_IT: ReportIntervalLanguageIT_IT,
            nl_NL: ReportIntervalLanguageNL_NL,
            pt_PT: ReportIntervalLanguagePT_PT
        }
    },
    ReportOptions: {
        ...createLanguageEnum(ReportOptionsEN_GB),
        i18nBundles: {
            de_DE: ReportOptionsDE_DE,
            en_GB: ReportOptionsEN_GB,
            en_US: ReportOptionsEN_US,
            fr_FR: ReportOptionsFR_FR,
            it_IT: ReportOptionsIT_IT,
            nl_NL: ReportOptionsNL_NL,
            pt_PT: ReportOptionsPT_PT
        }
    },
    ReportPortalInfo: {
        ...createLanguageEnum(ReportPortalInfoEN_GB),
        i18nBundles: {
            de_DE: ReportPortalInfoDE_DE,
            en_GB: ReportPortalInfoEN_GB,
            en_US: ReportPortalInfoEN_US,
            fr_FR: ReportPortalInfoFR_FR,
            it_IT: ReportPortalInfoIT_IT,
            nl_NL: ReportPortalInfoNL_NL,
            pt_PT: ReportPortalInfoPT_PT
        }
    },
    ReportScheduling: {
        ...createLanguageEnum(ReportSchedulingEN_GB),
        i18nBundles: {
            de_DE: ReportSchedulingDE_DE,
            en_GB: ReportSchedulingEN_GB,
            en_US: ReportSchedulingEN_US,
            fr_FR: ReportSchedulingFR_FR,
            it_IT: ReportSchedulingIT_IT,
            nl_NL: ReportSchedulingNL_NL,
            pt_PT: ReportSchedulingPT_PT
        }
    },
    ReportSchedulingEmails: {
        ...createLanguageEnum(ReportSchedulingEmailsEN_GB),
        i18nBundles: {
            de_DE: ReportSchedulingEmailsDE_DE,
            en_GB: ReportSchedulingEmailsEN_GB,
            en_US: ReportSchedulingEmailsEN_US,
            fr_FR: ReportSchedulingEmailsFR_FR,
            it_IT: ReportSchedulingEmailsIT_IT,
            nl_NL: ReportSchedulingEmailsNL_NL,
            pt_PT: ReportSchedulingEmailsPT_PT
        }
    },
    ReportTypes: {
        ...createLanguageEnum(ReportTypesEN_GB),
        i18nBundles: {
            de_DE: ReportTypesDE_DE,
            en_GB: ReportTypesEN_GB,
            en_US: ReportTypesEN_US,
            fr_FR: ReportTypesFR_FR,
            it_IT: ReportTypesIT_IT,
            nl_NL: ReportTypesNL_NL,
            pt_PT: ReportTypesPT_PT
        }
    },
    ReportingDefaultReportSets: {
        ...createLanguageEnum(ReportingDefaultReportSetsEN_GB),
        i18nBundles: {
            de_DE: ReportingDefaultReportSetsDE_DE,
            en_GB: ReportingDefaultReportSetsEN_GB,
            en_US: ReportingDefaultReportSetsEN_US,
            fr_FR: ReportingDefaultReportSetsFR_FR,
            it_IT: ReportingDefaultReportSetsIT_IT,
            nl_NL: ReportingDefaultReportSetsNL_NL,
            pt_PT: ReportingDefaultReportSetsPT_PT
        }
    },
    ReportingLanguage: {
        ...createLanguageEnum(ReportingLanguageEN_GB),
        i18nBundles: {
            de_DE: ReportingLanguageDE_DE,
            en_GB: ReportingLanguageEN_GB,
            en_US: ReportingLanguageEN_US,
            fr_FR: ReportingLanguageFR_FR,
            it_IT: ReportingLanguageIT_IT,
            nl_NL: ReportingLanguageNL_NL,
            pt_PT: ReportingLanguagePT_PT
        }
    },
    ReportingMenuLanguage: {
        ...createLanguageEnum(ReportingMenuLanguageEN_GB),
        i18nBundles: {
            de_DE: ReportingMenuLanguageDE_DE,
            en_GB: ReportingMenuLanguageEN_GB,
            en_US: ReportingMenuLanguageEN_US,
            fr_FR: ReportingMenuLanguageFR_FR,
            it_IT: ReportingMenuLanguageIT_IT,
            nl_NL: ReportingMenuLanguageNL_NL,
            pt_PT: ReportingMenuLanguagePT_PT
        }
    },
    ReportsFilterDeviceFilter: {
        ...createLanguageEnum(ReportsFilterDeviceFilterEN_GB),
        i18nBundles: {
            de_DE: ReportsFilterDeviceFilterDE_DE,
            en_GB: ReportsFilterDeviceFilterEN_GB,
            en_US: ReportsFilterDeviceFilterEN_US,
            fr_FR: ReportsFilterDeviceFilterFR_FR,
            it_IT: ReportsFilterDeviceFilterIT_IT,
            nl_NL: ReportsFilterDeviceFilterNL_NL,
            pt_PT: ReportsFilterDeviceFilterPT_PT
        }
    },
    RichTextEditor: {
        ...createLanguageEnum(RichTextEditorEN_GB),
        i18nBundles: {
            de_DE: RichTextEditorDE_DE,
            en_GB: RichTextEditorEN_GB,
            en_US: RichTextEditorEN_US,
            fr_FR: RichTextEditorFR_FR,
            it_IT: RichTextEditorIT_IT,
            nl_NL: RichTextEditorNL_NL,
            pt_PT: RichTextEditorPT_PT
        }
    },
    RoleLanguage: {
        ...createLanguageEnum(RoleLanguageEN_GB),
        i18nBundles: {
            de_DE: RoleLanguageDE_DE,
            en_GB: RoleLanguageEN_GB,
            en_US: RoleLanguageEN_US,
            fr_FR: RoleLanguageFR_FR,
            it_IT: RoleLanguageIT_IT,
            nl_NL: RoleLanguageNL_NL,
            pt_PT: RoleLanguagePT_PT
        }
    },
    Router: {
        ...createLanguageEnum(RouterEN_GB),
        i18nBundles: {
            de_DE: RouterDE_DE,
            en_GB: RouterEN_GB,
            en_US: RouterEN_US,
            fr_FR: RouterFR_FR,
            it_IT: RouterIT_IT,
            nl_NL: RouterNL_NL,
            pt_PT: RouterPT_PT
        }
    },
    RowOptions: {
        ...createLanguageEnum(RowOptionsEN_GB),
        i18nBundles: {
            de_DE: RowOptionsDE_DE,
            en_GB: RowOptionsEN_GB,
            en_US: RowOptionsEN_US,
            fr_FR: RowOptionsFR_FR,
            it_IT: RowOptionsIT_IT,
            nl_NL: RowOptionsNL_NL,
            pt_PT: RowOptionsPT_PT
        }
    },
    RulesLanguage: {
        ...createLanguageEnum(RulesLanguageEN_GB),
        i18nBundles: {
            de_DE: RulesLanguageDE_DE,
            en_GB: RulesLanguageEN_GB,
            en_US: RulesLanguageEN_US,
            fr_FR: RulesLanguageFR_FR,
            it_IT: RulesLanguageIT_IT,
            nl_NL: RulesLanguageNL_NL,
            pt_PT: RulesLanguagePT_PT
        }
    },
    SSOLanguage: {
        ...createLanguageEnum(SSOLanguageEN_GB),
        i18nBundles: {
            de_DE: SSOLanguageDE_DE,
            en_GB: SSOLanguageEN_GB,
            en_US: SSOLanguageEN_US,
            fr_FR: SSOLanguageFR_FR,
            it_IT: SSOLanguageIT_IT,
            nl_NL: SSOLanguageNL_NL,
            pt_PT: SSOLanguagePT_PT
        }
    },
    ScheduleStatus: {
        ...createLanguageEnum(ScheduleStatusEN_GB),
        i18nBundles: {
            de_DE: ScheduleStatusDE_DE,
            en_GB: ScheduleStatusEN_GB,
            en_US: ScheduleStatusEN_US,
            fr_FR: ScheduleStatusFR_FR,
            it_IT: ScheduleStatusIT_IT,
            nl_NL: ScheduleStatusNL_NL,
            pt_PT: ScheduleStatusPT_PT
        }
    },
    ScopeAssignment: {
        ...createLanguageEnum(ScopeAssignmentEN_GB),
        i18nBundles: {
            de_DE: ScopeAssignmentDE_DE,
            en_GB: ScopeAssignmentEN_GB,
            en_US: ScopeAssignmentEN_US,
            fr_FR: ScopeAssignmentFR_FR,
            it_IT: ScopeAssignmentIT_IT,
            nl_NL: ScopeAssignmentNL_NL,
            pt_PT: ScopeAssignmentPT_PT
        }
    },
    ScopeFiltering: {
        ...createLanguageEnum(ScopeFilteringEN_GB),
        i18nBundles: {
            de_DE: ScopeFilteringDE_DE,
            en_GB: ScopeFilteringEN_GB,
            en_US: ScopeFilteringEN_US,
            fr_FR: ScopeFilteringFR_FR,
            it_IT: ScopeFilteringIT_IT,
            nl_NL: ScopeFilteringNL_NL,
            pt_PT: ScopeFilteringPT_PT
        }
    },
    SelfProvisioning: {
        ...createLanguageEnum(SelfProvisioningEN_GB),
        i18nBundles: {
            de_DE: SelfProvisioningDE_DE,
            en_GB: SelfProvisioningEN_GB,
            en_US: SelfProvisioningEN_US,
            fr_FR: SelfProvisioningFR_FR,
            it_IT: SelfProvisioningIT_IT,
            nl_NL: SelfProvisioningNL_NL,
            pt_PT: SelfProvisioningPT_PT
        }
    },
    ServerStatusLanguage: {
        ...createLanguageEnum(ServerStatusLanguageEN_GB),
        i18nBundles: {
            de_DE: ServerStatusLanguageDE_DE,
            en_GB: ServerStatusLanguageEN_GB,
            en_US: ServerStatusLanguageEN_US,
            fr_FR: ServerStatusLanguageFR_FR,
            it_IT: ServerStatusLanguageIT_IT,
            nl_NL: ServerStatusLanguageNL_NL,
            pt_PT: ServerStatusLanguagePT_PT
        }
    },
    ServiceLvlSettings: {
        ...createLanguageEnum(ServiceLvlSettingsEN_GB),
        i18nBundles: {
            de_DE: ServiceLvlSettingsDE_DE,
            en_GB: ServiceLvlSettingsEN_GB,
            en_US: ServiceLvlSettingsEN_US,
            fr_FR: ServiceLvlSettingsFR_FR,
            it_IT: ServiceLvlSettingsIT_IT,
            nl_NL: ServiceLvlSettingsNL_NL,
            pt_PT: ServiceLvlSettingsPT_PT
        }
    },
    ServiceMessagesLanguage: {
        ...createLanguageEnum(ServiceMessagesLanguageEN_GB),
        i18nBundles: {
            de_DE: ServiceMessagesLanguageDE_DE,
            en_GB: ServiceMessagesLanguageEN_GB,
            en_US: ServiceMessagesLanguageEN_US,
            fr_FR: ServiceMessagesLanguageFR_FR,
            it_IT: ServiceMessagesLanguageIT_IT,
            nl_NL: ServiceMessagesLanguageNL_NL,
            pt_PT: ServiceMessagesLanguagePT_PT
        }
    },
    SettingsLanguage: {
        ...createLanguageEnum(SettingsLanguageEN_GB),
        i18nBundles: {
            de_DE: SettingsLanguageDE_DE,
            en_GB: SettingsLanguageEN_GB,
            en_US: SettingsLanguageEN_US,
            fr_FR: SettingsLanguageFR_FR,
            it_IT: SettingsLanguageIT_IT,
            nl_NL: SettingsLanguageNL_NL,
            pt_PT: SettingsLanguagePT_PT
        }
    },
    SidebarMenu: {
        ...createLanguageEnum(SidebarMenuEN_GB),
        i18nBundles: {
            de_DE: SidebarMenuDE_DE,
            en_GB: SidebarMenuEN_GB,
            en_US: SidebarMenuEN_US,
            fr_FR: SidebarMenuFR_FR,
            it_IT: SidebarMenuIT_IT,
            nl_NL: SidebarMenuNL_NL,
            pt_PT: SidebarMenuPT_PT
        }
    },
    SignInWith: {
        ...createLanguageEnum(SignInWithEN_GB),
        i18nBundles: {
            de_DE: SignInWithDE_DE,
            en_GB: SignInWithEN_GB,
            en_US: SignInWithEN_US,
            fr_FR: SignInWithFR_FR,
            it_IT: SignInWithIT_IT,
            nl_NL: SignInWithNL_NL,
            pt_PT: SignInWithPT_PT
        }
    },
    SortList: {
        ...createLanguageEnum(SortListEN_GB),
        i18nBundles: {
            de_DE: SortListDE_DE,
            en_GB: SortListEN_GB,
            en_US: SortListEN_US,
            fr_FR: SortListFR_FR,
            it_IT: SortListIT_IT,
            nl_NL: SortListNL_NL,
            pt_PT: SortListPT_PT
        }
    },
    StaticAgentControls: {
        ...createLanguageEnum(StaticAgentControlsEN_GB),
        i18nBundles: {
            de_DE: StaticAgentControlsDE_DE,
            en_GB: StaticAgentControlsEN_GB,
            en_US: StaticAgentControlsEN_US,
            fr_FR: StaticAgentControlsFR_FR,
            it_IT: StaticAgentControlsIT_IT,
            nl_NL: StaticAgentControlsNL_NL,
            pt_PT: StaticAgentControlsPT_PT
        }
    },
    StatisticAlarm: {
        ...createLanguageEnum(StatisticAlarmEN_GB),
        i18nBundles: {
            de_DE: StatisticAlarmDE_DE,
            en_GB: StatisticAlarmEN_GB,
            en_US: StatisticAlarmEN_US,
            fr_FR: StatisticAlarmFR_FR,
            it_IT: StatisticAlarmIT_IT,
            nl_NL: StatisticAlarmNL_NL,
            pt_PT: StatisticAlarmPT_PT
        }
    },
    StatisticCalculations: {
        ...createLanguageEnum(StatisticCalculationsEN_GB),
        i18nBundles: {
            de_DE: StatisticCalculationsDE_DE,
            en_GB: StatisticCalculationsEN_GB,
            en_US: StatisticCalculationsEN_US,
            fr_FR: StatisticCalculationsFR_FR,
            it_IT: StatisticCalculationsIT_IT,
            nl_NL: StatisticCalculationsNL_NL,
            pt_PT: StatisticCalculationsPT_PT
        }
    },
    StatusChange: {
        ...createLanguageEnum(StatusChangeEN_GB),
        i18nBundles: {
            de_DE: StatusChangeDE_DE,
            en_GB: StatusChangeEN_GB,
            en_US: StatusChangeEN_US,
            fr_FR: StatusChangeFR_FR,
            it_IT: StatusChangeIT_IT,
            nl_NL: StatusChangeNL_NL,
            pt_PT: StatusChangePT_PT
        }
    },
    TalkTime: {
        ...createLanguageEnum(TalkTimeEN_GB),
        i18nBundles: {
            de_DE: TalkTimeDE_DE,
            en_GB: TalkTimeEN_GB,
            en_US: TalkTimeEN_US,
            fr_FR: TalkTimeFR_FR,
            it_IT: TalkTimeIT_IT,
            nl_NL: TalkTimeNL_NL,
            pt_PT: TalkTimePT_PT
        }
    },
    TeamsAuth: {
        ...createLanguageEnum(TeamsAuthEN_GB),
        i18nBundles: {
            de_DE: TeamsAuthDE_DE,
            en_GB: TeamsAuthEN_GB,
            en_US: TeamsAuthEN_US,
            fr_FR: TeamsAuthFR_FR,
            it_IT: TeamsAuthIT_IT,
            nl_NL: TeamsAuthNL_NL,
            pt_PT: TeamsAuthPT_PT
        }
    },
    TelModuleStatusListLanguage: {
        ...createLanguageEnum(TelModuleStatusListLanguageEN_GB),
        i18nBundles: {
            de_DE: TelModuleStatusListLanguageDE_DE,
            en_GB: TelModuleStatusListLanguageEN_GB,
            en_US: TelModuleStatusListLanguageEN_US,
            fr_FR: TelModuleStatusListLanguageFR_FR,
            it_IT: TelModuleStatusListLanguageIT_IT,
            nl_NL: TelModuleStatusListLanguageNL_NL,
            pt_PT: TelModuleStatusListLanguagePT_PT
        }
    },
    TelSysConfiguration: {
        ...createLanguageEnum(TelSysConfigurationEN_GB),
        i18nBundles: {
            de_DE: TelSysConfigurationDE_DE,
            en_GB: TelSysConfigurationEN_GB,
            en_US: TelSysConfigurationEN_US,
            fr_FR: TelSysConfigurationFR_FR,
            it_IT: TelSysConfigurationIT_IT,
            nl_NL: TelSysConfigurationNL_NL,
            pt_PT: TelSysConfigurationPT_PT
        }
    },
    TelsysListLanguage: {
        ...createLanguageEnum(TelsysListLanguageEN_GB),
        i18nBundles: {
            de_DE: TelsysListLanguageDE_DE,
            en_GB: TelsysListLanguageEN_GB,
            en_US: TelsysListLanguageEN_US,
            fr_FR: TelsysListLanguageFR_FR,
            it_IT: TelsysListLanguageIT_IT,
            nl_NL: TelsysListLanguageNL_NL,
            pt_PT: TelsysListLanguagePT_PT
        }
    },
    TermsAndConditions: {
        ...createLanguageEnum(TermsAndConditionsEN_GB),
        i18nBundles: {
            de_DE: TermsAndConditionsDE_DE,
            en_GB: TermsAndConditionsEN_GB,
            en_US: TermsAndConditionsEN_US,
            fr_FR: TermsAndConditionsFR_FR,
            it_IT: TermsAndConditionsIT_IT,
            nl_NL: TermsAndConditionsNL_NL,
            pt_PT: TermsAndConditionsPT_PT
        }
    },
    TextInputDropDown: {
        ...createLanguageEnum(TextInputDropDownEN_GB),
        i18nBundles: {
            de_DE: TextInputDropDownDE_DE,
            en_GB: TextInputDropDownEN_GB,
            en_US: TextInputDropDownEN_US,
            fr_FR: TextInputDropDownFR_FR,
            it_IT: TextInputDropDownIT_IT,
            nl_NL: TextInputDropDownNL_NL,
            pt_PT: TextInputDropDownPT_PT
        }
    },
    TimeFormats: {
        ...createLanguageEnum(TimeFormatsEN_GB),
        i18nBundles: {
            de_DE: TimeFormatsDE_DE,
            en_GB: TimeFormatsEN_GB,
            en_US: TimeFormatsEN_US,
            fr_FR: TimeFormatsFR_FR,
            it_IT: TimeFormatsIT_IT,
            nl_NL: TimeFormatsNL_NL,
            pt_PT: TimeFormatsPT_PT
        }
    },
    TimeOptions: {
        ...createLanguageEnum(TimeOptionsEN_GB),
        i18nBundles: {
            de_DE: TimeOptionsDE_DE,
            en_GB: TimeOptionsEN_GB,
            en_US: TimeOptionsEN_US,
            fr_FR: TimeOptionsFR_FR,
            it_IT: TimeOptionsIT_IT,
            nl_NL: TimeOptionsNL_NL,
            pt_PT: TimeOptionsPT_PT
        }
    },
    Timezone: {
        ...createLanguageEnum(TimezoneEN_GB),
        i18nBundles: {
            de_DE: TimezoneDE_DE,
            en_GB: TimezoneEN_GB,
            en_US: TimezoneEN_US,
            fr_FR: TimezoneFR_FR,
            it_IT: TimezoneIT_IT,
            nl_NL: TimezoneNL_NL,
            pt_PT: TimezonePT_PT
        }
    },
    TimezoneModal: {
        ...createLanguageEnum(TimezoneModalEN_GB),
        i18nBundles: {
            de_DE: TimezoneModalDE_DE,
            en_GB: TimezoneModalEN_GB,
            en_US: TimezoneModalEN_US,
            fr_FR: TimezoneModalFR_FR,
            it_IT: TimezoneModalIT_IT,
            nl_NL: TimezoneModalNL_NL,
            pt_PT: TimezoneModalPT_PT
        }
    },
    UnreturnedCalls: {
        ...createLanguageEnum(UnreturnedCallsEN_GB),
        i18nBundles: {
            de_DE: UnreturnedCallsDE_DE,
            en_GB: UnreturnedCallsEN_GB,
            en_US: UnreturnedCallsEN_US,
            fr_FR: UnreturnedCallsFR_FR,
            it_IT: UnreturnedCallsIT_IT,
            nl_NL: UnreturnedCallsNL_NL,
            pt_PT: UnreturnedCallsPT_PT
        }
    },
    UnreturnedCallsFilter: {
        ...createLanguageEnum(UnreturnedCallsFilterEN_GB),
        i18nBundles: {
            de_DE: UnreturnedCallsFilterDE_DE,
            en_GB: UnreturnedCallsFilterEN_GB,
            en_US: UnreturnedCallsFilterEN_US,
            fr_FR: UnreturnedCallsFilterFR_FR,
            it_IT: UnreturnedCallsFilterIT_IT,
            nl_NL: UnreturnedCallsFilterNL_NL,
            pt_PT: UnreturnedCallsFilterPT_PT
        }
    },
    UserDetailsLanguage: {
        ...createLanguageEnum(UserDetailsLanguageEN_GB),
        i18nBundles: {
            de_DE: UserDetailsLanguageDE_DE,
            en_GB: UserDetailsLanguageEN_GB,
            en_US: UserDetailsLanguageEN_US,
            fr_FR: UserDetailsLanguageFR_FR,
            it_IT: UserDetailsLanguageIT_IT,
            nl_NL: UserDetailsLanguageNL_NL,
            pt_PT: UserDetailsLanguagePT_PT
        }
    },
    UserInvite: {
        ...createLanguageEnum(UserInviteEN_GB),
        i18nBundles: {
            de_DE: UserInviteDE_DE,
            en_GB: UserInviteEN_GB,
            en_US: UserInviteEN_US,
            fr_FR: UserInviteFR_FR,
            it_IT: UserInviteIT_IT,
            nl_NL: UserInviteNL_NL,
            pt_PT: UserInvitePT_PT
        }
    },
    UserMenu: {
        ...createLanguageEnum(UserMenuEN_GB),
        i18nBundles: {
            de_DE: UserMenuDE_DE,
            en_GB: UserMenuEN_GB,
            en_US: UserMenuEN_US,
            fr_FR: UserMenuFR_FR,
            it_IT: UserMenuIT_IT,
            nl_NL: UserMenuNL_NL,
            pt_PT: UserMenuPT_PT
        }
    },
    UserNotificationTypesHelp: {
        ...createLanguageEnum(UserNotificationTypesHelpEN_GB),
        i18nBundles: {
            de_DE: UserNotificationTypesHelpDE_DE,
            en_GB: UserNotificationTypesHelpEN_GB,
            en_US: UserNotificationTypesHelpEN_US,
            fr_FR: UserNotificationTypesHelpFR_FR,
            it_IT: UserNotificationTypesHelpIT_IT,
            nl_NL: UserNotificationTypesHelpNL_NL,
            pt_PT: UserNotificationTypesHelpPT_PT
        }
    },
    UserTour: {
        ...createLanguageEnum(UserTourEN_GB),
        i18nBundles: {
            de_DE: UserTourDE_DE,
            en_GB: UserTourEN_GB,
            en_US: UserTourEN_US,
            fr_FR: UserTourFR_FR,
            it_IT: UserTourIT_IT,
            nl_NL: UserTourNL_NL,
            pt_PT: UserTourPT_PT
        }
    },
    UsersByExtension: {
        ...createLanguageEnum(UsersByExtensionEN_GB),
        i18nBundles: {
            de_DE: UsersByExtensionDE_DE,
            en_GB: UsersByExtensionEN_GB,
            en_US: UsersByExtensionEN_US,
            fr_FR: UsersByExtensionFR_FR,
            it_IT: UsersByExtensionIT_IT,
            nl_NL: UsersByExtensionNL_NL,
            pt_PT: UsersByExtensionPT_PT
        }
    },
    UsersListLanguage: {
        ...createLanguageEnum(UsersListLanguageEN_GB),
        i18nBundles: {
            de_DE: UsersListLanguageDE_DE,
            en_GB: UsersListLanguageEN_GB,
            en_US: UsersListLanguageEN_US,
            fr_FR: UsersListLanguageFR_FR,
            it_IT: UsersListLanguageIT_IT,
            nl_NL: UsersListLanguageNL_NL,
            pt_PT: UsersListLanguagePT_PT
        }
    },
    WebexAuthLanguage: {
        ...createLanguageEnum(WebexAuthLanguageEN_GB),
        i18nBundles: {
            de_DE: WebexAuthLanguageDE_DE,
            en_GB: WebexAuthLanguageEN_GB,
            en_US: WebexAuthLanguageEN_US,
            fr_FR: WebexAuthLanguageFR_FR,
            it_IT: WebexAuthLanguageIT_IT,
            nl_NL: WebexAuthLanguageNL_NL,
            pt_PT: WebexAuthLanguagePT_PT
        }
    }
}

export const {
    ACDCodesLanguage,
    ACDDNDActivity,
    ACDStateThresholds,
    ACDStatusHotKeys,
    AbandonedCallAlarm,
    AbandonedTimeStatisticLanguage,
    AddUserLanguage,
    AdminActionsLanguage,
    AdminOverviewLanguage,
    AdministratorLanguage,
    Advanced,
    AgentAdvanced,
    AgentDetails,
    AgentListLanguage,
    AgentOmnichannel,
    AlarmActions,
    AnswerPerformance,
    ApiKeys,
    AppMenu,
    Audit,
    Authentication,
    BrandingLanguage,
    BroadworksSSO,
    CMECapabilities,
    CMEDetails,
    CRMConfigurationLanguage,
    CRMModal,
    CSVExportFormat,
    CXRecordLanguage,
    CXScoreLanguage,
    CallControlErrors,
    CallDetails,
    CallMovementFiltering,
    CallRecIntegration,
    CallRecording,
    CallStateThresholds,
    CallTargetting,
    ChangeLangLanguage,
    ChangeLayout,
    ChangeUserAgentLanguage,
    ChartProviderOptions,
    ChartStyleOptions,
    ClientConfigurationLanguage,
    ClientConfigurationModalLanguage,
    CmeListLanguage,
    CodeAddModify,
    CodeListLanguage,
    ComboBox,
    CommonAdmin,
    ConfigChangeLogListLanguage,
    ConfigureAgents,
    ConfigureReport,
    ContentRestriction,
    CookieConsent,
    Currency,
    CurrencyDisplayFormat,
    CustomSettings,
    CustomiseRole,
    CxiLicenceTypes,
    DarkMode,
    DashboardDisplaySettings,
    DashboardList,
    DashboardOptions,
    DatabaseLanguage,
    Date,
    DateTime,
    DaysOfTheWeek,
    DeviceFiltering,
    DeviceListLanguage,
    DeviceModal,
    DeviceTypesLanguage,
    DirectoryListLanguage,
    DirectoryModal,
    DisplayOptions,
    DisplaySettings,
    DisplaySwitching,
    DisplayedAsOptions,
    DocumentViewer,
    DomainProfile,
    DurationFiltering,
    ErrorLanguage,
    Estate,
    ExtensionEndpoint,
    FieldsList,
    FieldsTab,
    FileUploadLanguage,
    ForgotPasswordLanguage,
    Format,
    GenericAdminFilterLanguage,
    GenericAdminListLanguage,
    GenericFooter,
    GenericModal,
    GenericRuleLanguage,
    GenericScopeTab,
    HeaderSidebar,
    InboundStatSettings,
    InsightsDashboardLanguage,
    InsightsHub,
    LanguageBulkInsertUsers,
    LanguageBulkUploadDirectoryEntries,
    LanguageCME,
    LanguageDataTable,
    LanguageErrorCodes,
    LanguageErrors,
    LanguageFallbackNav,
    LanguageGeneral,
    LanguageLogFileDownload,
    LanguageMainMenu,
    LanguageMainNavigation,
    LanguageMyReportList,
    LanguageNewUserTutorial,
    LanguagePrompt,
    LanguageSnackbar,
    LicenceManagementPageLanguage,
    LicenseManagement,
    LicenseManagementLanguage,
    LinkInputLanguage,
    LocationalFiltering,
    LogManagementListLanguage,
    LoggingSettingsLanguage,
    MFALanguage,
    ManageCustomRoles,
    ManageQueues,
    MediaPlayer,
    MessagesLanguage,
    MicrosoftSSO,
    MiscellaneousFiltering,
    MonetaryCallAssignments,
    NotificationsLanguage,
    NotificationsLanguageModal,
    OAuthButton,
    PaginatedList,
    PartitionListLanguage,
    PartitionModal,
    PasswordChangeLanguage,
    PasswordTextInput,
    PermissionsLanguage,
    Presence,
    Preview,
    PrintOutput,
    Provisioning,
    RangeComboLanguage,
    RecordingListLanguage,
    ReportContentRowsSettingsLanguage,
    ReportIntervalLanguage,
    ReportOptions,
    ReportPortalInfo,
    ReportScheduling,
    ReportSchedulingEmails,
    ReportTypes,
    ReportingDefaultReportSets,
    ReportingLanguage,
    ReportingMenuLanguage,
    ReportsFilterDeviceFilter,
    RichTextEditor,
    RoleLanguage,
    Router,
    RowOptions,
    RulesLanguage,
    SSOLanguage,
    ScheduleStatus,
    ScopeAssignment,
    ScopeFiltering,
    SelfProvisioning,
    ServerStatusLanguage,
    ServiceLvlSettings,
    ServiceMessagesLanguage,
    SettingsLanguage,
    SidebarMenu,
    SignInWith,
    SortList,
    StaticAgentControls,
    StatisticAlarm,
    StatisticCalculations,
    StatusChange,
    TalkTime,
    TeamsAuth,
    TelModuleStatusListLanguage,
    TelSysConfiguration,
    TelsysListLanguage,
    TermsAndConditions,
    TextInputDropDown,
    TimeFormats,
    TimeOptions,
    Timezone,
    TimezoneModal,
    UnreturnedCalls,
    UnreturnedCallsFilter,
    UserDetailsLanguage,
    UserInvite,
    UserMenu,
    UserNotificationTypesHelp,
    UserTour,
    UsersByExtension,
    UsersListLanguage,
    WebexAuthLanguage
} = languageItems
